webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TotemDotsIndicator',

  props: {
    multiTotem: {
      type: Number,
      required: true,
      default: 0
    },
    explodeTotem: {
      type: Number,
      required: true,
      default: 0
    }
  },

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},
  methods: {}
});

/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"totem-dots-indicator",attrs:{"data-block-interaction":""}},[_c('div',{staticClass:"dot dot-1",class:{'selected': _vm.explodeTotem === 1},on:{"click":function($event){_vm.$emit('update:multiTotem', 0); _vm.$emit('update:explodeTotem', 1)}}},[_c('div',{staticClass:"dot-internal"})]),_vm._v(" "),_c('div',{staticClass:"dot dot-2",class:{'selected': _vm.multiTotem < 0.5 && _vm.explodeTotem === 0},on:{"click":function($event){_vm.$emit('update:multiTotem', 0); _vm.$emit('update:explodeTotem', 0)}}},[_c('div',{staticClass:"dot-internal"})]),_vm._v(" "),_c('div',{staticClass:"dot dot-3",class:{'selected': _vm.multiTotem > 0.5},on:{"click":function($event){_vm.$emit('update:multiTotem', 1); _vm.$emit('update:explodeTotem', 0)}}},[_c('div',{staticClass:"dot-internal"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HintsContainer_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6ee94a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HintsContainer_vue__ = __webpack_require__(1018);
function injectStyle (ssrContext) {
  __webpack_require__(1003)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6ee94a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HintsContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6ee94a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HintsContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_MobileDragHint__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atoms_ScrollToExploreHint__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atoms_MobileDragHintWheel__ = __webpack_require__(1014);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HintsContainer',

  components: {
    MobileDragHint: __WEBPACK_IMPORTED_MODULE_1__atoms_MobileDragHint__["a" /* default */],
    ScrollToExploreHint: __WEBPACK_IMPORTED_MODULE_2__atoms_ScrollToExploreHint__["a" /* default */],
    MobileDragHintWheel: __WEBPACK_IMPORTED_MODULE_3__atoms_MobileDragHintWheel__["a" /* default */]
  },

  props: {
    mode: {
      type: String,
      required: true
    },

    inactivityTime: {
      type: Number,
      required: true
    },

    selectedConcepts: {
      type: Array,
      required: true
    },

    selectedTotem: {
      required: true
    },

    confirmingConcept: {
      required: true
    },

    totems: {
      type: Array,
      required: true
    },

    conceptDetailsPanel: {
      require: true
    },

    multiTotem: {
      type: Number,
      required: true
    },

    explodeTotem: {
      type: Number,
      required: true
    },

    clickTarget: {
      required: true
    },

    totemReady: {
      type: Boolean,
      required: true
    },

    inactivityThreshold: {
      type: Number,
      required: false,
      default: 10
    }
  },

  data: function data() {
    return {
      Hints: __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */],
      hasOpenedDetailsPanelOnce: false,
      visitedHints: {},
      dismissedHints: {}
    };
  },

  watch: {
    conceptDetailsPanel: function conceptDetailsPanel(value) {
      if (value !== null) this.hasOpenedDetailsPanelOnce = true;
    },
    selectedTotem: function selectedTotem(value) {
      this.hasOpenedDetailsPanelOnce = false;
    }
  },

  methods: {
    onScrollUpClick: function onScrollUpClick() {
      this.$emit('scroll:up');
    },
    onScrollDownClick: function onScrollDownClick() {
      this.$emit('scroll:down');
    },


    isHintVisible: function isHintVisible(hint) {
      var dynamicInactivityThreshold = this.dismissedHints[hint] === true ? this.inactivityThreshold : 0.5;
      var isVisible = false;
      switch (hint) {
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].COMMON_SELECT_AT_LEAST_4_HOPES:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length > 0 && this.selectedConcepts.length < 4;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].COMMON_HOPEFUL_FOR_MORE:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length >= 4 && this.selectedConcepts.length < 10;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].COMMON_THATS_IT:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length === 10;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].DESKTOP_SCROLL_TO_EXPLORE_AND_SELECT_YOUR_HOPES:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length === 0 && !this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].DESKTOP_SCROLL_UP_TO_EXPLORE_THE_DATA:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && !this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].DESKTOP_SCROLL_DOWN_TO_COMPARE_TO_OTHERS:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && !this.$root.platform.mobile && this.selectedTotem === this.totems[0];
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].DESKTOP_CLICK_ON_A_PEBBLE_TO_EXPLORE_THE_DATA:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && !this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].DESKTOP_SCROLL_DOWN_TO_GO_BACK:
          var isOnOtherTotem = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && !this.$root.platform.mobile && this.selectedTotem !== this.totems[0];
          var isPanelOpen = this.mode === 'totem' && this.conceptDetailsPanel !== null;
          isVisible = (isOnOtherTotem || isPanelOpen) && !this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].DESKTOP_CLICK_AND_EXPLORE_OTHER_PEOPLES_HOPES:
          isVisible = this.mode === 'totem' && this.multiTotem === 1 && !this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_SELECT_YOUR_HOPES:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length === 0 && this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_WHEEL_ANIMATION:
          dynamicInactivityThreshold = this.dismissedHints[hint] === true ? this.inactivityThreshold : 5;
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_EXPLORE_THE_DATA_ANIMATION:
          dynamicInactivityThreshold = this.dismissedHints[hint] === true ? this.inactivityThreshold : 5;
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile && !this.hasOpenedDetailsPanelOnce && this.totemReady && this.selectedTotem === this.totems[0];
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_TAP_ON_A_PEBBLE_TO_EXPLORE_THE_DATA:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && this.$root.platform.mobile && !this.hasOpenedDetailsPanelOnce;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_SWIPE_DOWN_TO_GO_BACK_TO_YOUR_GROUPED_HOPES_ANIMATION:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && this.selectedTotem === this.totems[0] && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.inactivityTime > dynamicInactivityThreshold;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_EXPLORE_OTHER_PEOPLES_HOPES_ANIMATION:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.selectedTotem === this.totems[0];
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_SWIPE_DOWN_TO_GO_BACK_ANIMATION:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.selectedTotem !== this.totems[0] && this.inactivityTime > dynamicInactivityThreshold;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_TAKE_A_LOOK_AT_OTHER_PEOPLES_HOPES:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.conceptDetailsPanel === null && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.selectedTotem !== this.totems[0] && this.inactivityTime > dynamicInactivityThreshold;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_TAP_AND_EXPLORE_OTHER_PEOPLE_HOPES:
          isVisible = this.mode === 'totem' && this.multiTotem === 1 && this.$root.platform.mobile;
          break;
        case __WEBPACK_IMPORTED_MODULE_0__atoms_Hints__["a" /* default */].MOBILE_EXPLORE_THE_DATA_ANIMATION_RELATED:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile && !this.hasOpenedDetailsPanelOnce && this.totemReady && this.selectedTotem !== this.totems[0];
          break;
      }
      if (isVisible) this.$set(this.visitedHints, hint, true);

      if (this.visitedHints[hint] === true && !isVisible) this.$set(this.dismissedHints, hint, true);

      return isVisible;
    }
  }
});

/***/ }),

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  COMMON_SELECT_AT_LEAST_4_HOPES: 0,
  COMMON_HOPEFUL_FOR_MORE: 1,
  COMMON_THATS_IT: 2,

  // on wheel, at the beginning
  DESKTOP_SCROLL_TO_EXPLORE_AND_SELECT_YOUR_HOPES: 3,
  // on own totem, at rest
  // on related totem, at rest
  DESKTOP_SCROLL_UP_TO_EXPLORE_THE_DATA: 4,
  // on own totem, at rest
  DESKTOP_SCROLL_DOWN_TO_COMPARE_TO_OTHERS: 5,
  // on own totem, exploded
  // on related totem, exploded
  DESKTOP_CLICK_ON_A_PEBBLE_TO_EXPLORE_THE_DATA: 6,
  // on own totem, with panel open
  // on related totem, at rest
  DESKTOP_SCROLL_DOWN_TO_GO_BACK: 7,
  // on multitotem == 1
  DESKTOP_CLICK_AND_EXPLORE_OTHER_PEOPLES_HOPES: 8,

  // on wheel, at the beginning
  MOBILE_SELECT_YOUR_HOPES: 9,
  // on wheel, after x inactivity or tap on empty space
  MOBILE_WHEEL_ANIMATION: 10,
  // on own totem, at rest, after x inactivity or second tap
  MOBILE_EXPLORE_THE_DATA_ANIMATION: 11,
  // on own totem, exploded
  // on related totem, exploded
  MOBILE_TAP_ON_A_PEBBLE_TO_EXPLORE_THE_DATA: 12,
  // on own totem, exploded
  MOBILE_SWIPE_DOWN_TO_GO_BACK_TO_YOUR_GROUPED_HOPES_ANIMATION: 13,
  // on own totem, at rest, after exploded
  MOBILE_EXPLORE_OTHER_PEOPLES_HOPES_ANIMATION: 14,
  // on related totem, exploded
  MOBILE_SWIPE_DOWN_TO_GO_BACK_ANIMATION: 15,
  // on related totem, at rest, after exploded
  MOBILE_TAKE_A_LOOK_AT_OTHER_PEOPLES_HOPES: 16,
  // on multitotem == 1
  MOBILE_TAP_AND_EXPLORE_OTHER_PEOPLE_HOPES: 17,
  // on related totem, at rest, after x inactivity or second tap
  MOBILE_EXPLORE_THE_DATA_ANIMATION_RELATED: 18
});

/***/ }),

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileDragHint_vue__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddea5d4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileDragHint_vue__ = __webpack_require__(1009);
function injectStyle (ssrContext) {
  __webpack_require__(1007)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddea5d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileDragHint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddea5d4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileDragHint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_delay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DragHint',
  data: function data() {
    return {
      svgShown: true
    };
  },
  methods: {
    onAfterEnter: function onAfterEnter() {
      var _this = this;

      console.log('after enter');
      this.svgShown = false;
      __WEBPACK_IMPORTED_MODULE_0_lodash_delay___default()(function () {
        console.log('restart');
        _this.svgShown = true;
      }, 3000);
    }
  },
  props: {
    direction: {
      required: false,
      type: String,
      default: 'up'
    }
  }
});

/***/ }),

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-hint"},[_c('transition',{attrs:{"appear":"","name":"svg"},on:{"after-enter":_vm.onAfterEnter}},[(_vm.svgShown)?_c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"89.279px","height":"375.6px","viewBox":"0 0 89.279 375.6","enable-background":"new 0 0 89.279 375.6","xml:space":"preserve"}},[_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"8.647","y":"11.67","width":"70","height":"356.213"}},[_c('feColorMatrix',{attrs:{"type":"matrix","values":"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"}})],1)]),_vm._v(" "),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"8.647","y":"11.67","width":"70","height":"356.213","id":"back_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('linearGradient',{attrs:{"id":"SVGID_5_","gradientUnits":"userSpaceOnUse","x1":"-674.5176","y1":"685.834","x2":"-673.5178","y2":"685.834","gradientTransform":"matrix(0 357.2132 357.2132 0 -245376.5156 240958.0938)"}},[_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"0"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"1"}})],1),_vm._v(" "),_c('rect',{attrs:{"x":"-1107.61","y":"-278.746","fill":"url(#SVGID_5_)","width":"1440","height":"1000"}})],1)]),_vm._v(" "),_c('linearGradient',{attrs:{"id":"back_2_","gradientUnits":"userSpaceOnUse","x1":"-674.5176","y1":"687.043","x2":"-673.5181","y2":"687.043","gradientTransform":"matrix(2.187300e-014 357.213 357.213 -2.187300e-014 -245376.4844 240957.8438)"}},[_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"0"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#f9f8f7"},attrs:{"offset":"1"}})],1),_vm._v(" "),_c('path',{attrs:{"id":"back","mask":"url(#back_1_)","fill":"url(#back_2_)","d":"M8.647,332.883V46.67c0-19.33,15.669-35,35-35\n    c19.329,0,35,15.67,35,35v286.213c0,19.33-15.671,35-35,35C24.316,367.883,8.647,352.213,8.647,332.883"}}),_vm._v(" "),_c('g',{staticClass:"ring2",class:{'up': _vm.direction === 'up', 'down': _vm.direction === 'down'},attrs:{"id":"ring2","opacity":"0.4"}},[_c('g',[_c('defs',[_c('rect',{attrs:{"id":"SVGID_6_","x":"10.569","y":"13.591","width":"66.16","height":"66.158"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_7_"}},[_c('use',{attrs:{"xlink:href":"#SVGID_6_","overflow":"visible"}})]),_vm._v(" "),_c('path',{attrs:{"clip-path":"url(#SVGID_7_)","fill":"#FFFFFF","d":"M76.727,46.67c0,18.269-14.811,33.079-33.079,33.079\n        c-18.27,0-33.079-14.81-33.079-33.079s14.81-33.079,33.079-33.079C61.916,13.591,76.727,28.401,76.727,46.67"}})])]),_vm._v(" "),_c('circle',{staticClass:"ring",class:{'up': _vm.direction === 'up', 'down': _vm.direction === 'down'},attrs:{"id":"ring","fill":"none","stroke":"#FFFFFF","stroke-width":"5","stroke-miterlimit":"10","cx":"43.647","cy":"46.67","r":"33.079"}})],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollToExploreHint_vue__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69803305_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollToExploreHint_vue__ = __webpack_require__(1013);
function injectStyle (ssrContext) {
  __webpack_require__(1011)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69803305"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScrollToExploreHint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69803305_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScrollToExploreHint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1012:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScrollToExploreHint',

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},
  methods: {}
});

/***/ }),

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-to-explore-hint"},[_c('div',{staticClass:"arrow el-icon-arrow-up arrow-left-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-up arrow-left-2"}),_vm._v(" "),_c('div',{staticClass:"copy"},[_vm._v("SCROLL TO EXPLORE")]),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-down arrow-right-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-down arrow-right-2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileDragHintWheel_vue__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afd2946_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileDragHintWheel_vue__ = __webpack_require__(1017);
function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5afd2946"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileDragHintWheel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5afd2946_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileDragHintWheel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_delay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DragHint',
  data: function data() {
    return {
      svgShown: true
    };
  },
  methods: {
    onAfterEnter: function onAfterEnter() {
      var _this = this;

      console.log('after enter');
      this.svgShown = false;
      __WEBPACK_IMPORTED_MODULE_0_lodash_delay___default()(function () {
        console.log('restart');
        _this.svgShown = true;
      }, 3000);
    }
  },
  props: {
    direction: {
      required: false,
      type: String,
      default: 'left'
    }
  }
});

/***/ }),

/***/ 1017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-hint-wheel"},[_c('transition',{attrs:{"appear":"","name":"svg"},on:{"after-enter":_vm.onAfterEnter}},[(_vm.svgShown)?_c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"312.959px","height":"137.28px","viewBox":"0 0 312.959 137.28","enable-background":"new 0 0 312.959 137.28","xml:space":"preserve"}},[_c('defs',[_c('filter',{attrs:{"id":"Adobe_OpacityMaskFilter","filterUnits":"userSpaceOnUse","x":"18.544","y":"17.729","width":"275.901","height":"100.04"}},[_c('feColorMatrix',{attrs:{"type":"matrix","values":"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"}})],1)]),_vm._v(" "),_c('mask',{attrs:{"maskUnits":"userSpaceOnUse","x":"18.544","y":"17.729","width":"275.901","height":"100.04","id":"back_1_"}},[_c('g',{attrs:{"filter":"url(#Adobe_OpacityMaskFilter)"}},[_c('linearGradient',{attrs:{"id":"SVGID_5_","gradientUnits":"userSpaceOnUse","x1":"-562.4663","y1":"569.7651","x2":"-561.4663","y2":"569.7651","gradientTransform":"matrix(256.9606 12.3566 17.1576 -356.8009 134784.7031 210299.0781)"}},[_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"0"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"0.7533"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"1"}})],1),_vm._v(" "),_c('polygon',{attrs:{"fill":"url(#SVGID_5_)","points":"-578.069,-507.349 906.585,-435.956 855.287,630.823 -629.368,559.43     "}})],1)]),_vm._v(" "),_c('linearGradient',{attrs:{"id":"back_2_","gradientUnits":"userSpaceOnUse","x1":"-562.4658","y1":"569.7573","x2":"-561.4662","y2":"569.7573","gradientTransform":"matrix(256.961 12.3566 17.1576 -356.801 134785.0156 210299.0781)"}},[_c('stop',{staticStyle:{"stop-color":"#cdcdcd"},attrs:{"offset":"0"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#f9f8f7"},attrs:{"offset":"0.7533"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#f9f8f7"},attrs:{"offset":"1"}})],1),_vm._v(" "),_c('path',{attrs:{"id":"back","mask":"url(#back_1_)","fill":"url(#back_2_)","d":"M37.271,41.879c3.051-1.487,46.003-23.997,109.823-24.149\n    c37.962-0.053,83.44,8.425,129.574,34.568c16.825,9.515,22.752,30.87,13.236,47.695s-30.87,22.752-47.695,13.236\n    c-34.746-19.598-67.19-25.445-95.115-25.499c-23.348-0.011-43.379,4.293-57.26,8.54c-6.936,2.117-12.321,4.208-15.779,5.674\n    c-1.729,0.732-2.977,1.309-3.696,1.65c-0.359,0.172-0.587,0.285-0.677,0.33L65.7,95.983l4.131,7.862l-0.15,0.079L65.7,95.983\n    l4.131,7.862c-17.111,8.991-38.272,2.409-47.264-14.702C13.577,72.032,20.159,50.871,37.271,41.879z"}}),_vm._v(" "),_c('g',{staticClass:"ring2-outside",class:{'right': _vm.direction === 'right', 'left': _vm.direction === 'left'},attrs:{"id":"ring2","opacity":"0.4"}},[_c('g',{staticClass:"ring2-inside",class:{'right': _vm.direction === 'right', 'left': _vm.direction === 'left'}},[_c('defs',[_c('rect',{attrs:{"id":"SVGID_6_","x":"20.464","y":"39.93","width":"66.16","height":"66.16"}})]),_vm._v(" "),_c('clipPath',{attrs:{"id":"SVGID_7_"}},[_c('use',{attrs:{"xlink:href":"#SVGID_6_","overflow":"visible"}})]),_vm._v(" "),_c('path',{attrs:{"clip-path":"url(#SVGID_7_)","fill":"#FFFFFF","d":"M86.584,74.598c-0.877,18.248-16.382,32.33-34.63,31.452\n        c-18.248-0.877-32.329-16.382-31.452-34.63c0.878-18.248,16.382-32.33,34.63-31.452C73.38,40.845,87.462,56.351,86.584,74.598"}})])]),_vm._v(" "),_c('g',{staticClass:"ring-outside",class:{'right': _vm.direction === 'right', 'left': _vm.direction === 'left'}},[_c('circle',{staticClass:"ring-inside",class:{'right': _vm.direction === 'right', 'left': _vm.direction === 'left'},attrs:{"id":"ring","fill":"none","stroke":"#FFFFFF","stroke-width":"5","stroke-miterlimit":"10","cx":"53.543","cy":"73.009","r":"33.079"}})])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hints-container",class:{'left': _vm.conceptDetailsPanel !== null}},[_c('transition',[(_vm.isHintVisible(_vm.Hints.COMMON_SELECT_AT_LEAST_4_HOPES))?_c('div',{staticClass:"basic-hint simple-hint"},[_vm._v("Select at least 4 hopes")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.COMMON_HOPEFUL_FOR_MORE))?_c('div',{staticClass:"simple-hint lifted more-conferm"},[_vm._v("Hopeful for more?")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.COMMON_THATS_IT))?_c('div',{staticClass:"simple-hint lifted thats-it"},[_vm._v("That’s it!")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.DESKTOP_SCROLL_TO_EXPLORE_AND_SELECT_YOUR_HOPES))?_c('div',{staticClass:"simple-hint arrow-container"},[_c('div',{staticClass:"arrow el-icon-arrow-up arrow-left-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-up arrow-left-2"}),_vm._v(" "),_c('div',{staticClass:"copy"},[_vm._v("Scroll to explore"),_c('br'),_vm._v("and select your Hopes")]),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-down arrow-right-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-down arrow-right-2"})]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.DESKTOP_SCROLL_UP_TO_EXPLORE_THE_DATA))?_c('div',{staticClass:"simple-hint multiple-scroll-to-explore-hint position-left arrow-container",on:{"click":_vm.onScrollDownClick}},[_c('div',{staticClass:"arrow el-icon-arrow-up arrow-left-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-up arrow-left-2"}),_vm._v(" "),_c('div',{staticClass:"copy"},[_vm._v("Scroll up"),_c('br'),_vm._v("to explore the data")])]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.DESKTOP_SCROLL_DOWN_TO_COMPARE_TO_OTHERS))?_c('div',{staticClass:"simple-hint multiple-scroll-to-explore-hint position-right arrow-container",on:{"click":_vm.onScrollUpClick}},[_c('div',{staticClass:"arrow el-icon-arrow-down arrow-left-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-down arrow-left-2"}),_vm._v(" "),_c('div',{staticClass:"copy"},[_vm._v("Scroll down"),_c('br'),_vm._v("to compare to others")])]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.DESKTOP_CLICK_ON_A_PEBBLE_TO_EXPLORE_THE_DATA))?_c('div',{staticClass:"simple-hint"},[_vm._v("Click on a pebble to explore the data")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.DESKTOP_SCROLL_DOWN_TO_GO_BACK))?_c('div',{staticClass:"simple-hint arrow-container",class:{'multiple-scroll-to-explore-hint': _vm.conceptDetailsPanel === null, 'position-right': _vm.conceptDetailsPanel === null},on:{"click":_vm.onScrollUpClick}},[_c('div',{staticClass:"arrow el-icon-arrow-down arrow-left-1"}),_vm._v(" "),_c('div',{staticClass:"arrow el-icon-arrow-down arrow-left-2"}),_vm._v(" "),_c('div',{staticClass:"copy"},[_vm._v("Scroll down"),_c('br'),_vm._v("to go back")])]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.DESKTOP_CLICK_AND_EXPLORE_OTHER_PEOPLES_HOPES))?_c('div',{staticClass:"simple-hint"},[_vm._v("Click and explore other people’s Hopes")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_SELECT_YOUR_HOPES))?_c('div',{staticClass:"simple-hint"},[_vm._v("Select your hopes")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_WHEEL_ANIMATION))?_c('MobileDragHintWheel'):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_EXPLORE_THE_DATA_ANIMATION))?_c('div',{staticClass:"mobile-animation"},[_c('MobileDragHint'),_vm._v(" "),_c('span',[_vm._v("Explore the data")])],1):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_TAP_ON_A_PEBBLE_TO_EXPLORE_THE_DATA))?_c('div',{staticClass:"simple-hint"},[_vm._v("Tap on a pebble to explore the data")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_SWIPE_DOWN_TO_GO_BACK_TO_YOUR_GROUPED_HOPES_ANIMATION))?_c('div',{staticClass:"mobile-animation"},[_c('MobileDragHint',{attrs:{"direction":"down"}}),_vm._v(" "),_c('span',[_vm._v("Swipe down to go back to your grouped Hopes")])],1):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_EXPLORE_OTHER_PEOPLES_HOPES_ANIMATION))?_c('div',{staticClass:"mobile-animation"},[_c('MobileDragHint',{attrs:{"direction":"down"}}),_vm._v(" "),_c('span',[_vm._v("Explore other people’s Hopes!")])],1):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_SWIPE_DOWN_TO_GO_BACK_ANIMATION))?_c('div',{staticClass:"mobile-animation"},[_c('MobileDragHint',{attrs:{"direction":"down"}}),_vm._v(" "),_c('span',[_vm._v("Swipe down to go back")])],1):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_TAKE_A_LOOK_AT_OTHER_PEOPLES_HOPES))?_c('div',{staticClass:"mobile-animation"},[_c('MobileDragHint',{attrs:{"direction":"down"}}),_vm._v(" "),_c('span',[_vm._v("Take a look at other people’s Hopes!")])],1):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_TAP_AND_EXPLORE_OTHER_PEOPLE_HOPES))?_c('div',{staticClass:"simple-hint"},[_vm._v("Tap and explore other people’s Hopes")]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.isHintVisible(_vm.Hints.MOBILE_EXPLORE_THE_DATA_ANIMATION_RELATED))?_c('div',{staticClass:"mobile-animation"},[_c('MobileDragHint'),_vm._v(" "),_c('span',[_vm._v("Explore the data")])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1019:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroPageAR_vue__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d2ffdad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroPageAR_vue__ = __webpack_require__(1022);
function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d2ffdad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroPageAR_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d2ffdad_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroPageAR_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_packages_button__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntroPageAR',

  components: {
    ElButton: __WEBPACK_IMPORTED_MODULE_0_element_ui_packages_button__["a" /* default */]
  },

  methods: {
    onDownloadClick: function onDownloadClick() {
      this.$emit('download:click');
    }
  }
});

/***/ }),

/***/ 1022:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-page-ar"},[_c('div',{staticClass:"content"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('a',{attrs:{"href":"/static/img/marker.png","target":"_blank"},on:{"click":_vm.onDownloadClick}},[_c('el-button',{staticClass:"download-btn"},[_vm._v("Download")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Before you"),_c('br'),_vm._v("start...")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Download the marker"),_c('br'),_vm._v("and print it out")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Place it where you want your"),_c('br'),_vm._v("Hope-Sculpture to appear!")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.platform.prerenderer && _vm.isReady),expression:"!platform.prerenderer && isReady"}],staticClass:"google-hope-app",attrs:{"id":"app","version":_vm.version,"commit-hash":_vm.commitHash,"deploy-flag":_vm.deployFlag,"target-domain":_vm.targetDomain}},[_c('transition',[(_vm.currentMode !== 'intro')?_c('div',{staticClass:"header",class:{'in-totem': _vm.currentMode === 'totem' && !_vm.openAbout || _vm.currentMode === 'ar', 'page-about': _vm.openAbout}},[_c('span',{staticClass:"logo",attrs:{"data-block-interaction":""}},[_vm._v("BUILDING HOPES")]),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in"}},[(_vm.backend.shareAvailable && _vm.shareOpenAlpha === 0 || (_vm.finalModelShow))?_c('span',{staticClass:"share-desktop hover-link",attrs:{"data-block-interaction":""},on:{"click":_vm.onShareClick}},[_vm._v("SHARE")]):_vm._e(),_vm._v(" "),(_vm.backend.shareAvailable && _vm.shareOpenAlpha > 0 && !_vm.finalModelShow)?_c('span',{staticClass:"share-desktop hover-link",attrs:{"data-block-interaction":""},on:{"click":_vm.onShareClose}},[_vm._v("BACK")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in"}},[(!_vm.openAbout)?_c('span',{staticClass:"about hover-link",attrs:{"data-block-interaction":""},on:{"click":_vm.onAboutClick}},[_vm._v("ABOUT")]):_c('span',{staticClass:"about hover-link",attrs:{"data-block-interaction":""},on:{"click":_vm.onAboutClose}},[_vm._v("BACK")])]),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in"}},[(!_vm.openAbout)?_c('span',{staticClass:"about-mobile",attrs:{"data-block-interaction":""},on:{"click":_vm.onAboutClick}},[_vm._v("i")]):_c('span',{staticClass:"about-mobile",attrs:{"data-block-interaction":""},on:{"click":_vm.onAboutClose}},[_vm._v("✕")])]),_vm._v(" "),_c('transition',[(_vm.openAbout)?_c('span',{staticClass:"about-label"},[_vm._v("ABOUT")]):_vm._e()])],1):_vm._e()]),_vm._v(" "),_c('transition',[((_vm.currentMode !== 'intro' && _vm.currentMode !== 'ar') && !_vm.totemReady)?_c('HeaderStonesContainer',{staticClass:"stones-container",attrs:{"concepts":_vm.selectedConcepts}}):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'totem' || _vm.currentMode === 'wheel' || _vm.currentMode === 'save')?_c('TotemCanvas',{staticClass:"totem-canvas",class:{'totem-visualization': _vm.currentMode === 'totem'},style:(_vm.canvasStyle),attrs:{"mode":_vm.currentMode,"totems":_vm.totems,"blockedResize":_vm.blockedResize,"wheelConcepts":_vm.confirmedConcepts,"selectedConcepts":_vm.selectedConcepts,"currentTotem":_vm.currentlySelectedTotem,"multiTotem":_vm.canvasMultiTotem,"explodeTotem":_vm.canvasExplodeTotem,"tooltips":_vm.tooltips,"detailsPanelConcept":_vm.clickedConcept,"inactivityTime":_vm.inactivityTime,"shareOpenAlpha":_vm.shareOpenAlpha,"wheelBlock":_vm.elasticShareOpenAlpha.value > 0.5},on:{"update:currentTotem":function($event){_vm.currentlySelectedTotem=$event},"update:multiTotem":function($event){_vm.canvasMultiTotem=$event},"update:explodeTotem":function($event){_vm.canvasExplodeTotem=$event},"update:tooltips":function($event){_vm.tooltips=$event},"update:detailsPanelConcept":function($event){_vm.clickedConcept=$event},"update:inactivityTime":function($event){_vm.inactivityTime=$event},"update:shareOpenAlpha":function($event){_vm.shareOpenAlpha=$event},"concept:click":_vm.onConceptClick,"finalmodal:show":_vm.onFinalModelShow,"totemReady":function($event){_vm.totemReady = true}}}):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'totem' && _vm.totemReady && _vm.shareOpenAlpha < 0.5)?_c('TotemDotsIndicator',{staticClass:"totem-dots",attrs:{"multiTotem":_vm.canvasMultiTotem,"explodeTotem":_vm.canvasExplodeTotem},on:{"update:multiTotem":function($event){_vm.canvasMultiTotem=$event},"update:explodeTotem":function($event){_vm.canvasExplodeTotem=$event}}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"wheel"}},[(_vm.currentMode === 'wheel')?_c('CanvasConceptsSelectionWheel',{staticClass:"selection-wheel",attrs:{"concepts":_vm.concepts,"forMore":!_vm.confirmingConcept && _vm.currentMode === 'wheel' && _vm.selectedConcepts.length >= 4 && _vm.selectedConcepts.length < 10,"selected":_vm.selectedConcepts,"positions":_vm.wheelPositions,"inactivityTime":_vm.inactivityTime,"preventBlurOnDesktop":true},on:{"update:selected":function($event){_vm.selectedConcepts=$event},"update:positions":function($event){_vm.wheelPositions=$event},"update:inactivityTime":function($event){_vm.inactivityTime=$event}}}):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'ar' && !_vm.markerInstructionsShown)?_c('TotemCanvasAR',{attrs:{"totemData":_vm.currentlySelectedTotem}}):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'ar' && !_vm.arIntro)?_c('IntroPageAR',{on:{"download:click":_vm.onDownloadClick}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":(!_vm.confirmingConcept && _vm.currentMode === 'wheel' && _vm.selectedConcepts.length >= 4 && _vm.selectedConcepts.length < 10) ? 'concept-complete' : ''}},[(_vm.confirmingConcept)?_c('ConceptImportanceUI',{attrs:{"confirmingConcept":_vm.confirmingConcept},on:{"confirm":function($event){_vm.confirmConcept(_vm.confirmingConcept)},"cancel":function($event){_vm.removeConcept(_vm.confirmingConcept)}}}):_vm._e()],1),_vm._v(" "),(_vm.currentMode === 'wheel' && _vm.confirmedConcepts.length > 3 && !_vm.confirmingConcept)?_c('div',{staticClass:"wheel-done-bg"}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"wheel-done"}},[(_vm.currentMode === 'wheel' && _vm.confirmedConcepts.length > 3 && !_vm.confirmingConcept)?_c('el-button',{staticClass:"wheel-done-btn",on:{"click":_vm.gotoSaveTotemForm}},[_vm._v("\n      DONE\n    ")]):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'totem' && _vm.$root.platform.mobile && _vm.webRTCSupported && _vm.shareOpenAlpha < 0.5)?_c('el-button',{staticClass:"ar-view-btn",on:{"click":_vm.switchAR}},[_vm._v("AR VIEW")]):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'totem' && _vm.$root.platform.mobile && _vm.shareOpenAlpha < 0.5)?_c('el-button',{staticClass:"info-btn",on:{"click":_vm.onAboutClick}},[_vm._v("i")]):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.currentMode === 'ar' && !_vm.markerInstructionsShown)?_c('div',{staticClass:"ar-close-btn",on:{"click":_vm.switchAR}},[_c('i',{staticClass:"el-icon-close"})]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.currentMode === 'ar' && !_vm.markerInstructionsShown)?_c('a',{staticClass:"ar-download-marker-btn",attrs:{"href":"/static/img/marker.png","target":"_blank"}},[_vm._v("Download marker")]):_vm._e()]),_vm._v(" "),_c('transition',[_c('HintsContainer',{directives:[{name:"show",rawName:"v-show",value:(_vm.shareOpenAlpha < 0.5),expression:"shareOpenAlpha < 0.5"}],attrs:{"mode":_vm.currentMode,"inactivityTime":_vm.inactivityTime,"selectedConcepts":_vm.selectedConcepts,"selectedTotem":_vm.currentlySelectedTotem,"confirmingConcept":_vm.confirmingConcept,"totems":_vm.totems,"conceptDetailsPanel":_vm.clickedConcept,"multiTotem":_vm.canvasMultiTotem,"explodeTotem":_vm.canvasExplodeTotem,"clickTarget":null,"totemReady":_vm.totemReady},on:{"scroll:up":_vm.onScrollUp,"scroll:down":_vm.onScrollDown}})],1),_vm._v(" "),_c('transition-group',_vm._l((_vm.tooltips),function(tooltip,index){return (_vm.currentMode === 'totem' && _vm.shareOpenAlpha < 0.5)?_c('div',{key:tooltip.label,staticClass:"tooltip",style:(_vm.tooltipStyle(tooltip))},[_c('div',{staticClass:"tooltip-internal"},[_vm._v(_vm._s(_vm.getTootipLabel(tooltip.label)))])]):_vm._e()})),_vm._v(" "),_c('transition',[(_vm.currentMode === 'ar' && _vm.markerInstructionsShown)?_c('ARMarkerInstructions',{attrs:{"shown":_vm.markerInstructionsShown},on:{"update:shown":function($event){_vm.markerInstructionsShown=$event},"cancel":function($event){_vm.currentMode = 'totem'}}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"details-panel","mode":"out-in"}},[_c('keep-alive',[(_vm.clickedConcept)?_c('ConceptDetailsPanel',{attrs:{"concept":_vm.clickedConcept},on:{"about:click":_vm.onAboutClick,"concept:next":_vm.onConceptNext,"concept:prev":_vm.onConceptPrev,"update:concept":function($event){_vm.clickedConcept=$event}}}):_vm._e()],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"intro"}},[(_vm.currentMode === 'intro' && _vm.isReady)?_c('IntroScreen',{staticClass:"intro-screen",attrs:{"mode":_vm.currentMode},on:{"update:mode":function($event){_vm.currentMode=$event}}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"intro-text"}},[(_vm.introTextVisible)?_c('div',{staticClass:"intro-text"},[_c('span',[_vm._v("WHAT ARE YOU HOPEFUL FOR?")])]):_vm._e()]),_vm._v(" "),_c('transition',[(_vm.currentMode === 'save')?_c('TotemSaveForm',{attrs:{"mode":_vm.currentMode,"concepts":_vm.selectedConcepts},on:{"input:focus":_vm.onFocus,"input:blur":_vm.onBlur,"totem:save":_vm.onTotemSave,"update:mode":function($event){_vm.currentMode=$event}}}):_vm._e()],1),_vm._v(" "),_c('transition',[(_vm.openAbout)?_c('AboutPage'):_vm._e()],1),_vm._v(" "),(_vm.elasticShareOpenAlpha.value > 0 && !_vm.finalModelShow)?_c('SharePanel',{style:(_vm.sharePanelStyle),attrs:{"totemData":_vm.totemData,"openAlpha":_vm.shareOpenAlpha},on:{"update:openAlpha":function($event){_vm.shareOpenAlpha=$event}}}):_vm._e(),_vm._v(" "),(_vm.elasticShareOpenAlpha.value > 0 && _vm.finalModelShow)?_c('FinalSharePanel',{style:(_vm.sharePanelStyle),attrs:{"totemData":_vm.totemData,"openAlpha":_vm.shareOpenAlpha},on:{"update:openAlpha":function($event){_vm.shareOpenAlpha=$event},"share:open":_vm.onShareClick,"panel:close":_vm.onFinalModelClose}}):_vm._e(),_vm._v(" "),(!_vm.deployFlag)?_c('VersionInfo',{attrs:{"version":_vm.version,"commit-hash":_vm.commitHash}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_singlelanguage__ = __webpack_require__(1026);



// IMPORTANT: Use only one of the options below
// also please delete the file you don't use in the project

// use this if you don't want /en/route notation


// use this if you prefer /en/route notation
// and automatic user language detection
// import routes from '../routes-multilanguage'

// docs: https://router.vuejs.org/en/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes_singlelanguage__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),

/***/ 1026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// only pages should be imported and used here
// http://bradfrost.com/blog/post/atomic-web-design/

var routes = [{
  path: '/',
  name: 'Home'
}, {
  path: '*',
  redirect: '/'
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gettext__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gettext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_gettext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_availableLanguages_json__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_availableLanguages_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_availableLanguages_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_locale_it_translation_json__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_locale_it_translation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_locale_it_translation_json__);






// only one translation, add another one if you have another


// usage: https://github.com/Polyconseil/vue-gettext
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_gettext___default.a, {
  translations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__assets_data_locale_it_translation_json___default.a),
  // use this line to join locales together
  // translations: Object.assign({}, it, zh, es, etc),
  availableLanguages: __WEBPACK_IMPORTED_MODULE_3__assets_data_availableLanguages_json___default.a,
  defaultLanguage: 'en',
  silent: true
});

/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

module.exports = {"en":"English","it":"Italiano"}

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

module.exports = {"it":{"Language:":"Lingua:","Platform Information":"Informazioni Piattaforma","These are some Spritesheet Icons":"Queste sono icone Spritesheet","This is an inline SVG Icon":"Questa è una SVG Inline","Welcome to the MONOGRID Vue.js Boilerplate":"Benvenuto nel MONOGRID Vue.js Boilerplate","MONOGRID":"MONOGRID","A Vue.js Boilerplate buit and mantained by MONOGRID":"Un boilerplate Vue.js sviluppato e mantenuto da MONOGRID","Built with ♥ by [MONOGRID](http://www.mono-grid.com)":"Con ♥ da [MONOGRID](http://www.mono-grid.com)","Please feel free to\n\n- ~~stress [Daniele](mailto:daniele@mono-grid.com)~~\n- **explore our [Example Service](Service) page**\n- [Switch Language](Home \"language: 'it'\") to Italian":"Sentiti libero di \n\n- ~~stressare [Daniele](mailto:daniele@mono-grid.com)~~ \n- **navigare nella [Pagina di esempio](Service) per Servizi**\n- [Cambiare la lingua](Home \"language: 'en'\") in Inglese","Home Page":"Home Page","Service Page":"Pagina Servizio"}}

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ElasticNumber__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ElasticVector3__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animejs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_three_SubdivisionModifier__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_three_SubdivisionModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_three_SubdivisionModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_three_SimplifyModifier__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_three_SimplifyModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_three_SimplifyModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_random_seed__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_random_seed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_random_seed__);





/* global THREE */







var HopeConceptStone = function (_THREE$Mesh) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HopeConceptStone, _THREE$Mesh);

  //
  function HopeConceptStone(config, material) {
    var isCategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var bufferGeometry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HopeConceptStone);

    // build random seed
    var seed = config.id + ' ' + config.color + ' ' + config.label;
    if (config.concepts) {
      config.concepts.forEach(function (concept) {
        seed += concept.id;
      });
    }
    var randomGenerator = __WEBPACK_IMPORTED_MODULE_10_random_seed___default.a.create();
    randomGenerator.seed(seed);

    var vTotal = new THREE.Vector3();
    var vNumber = 0;
    // let debug = false
    var geometry = new THREE.IcosahedronGeometry(1, 0);
    var categoryRotateZ = void 0;
    if (!isCategory) {
      geometry.rotateX(randomGenerator.floatBetween(0, Math.PI));
      geometry.rotateY(randomGenerator.floatBetween(0, Math.PI));
      geometry.rotateZ(randomGenerator.floatBetween(0, Math.PI));
    } else {
      categoryRotateZ = randomGenerator.floatBetween(0, Math.PI / 3);
      categoryRotateZ *= randomGenerator.random() > 0.5 ? 1 : -1;
      geometry.scale(1 + config.concepts.length / 5, 1, 1);
      geometry.rotateZ(categoryRotateZ);
    }

    geometry.vertices.forEach(function (vertex) {
      if (!isCategory) {
        vertex.multiplyScalar(randomGenerator.floatBetween(0.3, 1));
      } else {
        vertex.multiplyScalar(randomGenerator.floatBetween(0.4, 1));
      }
      vTotal.add(vertex);
      vNumber++;
    });

    vTotal.divideScalar(vNumber);
    geometry.translate(-vTotal.x, -vTotal.y, -vTotal.z);

    var sub = new THREE.SubdivisionModifier(2);
    sub.modify(geometry);

    var simpl = new THREE.SimplifyModifier();
    var collisionGeometry = simpl.modify(geometry, 50);
    // let collisionGeometry = geometry.clone() // simpl.modify(geometry, 50)
    collisionGeometry.computeVertexNormals();
    collisionGeometry.computeFaceNormals();
    collisionGeometry.computeBoundingSphere();

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HopeConceptStone.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HopeConceptStone)).call(this, bufferGeometry ? new THREE.BufferGeometry().fromGeometry(geometry) : geometry, material));

    _this.categoryRotateZ = categoryRotateZ;
    // let sc = 0.3 + (config.concepts.length / 4)
    _this.scale.set(0.001, 0.001, 0.001);
    _this.elasticPosition = new __WEBPACK_IMPORTED_MODULE_6__utils_ElasticVector3__["a" /* default */](_this.position);
    _this.elasticPosition.speed = 20;
    _this.com = vTotal;
    // this.castShadow = true
    _this.collisionGeometry = collisionGeometry;
    _this.collisionMesh = new THREE.Mesh(new THREE.BufferGeometry().fromGeometry(_this.collisionGeometry), new THREE.MeshBasicMaterial({
      color: 0x000000,
      wireframe: true,
      side: THREE.DoubleSide
    }));
    _this.add(_this.collisionMesh);

    _this.rayCaster = new THREE.Raycaster();
    _this.collisionArrowLength = 0.5;

    _this.redcolor = new THREE.Color(0xff0000);
    _this.greenColor = new THREE.Color(0x00ff00);
    _this.collisionOrigin = new THREE.Vector3();
    _this.collisionDirection = new THREE.Vector3();
    _this.collisionLOD = [];
    // LOD 0: single ray
    _this.collisionLOD[0] = [{
      ray: new THREE.Ray(new THREE.Vector3(), new THREE.Vector3(0, -1, 0)), // vertical
      arrow: new THREE.ArrowHelper(new THREE.Vector3(0, -1, 0), new THREE.Vector3(), _this.collisionArrowLength, 0x00ff00),
      r: 0
    }];
    // this.collisionLOD[1] = this.createRadialCollisionRaysFromCenter(2, 0.2, 0.3, 3)
    // this.collisionLOD[2] = this.createParallelCollisionRaysForLowerVertices(10)

    _this.verticalAcceleration = 0;
    _this.oscillationSize = THREE.Math.randFloat(0.2, 0.5);
    _this.oscillationSpeed = THREE.Math.randFloatSpread(0.05);
    _this.elasticOscillationSpeed = new __WEBPACK_IMPORTED_MODULE_5__utils_ElasticNumber__["a" /* default */](0);
    _this.oscillationTick = 0;
    _this.rotationRate = 0;
    _this.elasticRotationRate = new __WEBPACK_IMPORTED_MODULE_5__utils_ElasticNumber__["a" /* default */](0);

    _this.__visible = false;
    _this.spacing = 0;
    _this.rayScanTick = 0;
    _this.rayScanSpeed = 0.4;
    _this.debug = false;
    _this.rotate = true;
    _this.oscillate = false;
    _this.activeCollisionLOD = 0;
    // this.rotationDirection = (Math.round(Math.random()) * 2 - 1) // random 1 or -1
    _this.config = config;
    randomGenerator.done();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HopeConceptStone, [{
    key: 'setVisible',
    value: function setVisible() {
      var _this2 = this;

      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var instantaneous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      //
      if (value && !this.__visible) {
        this.visible = true;
        this.setScale(true);
      }

      if (!value && this.__visible) {
        this.cancelScaleAnimation();
        this.scaleAnimation = __WEBPACK_IMPORTED_MODULE_7_animejs___default()({
          targets: this.scale,
          x: 0.001,
          y: 0.001,
          z: 0.001,
          easing: 'easeOutElastic',
          complete: function complete(anim) {
            _this2.visible = false;
            _this2.scaleAnimation = null;
          }
        });
      }
      this.__visible = value;
    }
  }, {
    key: 'setScale',
    value: function setScale() {
      var fromZero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.cancelScaleAnimation();
      var sc = 0.3;
      if (this._config.concepts) {
        // this is a "category" stone
        sc = 0.3 + this._config.concepts.length / 10;
      } else {
        // this is a concept stone
        sc += 0.2 * this._config.importance;
      }
      if (fromZero) {
        this.scale.set(0.001, 0.001, 0.001);
      }

      if (animate) {
        this.animateScale(sc);
      } else {
        this.scale.set(sc, sc, sc);
      }
    }

    // getCategoryScale (multiplier) {
    //   // rotate the multiplier
    //   // let v = new THREE.Vector3(multiplier, 0, 0)
    //   // v.applyAxisAngle(new THREE.Vector3(0, 0, 1), this.categoryRotateZ)

    //   let m = new THREE.Matrix4()
    //   m.makeRotationX(this.categoryRotateZ)

    //   let m2 = new THREE.Matrix4()
    //   m2.makeScale(0.3 + multiplier, 0.3, 0.3)

    //   m.premultiply(m2)

    //   // m.makeShear(v.x, v.y, 0)
    //   // m.scale(new THREE.Vector3(0.3, 0.3, 0.3))
    //   let scale = new THREE.Vector3()
    //   let quaternion = new THREE.Quaternion()
    //   m.decompose(new THREE.Vector3(), quaternion, scale)

    //   scale.applyQuaternion(quaternion)
    //   // let scX = 0.3 + 0.8 * Math.abs(scale.x)
    //   // let scY = 0.3 + 0.8 * Math.abs(scale.y)
    //   let scX = Math.abs(scale.x)
    //   let scY = Math.abs(scale.y)
    //   return {scX, scY}
    // }

  }, {
    key: 'cancelScaleAnimation',
    value: function cancelScaleAnimation() {
      if (this.scaleAnimation) {
        this.scaleAnimation.pause();
        __WEBPACK_IMPORTED_MODULE_7_animejs___default.a.remove(this.scale);
      }
    }
  }, {
    key: 'animateScale',
    value: function animateScale(sc) {
      var _this3 = this;

      this.scaleAnimation = __WEBPACK_IMPORTED_MODULE_7_animejs___default()({
        targets: this.scale,
        x: sc,
        y: sc,
        z: sc,
        easing: 'easeOutElastic',
        complete: function complete(anim) {
          _this3.scaleAnimation = null;
        }
      });
    }
  }, {
    key: 'update',
    value: function update(parent, delta) {
      var skipPhysics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // check if we need to update physics
      if (!skipPhysics) {
        // check if we have a parent
        if (parent) {
          // this.rayScan()
          var compenetration = this.singleCollisionTest(parent);
          if (compenetration <= 0) {
            this.elasticPosition.y -= this.verticalAcceleration;
            this.verticalAcceleration += 0.0004;
          } else {
            this.verticalAcceleration = 0;
            // this.elasticPosition.y = this.elasticPosition.value.y = this.elasticPosition.value.y + compenetration
            this.elasticPosition.y = this.elasticPosition.value.y + compenetration;
          }
          // falling stones fix
          if (this.elasticPosition.y <= parent.position.y + 0.1) {
            if (parent.collisionMesh) {
              // we are colliding with another stone
              this.verticalAcceleration = -0.02;
              this.elasticPosition.y = parent.position.y + 0.2;
            } else {
              // we are colliding with ground
              // for some reason if we don't do this
              // stones will keep bouncing off the ground
              this.verticalAcceleration = -0.01;
              this.elasticPosition.y = parent.position.y;
            }
          }
        } else if (parent === null || parent === undefined) {
          // no parent = bottom stone
          if (!this.groundCheck()) {
            // fall to ground
            this.elasticPosition.y -= this.verticalAcceleration;
            this.verticalAcceleration += 0.0004;
          } else {
            // stay still
            this.verticalAcceleration = 0;
            this.elasticPosition.y = 0;
          }
        }
      }

      this.elasticRotationRate.update(delta);
      this.rotation.y += this.elasticRotationRate.value;

      this.elasticOscillationSpeed.update(delta);
      this.oscillationTick += this.elasticOscillationSpeed.value;
      this.rotation.z = Math.sin(this.oscillationTick) * this.oscillationSize;

      this.elasticPosition.update(delta);
    }
  }, {
    key: 'groundCheck',
    value: function groundCheck() {
      return this.position.y <= 0;
    }
  }, {
    key: 'rayScan',
    value: function rayScan() {
      // this.rayScanTick += this.rayScanSpeed
      var axis = new THREE.Vector3(0, -1, 0);

      for (var i = 0; i < this.collisionRays.length; i++) {
        var object = this.collisionRays[i];
        object.ray.direction.applyAxisAngle(axis, THREE.Math.randFloat(0.1, 2));
        // object.ray.direction.applyAxisAngle(axis, this.rayScanSpeed)
        object.arrow.setDirection(object.ray.direction);
      }
    }
  }, {
    key: 'precomputeCollisionRaysOwnIntersection',
    value: function precomputeCollisionRaysOwnIntersection() {
      var _this4 = this;

      this.updateMatrixWorld(true);
      this.collisionMesh.updateMatrixWorld(true);

      this.collisionRays.forEach(function (object) {
        _this4.collisionOrigin.copy(object.ray.origin);
        _this4.collisionOrigin.applyMatrix4(_this4.matrixWorld);
        _this4.collisionDirection.copy(object.ray.direction);
        _this4.collisionDirection.transformDirection(_this4.matrixWorld);
        _this4.rayCaster.set(_this4.collisionOrigin, _this4.collisionDirection);
        var selfIntersections = [];
        _this4.collisionMesh.material.side = THREE.BackSide; // test backside of self
        _this4.collisionMesh.raycast(_this4.rayCaster, selfIntersections);

        if (selfIntersections.length > 0) {
          object.selfIntersection = -_this4.collisionMesh.worldToLocal(selfIntersections[0].point).y;
        }
      });

      this.collisionRays.sort(function (a, b) {
        return a.selfIntersection > b.selfIntersection ? -1 : 1;
      });
    }
    // palallel collision rays for each

  }, {
    key: 'createParallelCollisionRaysForLowerVertices',
    value: function createParallelCollisionRaysForLowerVertices() {
      var _this5 = this;

      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

      var ret = [];
      var vert = this.collisionGeometry.vertices.concat();
      vert.sort(function (a, b) {
        return a.y < b.y ? -1 : 1;
      });
      // select lower vertices
      vert = vert.slice(0, num);
      vert.forEach(function (v) {
        var v2 = v.clone();
        v2.y = 0;
        ret.push({
          ray: new THREE.Ray(v2, new THREE.Vector3(0, -1, 0).normalize()),
          arrow: new THREE.ArrowHelper(new THREE.Vector3(0, -1, 0).normalize(), v2, _this5.collisionArrowLength, 0x00ff00),
          r: 0
        });
      });
      return ret;
    }
  }, {
    key: 'createRadialCollisionRaysForLowerVertices',
    value: function createRadialCollisionRaysForLowerVertices() {
      var _this6 = this;

      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

      var ret = [];
      var vert = this.collisionGeometry.vertices.concat();
      vert.sort(function (a, b) {
        return a.y < b.y ? -1 : 1;
      });
      // select lower vertices
      vert = vert.slice(0, num);
      vert.forEach(function (v) {
        var v2 = v.clone();
        v2.normalize();
        ret.push({
          ray: new THREE.Ray(new THREE.Vector3(), v2),
          arrow: new THREE.ArrowHelper(v2, new THREE.Vector3(), _this6.collisionArrowLength, 0x00ff00),
          r: 0
        });
      });
      return ret;
    }
  }, {
    key: 'createRadialCollisionRaysFromCenter',
    value: function createRadialCollisionRaysFromCenter() {
      var numRadius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      var radiusStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
      var radiusIncrement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var numRaysPerRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;

      var ret = [];

      for (var i = 0; i < numRadius; i++) {
        var radius = radiusStart + i * radiusIncrement;
        for (var k = 0; k < numRaysPerRadius; k++) {
          var offset = i % 2 === 0 ? 0 : Math.PI / 4;
          var r = k * (Math.PI * 2 / numRaysPerRadius) + offset;
          var x = radius * Math.cos(r);
          var y = radius * Math.sin(r);
          ret.push({
            ray: new THREE.Ray(new THREE.Vector3(), new THREE.Vector3(x, -1, y).normalize()),
            arrow: new THREE.ArrowHelper(new THREE.Vector3(x, -1, y).normalize(), new THREE.Vector3(), this.collisionArrowLength, 0x00ff00),
            r: radius
          });
        }
      }

      return ret;
    }
  }, {
    key: 'singleCollisionTest',
    value: function singleCollisionTest(parent) {
      var _this7 = this;

      var stopAtComp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      if (this.debug) {
        this.collisionRays.forEach(function (obj) {
          obj.arrow.setColor(_this7.greenColor);
        });
      }

      var compenetration = 0;
      var numConfirmedCompenetrations = 0;

      for (var i = 0; i < this.collisionRays.length; i++) {
        var object = this.collisionRays[i];

        this.collisionOrigin.copy(object.ray.origin);
        this.collisionOrigin.applyMatrix4(this.matrixWorld);
        this.collisionDirection.copy(object.ray.direction);
        this.collisionDirection.transformDirection(this.matrixWorld);
        this.rayCaster.set(this.collisionOrigin, this.collisionDirection);

        var parentIntersections = [];
        var collisionMesh = parent.collisionMesh || parent;
        var parentMaterialSide = collisionMesh.material.side;
        collisionMesh.material.side = THREE.FrontSide; // test front side of parent
        collisionMesh.raycast(this.rayCaster, parentIntersections);
        collisionMesh.material.side = parentMaterialSide; // reset material side

        if (parentIntersections.length > 0) {
          var intersectionPoint = this.parent.worldToLocal(parentIntersections[0].point.clone());
          var int = Math.abs(intersectionPoint.y - this.position.y);
          // console.log(int)
          var cmp = object.selfIntersection * this.scale.y - int + this.spacing;
          compenetration = Math.max(compenetration, cmp);
          if (cmp > 0) {
            numConfirmedCompenetrations++;
            if (this.debug) {
              object.arrow.setColor(this.redcolor);
            }
          }
        }
        if (numConfirmedCompenetrations === stopAtComp) {
          break;
        }
      }
      return compenetration;
    }
  }, {
    key: 'doubleCollisionTest',
    value: function doubleCollisionTest(parent) {
      var _this8 = this;

      var stopAtComp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      if (this.debug) {
        this.collisionRays.forEach(function (obj) {
          obj.arrow.setColor(_this8.greenColor);
        });
      }

      var compenetration = 0;
      var numConfirmedCompenetrations = 0;

      for (var i = 0; i < this.collisionRays.length; i++) {
        var object = this.collisionRays[i];

        this.collisionOrigin.copy(object.ray.origin);
        this.collisionOrigin.applyMatrix4(this.matrixWorld);
        this.collisionDirection.copy(object.ray.direction);
        // direction.transformDirection(this.matrixWorld)
        this.rayCaster.set(this.collisionOrigin, this.collisionDirection);

        var parentIntersections = [];
        var selfIntersections = [];
        parent.collisionMesh.material.side = THREE.FrontSide; // test front side of parent
        parent.collisionMesh.raycast(this.rayCaster, parentIntersections);

        if (parentIntersections.length > 0) {
          // if intersects with parent
          this.collisionMesh.material.side = THREE.BackSide; // test backside of self
          this.collisionMesh.raycast(this.rayCaster, selfIntersections);

          if (selfIntersections.length > 0) {
            var cmp = selfIntersections[0].distance - parentIntersections[0].distance;
            compenetration = Math.max(compenetration, cmp);
            if (cmp > 0) {
              if (this.debug) {
                object.arrow.setColor(this.redcolor);
              }
              numConfirmedCompenetrations++;
            }
          }
        }
        if (numConfirmedCompenetrations === stopAtComp) {
          break;
        }
      }

      return compenetration;
    }
  }, {
    key: 'addWheelShadowPlane',
    value: function addWheelShadowPlane() {
      var geom = new THREE.PlaneBufferGeometry(2, 2);
      var material = new THREE.MeshBasicMaterial({
        transparent: true,
        map: new THREE.TextureLoader().load('/static/img/shadow1.png'),
        side: THREE.DoubleSide,
        depthWrite: false
      });
      var plane = new THREE.Mesh(geom, material);
      plane.position.copy(this.collisionGeometry.boundingSphere.center);
      plane.position.z -= this.collisionGeometry.boundingSphere.radius;
      this.add(plane);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.geometry.dispose();
      this.material.map.dispose();
      this.material.dispose();

      this.collisionMesh.traverse(function (child) {
        child.material.dispose();
        if (child.material.map) child.material.map.dispose();
        child.geometry.dispose();
      });

      while (this.collisionMesh.children.length > 0) {
        this.collisionMesh.remove(this.collisionMesh.children[0]);
      }

      this.collisionMesh.material.dispose();
      this.collisionMesh.geometry.dispose();
      this.remove(this.collisionMesh);
    }
  }, {
    key: 'isConceptStone',
    get: function get() {
      return this._config ? this._config.concepts !== undefined : false;
    }
  }, {
    key: 'config',
    get: function get() {
      return this._config;
    },
    set: function set(value) {
      this._config = value;
      this.rotationDirection = value.trend !== undefined ? value.trend : 1;

      if (this.isConceptStone) {
        this.material.map.draw(value.color, value.concepts.length);
      } else {
        this.rotationRate = value.activity * 0.1 * this.rotationDirection;
        this.elasticRotationRate.target = this.rotationRate;
      }
      if (this.__visible) {
        this.setScale();
      }
    }
  }, {
    key: 'activeCollisionLOD',
    get: function get() {
      return this._activeCollisionLOD;
    },
    set: function set(value) {
      var _this9 = this;

      this._activeCollisionLOD = value;

      // create collision LOD rays in demand
      if ((value === 1 || value === 2) && !this.collisionLOD[1]) {
        this.collisionLOD[1] = this.createRadialCollisionRaysFromCenter(2, 0.2, 0.3, 3);
      }
      if (value === 2 && !this.collisionLOD[2]) {
        this.collisionLOD[2] = this.createParallelCollisionRaysForLowerVertices(10);
      }

      this.collisionRays = [];
      for (var i = 0; i <= value; i++) {
        this.collisionRays = this.collisionRays.concat(this.collisionLOD[i]);
      }

      while (this.collisionMesh.children.length > 0) {
        this.collisionMesh.remove(this.collisionMesh.children[0]);
      }

      this.precomputeCollisionRaysOwnIntersection();

      if (this.debug) {
        this.collisionRays.forEach(function (object) {
          _this9.collisionMesh.add(object.arrow);
        });
      }
    }
  }, {
    key: 'debug',
    get: function get() {
      return this._debug;
    },
    set: function set(value) {
      this._debug = value;
      this.collisionMesh.visible = value;
      this.material.transparent = value;
      this.material.opacity = value ? 0.7 : 1;
    }
  }, {
    key: 'oscillate',
    get: function get() {
      return this._oscillate;
    },
    set: function set(value) {
      if (!this.isConceptStone) {
        this.elasticOscillationSpeed.target = value ? this.oscillationSpeed : 0;
        this._oscillate = value;
      } else {
        this._oscillate = false;
      }
    }
  }, {
    key: 'rotate',
    get: function get() {
      return this._rotate;
    },
    set: function set(value) {
      if (!this.isConceptStone) {
        this.elasticRotationRate.target = value ? this.rotationRate : 0;
        this._rotate = value;
      } else {
        this._rotate = false;
      }
    }
  }]);

  return HopeConceptStone;
}(THREE.Mesh);

/* harmony default export */ __webpack_exports__["a"] = (HopeConceptStone);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/google-play.db9b21a.png";

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app-store.9948d29.png";

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */

// Reasonable defaults
var PIXEL_STEP = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType()
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can lety
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel(event) {
  var sX = 0;
  var sY = 0; // spinX, spinY
  var pX = 0;
  var pY = 0; // pixelX, pixelY

  // Legacy
  if ('detail' in event) {
    sY = event.detail;
  }
  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }
  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }
  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  }

  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }
  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode === 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }
  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return {
    spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY
  };
}

/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
// normalizeWheel.getEventType = function() {
//   return (UserAgent_DEPRECATED.firefox())
//            ? 'DOMMouseScroll'
//            : (isEventSupported('wheel'))
//                ? 'wheel'
//                : 'mousewheel'
// }

/* harmony default export */ __webpack_exports__["a"] = (normalizeWheel);

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_meanBy__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_meanBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_meanBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_await_to_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment_recur__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment_recur___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment_recur__);







// import axios from 'axios'









/* global THREE */

var mockCategories = [{
  id: 1,
  label: 'Humanism/Culture',
  color: 0x925DE8
}, {
  id: 2,
  label: 'Education',
  color: 0x2B71E2
}, {
  id: 3,
  label: 'Politics',
  color: 0x48C4EF
}, {
  id: 4,
  label: 'Economy',
  color: 0xFF85CE
}, {
  id: 5,
  label: 'Science',
  color: 0xFF556A
}, {
  id: 6,
  label: 'Nature/Environment',
  color: 0xFF8E55
}, {
  id: 7,
  label: 'Technology',
  color: 0xFFBE2E
}, {
  id: 8,
  label: 'Medicine',
  color: 0x64E2BB
}];

var getMockInterestOverTime = function getMockInterestOverTime() {
  var ret = [];
  // let l = 10 + Math.round(Math.random() * 20)

  var y = 2008 + Math.round(Math.random() * 8);
  var m = Math.round(Math.random() * 10);
  var d = 1 + Math.round(Math.random() * 27);
  var startDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()([y, m, d]);
  var now = __WEBPACK_IMPORTED_MODULE_13_moment___default()();
  var l = now.diff(startDate, 'months', true);

  var intervals = startDate.recur().dayOfMonth(1).next(l);
  var trend = 1;

  for (var i = 0; i < l; i++) {
    var interest = void 0;
    if (i === 0) {
      interest = Math.random();
    } else {
      var prev = ret[i - 1].interest;
      interest = prev + Math.random() * 0.1 * trend;
      interest = Math.max(0, Math.min(1, interest));
    }
    if (interest === 1) trend = -1;
    if (interest === 0) trend = 1;
    // randomize trend every 2 months
    if (i % 2 === 0) {
      trend = Math.random() > 0.5 ? -1 : 1;
    }

    ret.push({
      date: intervals[i].format(),
      interest: interest
    });
  }

  // ret.push({
  //   date: now.format(), // now
  //   interest: Math.random()
  // })
  return ret;
};
var regions = ['United States', 'Zimbabwe', 'Italy', 'Japan', 'France', 'Germany', 'Poland', 'Brazil', 'Argentina', 'United Kingdom', 'Indonesia', 'Australia', 'Afghanistan', 'Ethiopia', 'Hungary', 'Portugal', 'Vietnam'];
var getMockInterestByRegion = function getMockInterestByRegion() {
  var ret = [];
  for (var i = 0; i < 6; i++) {
    var name = regions[Math.floor(Math.random() * regions.length)];
    while (__WEBPACK_IMPORTED_MODULE_8_lodash_find___default()(ret, { name: name })) {
      // avoid duplicates
      name = regions[Math.floor(Math.random() * regions.length)];
    }
    var interest = Math.random();
    ret.push({ name: name, interest: interest });
  }
  return ret;
};

var RELATED_TOTEM_AMOUNT = 5;

var conceptLabels = [['Gender equality', 'Women\'s rights', 'Human rights', 'Spiritual growth', 'Art', 'Journalism', 'Feminism', 'Religion', 'Awakening movies'], ['Knowledge sharing', 'Olympic trophies', 'Learning', 'Education', 'Lessons from history', 'Litterature', 'Media literacy', 'Science and Technology', 'Grad school', 'Academies'], ['Climate Policy', 'Counter-Terrorism', 'Free World', 'Relaunch of USA influence', 'Revive of Euro-mediterranean relationship', 'Political Engagement', 'Europe’s unity', 'Privacy', 'Ending Poverty', 'Immigration'], ['Economic system', 'Social justice', 'Economic growth', 'New currencies', 'Online trading', 'Sustainable development', 'Circular economy', 'Basic income', 'Cyber security'], ['Scientific discoveries', 'Extraterrestrial life', 'Man on Mars', 'New materials', 'Molecular biology'], ['Environment improvements', 'Climate Change adaptation', 'Preservation of life', 'Renewable energy'], ['Video-games evolution', 'Technological breakthroughs', 'Artificial Intelligence', 'Cloud', 'Blockchain technology', 'Digital immersion', 'Smart-Things', 'Self-driving automobiles', 'Solar powered facilities', 'New means of transportation'], ['Cancer treatments improvement', 'Medical discovery', 'Alternative medicine', 'Drugs', 'Homeopathy', 'Phytoterapy', 'Traditional Chinese medicine', 'Acupunture', 'Biomedical research']];

var mockConcepts = [];
var incrementalId = 0;
conceptLabels.forEach(function (category, categoryIndex) {
  category.forEach(function (concept) {
    mockConcepts.push({
      id: incrementalId,
      category: categoryIndex + 1,
      activity: Math.random(),
      label: concept,
      interestOverTime: getMockInterestOverTime(),
      interestByRegion: getMockInterestByRegion()
    });
    incrementalId++;
  });
});

var useMockBackend = false;

var GoogleHopeService = function () {
  function GoogleHopeService() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, GoogleHopeService);

    this.categoriesCache = null;
    this.conceptsCache = null;
    this.userTotem = null;
    this.loading = false;
    this.shareAvailable = false;

    var location = window && window.location ? window.location.host : '';

    this._getCategories = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/categories' : '/api/categories',
      withCredentials: true
    };
    this._getConcepts = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/concepts' : '/api/concepts'
    };
    this._getRelatedTotems = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/totems?amount=' + RELATED_TOTEM_AMOUNT : '/api/totems?amount=' + RELATED_TOTEM_AMOUNT
    };
    this._saveTotem = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/totem' : '/api/totem',
      method: 'POST'
    };
    this._saveThumbnail = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/thumbnail' : '/api/thumbnail',
      method: 'PUT',
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    };
  }

  // async
  // retrieves a list of categories
  // each one containing concepts


  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(GoogleHopeService, [{
    key: 'getCategories',
    value: function getCategories() {
      var _this = this;

      this.loading = true;
      if (!useMockBackend) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
            var _ref2, _ref3, error, response, data;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_12_await_to_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_axios___default.a.request(_this._getCategories));

                  case 2:
                    _ref2 = _context.sent;
                    _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                    error = _ref3[0];
                    response = _ref3[1];

                    _this.loading = false;
                    if (error) {
                      reject(error);
                    } else {
                      data = response.data.map(function (cat) {
                        cat.color = new THREE.Color(cat.color).getHex();
                        return cat;
                      });

                      _this.categoriesCache = data;
                      resolve(data);
                    }

                  case 8:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // fake delay
        _this.categoriesCache = mockCategories;
        __WEBPACK_IMPORTED_MODULE_7_lodash_delay___default()(function () {
          _this.loading = false;
          resolve(mockCategories);
        }, Math.random() * 1500);
      });
    }
    // async
    // retrieves a list of flattened concept
    // category optional
    // if category is omitted it returns all concepts of all categories

  }, {
    key: 'getConcepts',
    value: function getConcepts() {
      var _this2 = this;

      var categoryId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

      this.loading = true;

      if (!useMockBackend) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
            var _ref5, _ref6, error, response, userConcepts;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_12_await_to_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_axios___default.a.request(_this2._getConcepts));

                  case 2:
                    _ref5 = _context2.sent;
                    _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                    error = _ref6[0];
                    response = _ref6[1];

                    _this2.loading = false;
                    if (error) {
                      reject(error);
                    } else {
                      userConcepts = response.data.map(function (concept) {
                        var activity = concept.interest[concept.interest.length - 1].value / 100;
                        var beforeActivity = concept.interest[concept.interest.length - 2].value / 100;
                        var trend = activity > beforeActivity ? 1 : -1;
                        var concObject = {
                          id: concept.id,
                          category: concept.category,
                          label: concept.label,
                          link: concept.link,
                          entity: concept.entity,
                          activity: activity
                        };

                        concObject.interestByRegion = concept.regions.map(function (region) {
                          return {
                            name: region.geoName,
                            interest: region.value / 100
                          };
                        });
                        concObject.interestOverTime = concept.interest.map(function (interest) {
                          return {
                            date: __WEBPACK_IMPORTED_MODULE_13_moment___default()(interest.formattedAxisTime).format(),
                            formattedDate: interest.formattedAxisTime,
                            interest: interest.value / 100
                          };
                        });

                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(concObject, {
                          confirmed: false,
                          importance: 0.5,
                          trend: trend,
                          categoryObject: _this2.getConceptCategory(concept)
                        });
                      });

                      _this2.conceptsCache = userConcepts;
                      if (categoryId !== -1) {
                        resolve(__WEBPACK_IMPORTED_MODULE_9_lodash_filter___default()(userConcepts, { category: categoryId }));
                      } else {
                        resolve(userConcepts);
                      }
                    }

                  case 8:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x4, _x5) {
            return _ref4.apply(this, arguments);
          };
        }());
      }
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.conceptsCache = mockConcepts;
        var userConcepts = mockConcepts.map(function (concept) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, concept, {
            confirmed: false,
            importance: 0.5,
            categoryObject: _this2.getConceptCategory(concept)
          });
        });
        if (categoryId !== -1) {
          // fake delay
          __WEBPACK_IMPORTED_MODULE_7_lodash_delay___default()(function () {
            _this2.loading = false;
            resolve(__WEBPACK_IMPORTED_MODULE_9_lodash_filter___default()(userConcepts, { category: categoryId }));
          }, Math.random() * 1500);
        } else {
          // fake delay
          __WEBPACK_IMPORTED_MODULE_7_lodash_delay___default()(function () {
            _this2.loading = false;
            resolve(userConcepts);
          }, Math.random() * 1500);
        }
      });
    }
    // async
    // retrieves a list of related totems

  }, {
    key: 'getRelatedTotems',
    value: function getRelatedTotems(concepts) {
      var _this3 = this;

      this.loading = true;

      if (!useMockBackend) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
          var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
            var _ref8, _ref9, error, response, res, data, i, totem, _concepts, j, concept;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_12_await_to_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_axios___default.a.request(_this3._getRelatedTotems));

                  case 2:
                    _ref8 = _context3.sent;
                    _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref8, 2);
                    error = _ref9[0];
                    response = _ref9[1];

                    _this3.loading = false;

                    if (!error) {
                      _context3.next = 11;
                      break;
                    }

                    reject(error);
                    _context3.next = 34;
                    break;

                  case 11:
                    // let data = response.data.map(cat => {
                    //   cat.color = new THREE.Color(cat.color).getHex()
                    //   return cat
                    // })
                    res = [];
                    data = response.data;
                    i = 0;

                  case 14:
                    if (!(i < data.length)) {
                      _context3.next = 33;
                      break;
                    }

                    totem = data[i];
                    _concepts = [];
                    j = 0;

                  case 18:
                    if (!(j < totem.concepts.length)) {
                      _context3.next = 29;
                      break;
                    }

                    concept = _this3.conceptsCache[totem.concepts[j].id - 1];

                    if (concept) {
                      _context3.next = 22;
                      break;
                    }

                    return _context3.abrupt('continue', 26);

                  case 22:

                    concept.importance = totem.concepts[j].importance;
                    concept.name = totem.name;
                    concept.latlon = totem.latlon;

                    _concepts.push(concept);

                  case 26:
                    j++;
                    _context3.next = 18;
                    break;

                  case 29:

                    res.push(_concepts);

                  case 30:
                    i++;
                    _context3.next = 14;
                    break;

                  case 33:

                    // this.categoriesCache = data
                    resolve(res);

                  case 34:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this3);
          }));

          return function (_x6, _x7) {
            return _ref7.apply(this, arguments);
          };
        }());
      }

      // this.loading = true
      // return new Promise((resolve, reject) => {
      //   let ret = []
      //   for (let i = 0; i < 5; i++) {
      //     let totem = []
      //     for (let k = 0; k < 10; k++) {
      //       let randomConcept = this.conceptsCache[Math.floor(Math.random() * (this.conceptsCache.length - 1))]
      //       // avoid creating duplicate concepts
      //       if (!find(totem, {id: randomConcept.id})) {
      //         totem.push(Object.assign({}, randomConcept, {
      //           categoryObject: this.getConceptCategory(randomConcept),
      //           importance: Math.random()
      //         }))
      //       }
      //     }
      //     ret.push(totem)
      //   }
      //   delay(() => {
      //     this.loading = false

      //     console.log('TOTEMS:', ret)
      //     resolve(ret)
      //   }, Math.random() * 1500)
      // })
    }

    // sync
    // returns a category given a concept

  }, {
    key: 'getConceptCategory',
    value: function getConceptCategory(concept) {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_find___default()(this.categoriesCache, { id: concept.category });
    }
    // sync
    // builds totem data based on selected concepts

  }, {
    key: 'getTotemData',
    value: function getTotemData(concepts) {
      if (!this.categoriesCache) {
        return null;
      }
      var data = {
        stones: []
      };

      this.categoriesCache.forEach(function (category) {
        var conc = __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default()(concepts, { category: category.id });
        if (conc.length > 0) {
          data.stones.push({
            id: category.id,
            color: category.color,
            label: category.label,
            averageActivity: __WEBPACK_IMPORTED_MODULE_10_lodash_meanBy___default()(conc, 'activity'),
            concepts: conc
          });
        }
      });

      return data;
    }

    // async
    // saves a totem

  }, {
    key: 'saveTotem',
    value: function saveTotem(concepts, name, location) {
      var _this4 = this;

      this.loading = true;

      if (!useMockBackend) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
          var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
            var request, _ref11, _ref12, error, response;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                      data: {
                        name: name,
                        concepts: concepts.map(function (concept) {
                          return { id: concept.id, importance: concept.importance };
                        }),
                        latlon: location.lat + ',' + location.lng
                      }
                    }, _this4._saveTotem);
                    _context4.next = 3;
                    return Object(__WEBPACK_IMPORTED_MODULE_12_await_to_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_axios___default.a.request(request));

                  case 3:
                    _ref11 = _context4.sent;
                    _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref11, 2);
                    error = _ref12[0];
                    response = _ref12[1];

                    _this4.loading = false;
                    if (error) {
                      reject(error);
                    } else {
                      _this4.userTotem = _this4.getTotemData(concepts);
                      _this4.userTotem.id = response.data.key;
                      _this4.userTotem.label = name;
                      _this4.userTotem.geolocation = location;
                      resolve(response);
                    }

                  case 9:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this4);
          }));

          return function (_x8, _x9) {
            return _ref10.apply(this, arguments);
          };
        }());
      }

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.userTotem = _this4.getTotemData(concepts);
        _this4.userTotem.id = Math.round(Math.random() * 100000);
        _this4.userTotem.label = name;
        _this4.userTotem.geolocation = location;
        // fake delay
        __WEBPACK_IMPORTED_MODULE_7_lodash_delay___default()(function () {
          _this4.loading = false;
          resolve(_this4.userTotem);
        }, Math.random() * 1500);
      });
    }
    // async
    // saves a thumbnail

  }, {
    key: 'saveThumbnail',
    value: function saveThumbnail(id, thumbnail) {
      var _this5 = this;

      this.loading = true;

      if (!useMockBackend) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
          var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
            var data, request, _ref14, _ref15, error, response;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    data = new FormData();

                    data.append('thumbnail', thumbnail);
                    request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ data: data }, _this5._saveThumbnail);

                    request.url += '/' + id;

                    _context5.next = 6;
                    return Object(__WEBPACK_IMPORTED_MODULE_12_await_to_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_axios___default.a.request(request));

                  case 6:
                    _ref14 = _context5.sent;
                    _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref14, 2);
                    error = _ref15[0];
                    response = _ref15[1];

                    _this5.loading = false;
                    if (error) {
                      reject(error);
                    } else {
                      _this5.shareAvailable = true;
                      resolve(response);
                    }

                  case 12:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this5);
          }));

          return function (_x10, _x11) {
            return _ref13.apply(this, arguments);
          };
        }());
      }

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // fake delay
        __WEBPACK_IMPORTED_MODULE_7_lodash_delay___default()(function () {
          _this5.loading = false;
          resolve(true);
        }, Math.random() * 1500);
      });
    }
  }]);

  return GoogleHopeService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new GoogleHopeService());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06acd2ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__(676);
function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06acd2ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06acd2ee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atoms_HopeCategoryStone__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atoms_HopeStoneTexture__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atoms_HopeTotemLabel__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_applyToonLighting__ = __webpack_require__(97);





/* global THREE */






var HopeTotem = function (_THREE$Group) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HopeTotem, _THREE$Group);

  // constructor
  function HopeTotem(config) {
    var isUserTotem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var userTotem = arguments[2];

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HopeTotem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HopeTotem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HopeTotem)).call(this));

    _this._isUserTotem = isUserTotem;
    _this._stones = [];
    _this._stoneShadows = [];
    _this._debug = false;
    _this._rotate = true;
    _this._oscillate = true;
    _this._collisionLOD = 0;
    _this._id = config.id;
    _this._spacing = 0;
    _this._allStonesExploded = false;

    // this.position.x = config.position.x
    // this.position.z = config.position.z
    // this.position.y = 0
    _this.doUpdate = true;

    _this.config = config;
    _this.label = new __WEBPACK_IMPORTED_MODULE_7__atoms_HopeTotemLabel__["a" /* default */](config.label);

    _this._distance = 0;

    var deg2rad = function deg2rad(d) {
      return d * (Math.PI / 180);
    };

    if (_this._isUserTotem) {
      _this.label.draw(_this._config.label, 'Your hopes, by topic');
    } else {
      if (userTotem) {
        var currentDistance = _this.config.stones[0].concepts[0].latlon;
        var userDistance = {
          lat: userTotem[0]._config.geolocation.lat,
          lon: userTotem[0]._config.geolocation.lng
        };

        var R = 6371e3;

        var lat1 = deg2rad(parseFloat(currentDistance.split(',')[0]));
        var lon1 = deg2rad(parseFloat(currentDistance.split(',')[1]));

        var lat2 = deg2rad(userDistance.lat);
        var lon2 = deg2rad(userDistance.lon);

        var phi1 = lat1;
        var phi2 = lat2;
        var delta1 = lat2 - lat1;
        var delta2 = lon2 - lon1;

        var a = Math.sin(delta1 / 2) * Math.sin(delta1 / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(delta2 / 2) * Math.sin(delta2 / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        _this._distance = Math.round(R * c / 1000 * 0.621371);

        _this.label.draw(_this._config.label, _this._distance + ' Miles');
      }
    }

    _this.add(_this.label);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HopeTotem, [{
    key: 'findCategoryStoneByConcept',
    value: function findCategoryStoneByConcept(concept) {
      var ret = null;
      this._stones.some(function (stone) {
        if (stone.hasConcept(concept)) {
          ret = stone;
          return true;
        }
        return false;
      });
      return ret;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this2 = this;

      this._stones.forEach(function (stone) {
        stone.destroy();
        _this2.remove(stone);
      });
      this._stones = [];
    }
  }, {
    key: '_initStoneY',
    value: function _initStoneY(stone, prevStone) {
      var thisStoneRadius = stone.unexplodedStone.collisionMesh.geometry.boundingSphere.radius * 0.9;
      var thisStoneScale = 0.3 + stone.config.concepts.length / 4;
      var prevStoneRadius = prevStone.unexplodedStone.collisionMesh.geometry.boundingSphere.radius * 0.9;
      var prevStoneScale = 0.3 + prevStone.config.concepts.length / 4;
      var prevStoneY = prevStone.getY();
      stone.setY(prevStoneY + prevStoneRadius * prevStoneScale + thisStoneRadius * thisStoneScale);
    }
  }, {
    key: 'getStone',
    value: function getStone(stoneData) {
      return __WEBPACK_IMPORTED_MODULE_8_lodash_find___default()(this._stones, { config: { id: stoneData.id } });
    }
  }, {
    key: 'update',
    value: function update(delta, ground) {
      if (this.doUpdate) {
        for (var i = 0; i < this._stones.length; i++) {
          if (i > 0) {
            this._stones[i].update(this._stones[i - 1].upperCollider, delta);
          } else {
            this._stones[i].update(ground, delta);
          }

          var shadow = this._stoneShadows[i];
          var y = this._stones[i].unexplodedStone.position.y;
          shadow.position.z = -0.2 - y * 0.8;
          shadow.position.x = -0.2 - y * 0.8;
        }

        if (this._stones.length) {
          var top = this._stones[this._stones.length - 1].upperCollider;
          this.label.position.y = top.position.y + top.collisionMesh.geometry.boundingSphere.radius * top.scale.y;
          this.label.visible = this.doUpdate;
        }
      }
    }
  }, {
    key: 'allStonesExploded',
    get: function get() {
      return this._allStonesExploded;
    },
    set: function set(value) {
      if (value !== this._allStonesExploded) {
        this._allStonesExploded = value;

        if (value) {
          if (this._isUserTotem) {
            this.label.draw(this._config.label, 'All your hopes');
          } else {
            this.label.draw(this._config.label, this._distance + ' Miles');
          }
        } else {
          if (this._isUserTotem) {
            this.label.draw(this._config.label, 'Your hopes, by topic');
          } else {
            this.label.draw(this._config.label, this._distance + ' Miles');
          }
        }
      }
    }
  }, {
    key: 'spacing',
    set: function set(value) {
      this._spacing = value;
      for (var i = this._stones.length - 1; i >= 0; i--) {
        this._stones[i].spacing = value;
      }
    },
    get: function get() {
      return this._spacing;
    }
  }, {
    key: 'stones',
    get: function get() {
      return this._stones;
    }

    // handle variation (update, remove, add) on stones

  }, {
    key: 'config',
    set: function set(value) {
      var _this3 = this;

      // remove stones
      // inverse loop for removing
      for (var i = this._stones.length - 1; i >= 0; i--) {
        var stone = this._stones[i];
        if (!__WEBPACK_IMPORTED_MODULE_8_lodash_find___default()(value.stones, { id: stone.config.id })) {
          stone.destroy();
          this.remove(stone);
          this._stones.splice(i, 1);

          var shadow = this._stoneShadows[i];
          shadow.material.map.dispose();
          shadow.material.dispose();
          shadow.geometry.dispose();
          this.remove(shadow);
          this._stoneShadows.splice(i, 1);
        }
      }

      // add/update stones
      value.stones.forEach(function (stoneConfig, i) {
        var existingStone = _this3.getStone(stoneConfig);
        if (!existingStone) {
          var material = new THREE.MeshToonMaterial({
            specular: new THREE.Color(0x000000),
            shininess: 0,
            transparent: true,
            opacity: 0,
            map: new __WEBPACK_IMPORTED_MODULE_6__atoms_HopeStoneTexture__["a" /* default */](stoneConfig.color, stoneConfig.concepts.length)
          });
          material.onBeforeCompile = function (mat) {
            mat.fragmentShader = mat.fragmentShader.replace('#include <fog_fragment>', '#include <fog_fragment>;\n#ifdef USE_FOG\ngl_FragColor.a *= 2.0 - fogFactor;\n#endif');
            Object(__WEBPACK_IMPORTED_MODULE_9__utils_applyToonLighting__["a" /* default */])(mat);
          };
          var _stone = new __WEBPACK_IMPORTED_MODULE_5__atoms_HopeCategoryStone__["a" /* default */](stoneConfig, material);
          // stone.elasticPosition.y = stone.position.y = this._stones[this._stones.length - 1].position.y + 1.5
          if (i > 0) {
            var prevStone = _this3._stones[i - 1];
            _this3._initStoneY(_stone, prevStone);
          }
          _stone.debug = _this3._debug;
          _stone.rotate = _this3._rotate;
          _stone.oscillate = _this3._oscillate;
          _stone.activeCollisionLOD = _this3._collisionLOD;
          _this3.add(_stone);
          _this3._stones.push(_stone);

          var geom = new THREE.PlaneBufferGeometry(2, 2);
          var shadowMat = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: 0.15,
            map: new THREE.TextureLoader().load('/static/img/shadow1.png'),
            // side: THREE.DoubleSide,
            // depthTest: false,
            depthWrite: false
          });
          var _shadow = new THREE.Mesh(geom, shadowMat);
          _shadow.rotation.x = -(Math.PI / 2);
          _shadow.position.y = -0.48;
          _shadow.position.z = -(i * 0.5);
          _shadow.position.x = -(i * 0.5);
          _this3.add(_shadow);
          _this3._stoneShadows.push(_shadow);
        } else {
          existingStone.config = stoneConfig;
          if (i > 0) {
            var _prevStone = _this3._stones[i - 1];
            _this3._initStoneY(existingStone, _prevStone);
          }
        }
      });

      this._config = value;
    },
    get: function get() {
      return this._config;
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }, {
    key: 'collisionLOD',
    get: function get() {
      return this._collisionLOD;
    },
    set: function set(value) {
      this._collisionLOD = value;

      for (var i = 0; i < this._stones.length; i++) {
        this._stones[i].activeCollisionLOD = value;
      }
    }
  }, {
    key: 'debug',
    get: function get() {
      return this._debug;
    },
    set: function set(value) {
      this._debug = value;

      for (var i = 0; i < this._stones.length; i++) {
        this._stones[i].debug = value;
      }
    }
  }, {
    key: 'rotate',
    get: function get() {
      return this._rotate;
    },
    set: function set(value) {
      this._rotate = value;

      for (var i = 0; i < this._stones.length; i++) {
        this._stones[i].rotate = value;
      }
    }
  }, {
    key: 'oscillate',
    get: function get() {
      return this._oscillate;
    },
    set: function set(value) {
      this._oscillate = value;

      for (var i = 0; i < this._stones.length; i++) {
        this._stones[i].oscillate = value;
      }
    }
  }]);

  return HopeTotem;
}(THREE.Group);

/* harmony default export */ __webpack_exports__["a"] = (HopeTotem);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ElasticVector3 = function () {
  function ElasticVector3(value) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ElasticVector3);

    this.value = value;
    this.x = value.x;
    this.y = value.y;
    this.z = value.z;
    this.speed = 3;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ElasticVector3, [{
    key: "set",
    value: function set(x, y, z) {
      this.x = x;
      this.y = y;
      this.z = z;
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      this.z = v.z;
    }
  }, {
    key: "update",
    value: function update(delta) {
      delta = Math.min(delta, 1 / 10);

      var distx = this.x - this.value.x;
      var disty = this.y - this.value.y;
      var distz = this.z - this.value.z;

      this.value.x += distx * (this.speed * delta);
      this.value.y += disty * (this.speed * delta);
      this.value.z += distz * (this.speed * delta);
    }
  }]);

  return ElasticVector3;
}();

/* harmony default export */ __webpack_exports__["a"] = (ElasticVector3);

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bpXs":"767","bpSm":"991","bpMd":"1199","bpLg":"1399","bpMlg":"1699","bpXmlg":"1700","bpXlg":"1800","bpXxlg":"5000","cBackground":"#f9f8f7","headerHeight":"50","conceptSelectorDesktopHeight":"150","conceptSelectorMobileTrackPercent":"50","conceptSelectorDesktopTrackPercent":"25","conceptContainerDesktopWidth":"600","conceptContainerMobileRight":"75","conceptContainerMobileLeft":"25"};

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptsSelectionWheel_vue__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b813ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptsSelectionWheel_vue__ = __webpack_require__(868);
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56b813ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptsSelectionWheel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b813ce_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptsSelectionWheel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MobileDetect = __webpack_require__(654);
var md = new MobileDetect(window.navigator.userAgent);

var volumeTest = document.createElement('audio');
volumeTest.volume = 0.5;

var Platform = {
  mobile: !!md.mobile(),
  phone: !!md.phone(),
  tablet: !!md.tablet(),
  android: !!md.is('AndroidOS'),
  ios: !!md.is('iOS'),
  ipad: !!md.is('iPad'),
  iphone: !!md.is('iPhone'),
  wphone: !!md.is('WindowsPhoneOS'),
  edge: !!/Edge\/\d+/i.test(window.navigator.userAgent),
  firefox: md.version('Gecko') > 1,
  chrome: /Chrome/i.test(window.navigator.userAgent),
  ie11: !!/Trident.*rv:11\./i.test(window.navigator.userAgent),
  safari: /Safari/.test(window.navigator.userAgent) && /Apple Computer/.test(window.navigator.vendor),
  prerenderer: /PhantomJS/.test(window.navigator.userAgent),
  volume: volumeTest.volume === 0.5

  // if not prerenderer
};if (!Platform.prerenderer) {
  var _loop = function _loop(key) {
    window.Modernizr.addTest(key, function () {
      return Platform[key];
    });
  };

  // add custom modernizr tests
  for (var key in Platform) {
    _loop(key);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Platform);

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8.3 17.39"}},[_c('defs'),_c('title',[_v("arrow-dx")]),_c('g',{attrs:{"id":"Livello_2","data-name":"Livello 2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M.5.5l7.14 7.72L.5 16.89","id":"Layer_2","data-name":"Layer 2"}})])])}}};

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8.3 17.39"}},[_c('defs'),_c('title',[_v("arrow-sx")]),_c('g',{attrs:{"id":"Livello_2","data-name":"Livello 2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M7.8 16.89L.66 8.17 7.8.5","id":"Layer_2","data-name":"Layer 2"}})])])}}};

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60.25 50.76"}},[_c('title',[_v("about_5")]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Livello 4","fill":"none","stroke":"#606060","stroke-miterlimit":"10"}},[_c('path',{attrs:{"stroke-linecap":"round","opacity":".2","d":"M30.21.56v12.48"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M30.21 30.29v13.14M48.77 11.28l-11.02 6.36"}}),_c('path',{attrs:{"stroke-linecap":"round","opacity":".2","d":"M22.83 26.26l-11.19 6.45"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M30.18.5L11.64 11.2M48.77 32.72l-18.54 10.7M11.64 11.27l10.9 6.3"}}),_c('path',{attrs:{"stroke-linecap":"round","opacity":".2","d":"M37.47 26.19l11.3 6.53"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M30.24.57l18.53 10.71M11.64 32.71l18.53 10.71M11.64 11.27v21.46M48.77 11.27v21.46"}}),_c('circle',{attrs:{"cx":"30.13","cy":"21.66","r":"8.63"}}),_c('path',{attrs:{"stroke-linecap":"round","opacity":".2","d":"M22.54 17.57l7.7 4.44-.03.02v8.26l-.03-8.28 7.57-4.37"}}),_c('path',{attrs:{"d":"M13 46.13a47.2 47.2 0 0 0 17.08 3c16.37 0 29.63-7.37 29.63-16.48 0-5.17-4.28-9.78-11-12.8M11.64 19.78C4.85 22.8.5 27.45.5 32.66c0 4.84 3.75 9.19 9.71 12.21M12.85 46.07l2.13 4.19M17.19 44.1l-4.34 1.97","stroke-linecap":"round"}})])])])}}};

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 61 61"}},[_c('title',[_v("facebook_icon")]),_c('g',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Layer 2"}},[_c('image',{staticStyle:{"mix-blend-mode":"multiply"},attrs:{"width":"61","height":"61","opacity":".15","xlink:href":"data:image/png;base64,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"}}),_c('circle',{attrs:{"cx":"30.23","cy":"28.45","r":"27","fill":"#405a93"}}),_c('path',{attrs:{"d":"M32.15 40.21V29.94h3.42l.53-4h-4v-2.49a2.14 2.14 0 0 1 .4-1.45 2 2 0 0 1 1.59-.54h2.13V17.9c-.83-.07-1.85-.11-3.07-.11a5.17 5.17 0 0 0-3.72 1.35A5.18 5.18 0 0 0 28 23v3h-3.41v4H28v10.21","fill":"#fff"}})])])}}};

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 61 61"}},[_c('title',[_v("twitter_icon")]),_c('g',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Layer 2"}},[_c('image',{staticStyle:{"mix-blend-mode":"multiply"},attrs:{"width":"61","height":"61","opacity":".15","xlink:href":"data:image/png;base64,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"}}),_c('circle',{attrs:{"cx":"30.73","cy":"28.45","r":"27","fill":"#4aabe7"}}),_c('path',{attrs:{"d":"M42.49 25.65A15.65 15.65 0 0 1 40.65 33a15.32 15.32 0 0 1-13.93 8.44 15.4 15.4 0 0 1-8.49-2.48c.39 0 .83.05 1.32.05a11 11 0 0 0 6.91-2.37 5.14 5.14 0 0 1-3.24-1.08 5.57 5.57 0 0 1-1.93-2.72h1a6.69 6.69 0 0 0 1.47-.16 5.56 5.56 0 0 1-3.16-1.95 5.28 5.28 0 0 1-1.27-3.48v-.1a5.38 5.38 0 0 0 2.48.74 6.07 6.07 0 0 1-1.79-2 5.3 5.3 0 0 1-.69-2.66 5.37 5.37 0 0 1 .79-2.77 15.53 15.53 0 0 0 11.39 5.8 7.68 7.68 0 0 1-.1-1.27 5.59 5.59 0 0 1 2.74-4.79 5.27 5.27 0 0 1 2.74-.74 5.35 5.35 0 0 1 2.24.47A6.14 6.14 0 0 1 41 21.22a11.44 11.44 0 0 0 3.5-1.32 5.53 5.53 0 0 1-2.43 3.1 11.64 11.64 0 0 0 3.16-.9 12 12 0 0 1-2.79 2.9 3.59 3.59 0 0 1 .05.65z","fill":"#fff"}})])])}}};

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_console_polyfill__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_console_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_console_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_router_js__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_locale_js__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_event_handler__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_event_handler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_event_handler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_axios__);
// import polyfills



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// import './plugins/analytics.js'






// usage: https://github.com/declandewet/vue-meta
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_meta___default.a);
// usage: https://github.com/sandeepk01/vue-event-handler
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_event_handler___default.a);
// usage: https://github.com/imcvampire/vue-axios
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_9_axios___default.a);

//
//
// Initialization of the preloader app (placed on the HTML)
//
//
var preloader = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  // avoid touching the actual element on the HTML
  // if this is a prerenderer
  el: !__WEBPACK_IMPORTED_MODULE_4__platform__["a" /* default */].prerenderer ? '#app-loading-container' : null,
  created: function created() {
    // do preloading stuff here
  },
  data: function data() {
    return {
      visible: true
    };
  }
});

// management of languages
__WEBPACK_IMPORTED_MODULE_5__plugins_router_js__["a" /* default */].beforeEach(function (to, from, next) {
  // set current language on change route
  if (to.params.language) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.language = to.params.language;
  }
  next();
});

//
//
// Initialization of the app (placed on the HTML)
//
//
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__plugins_router_js__["a" /* default */],
  computed: {
    platform: function platform() {
      return __WEBPACK_IMPORTED_MODULE_4__platform__["a" /* default */];
    },
    targetDomain: function targetDomain() {
      return this.$el.attributes['target-domain'].value;
    }
  },
  // this block allows passing props to the main App
  // these props are set by html-webpack-plugin in the html
  // and the values are taken from git-revision-webpack-plugin
  render: function render(createElement) {
    return createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */], {
      props: {
        version: this.$el.attributes.version.value,
        commitHash: this.$el.attributes['commit-hash'].value,
        deployFlag: this.$el.attributes['deploy-flag'] ? this.$el.attributes['deploy-flag'].value === 'true' : false,
        targetDomain: this.$el.attributes['target-domain'].value,
        preloader: preloader
      }
    });
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 *
 *
 * @class RAF
 */
var RAF = function () {
  /**
   * Creates an instance of RAF.
   *
   * @memberOf RAF
   */
  function RAF() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RAF);

    this.listeners = [];
    this._update = this._update.bind(this);
    this._update();
  }
  /**
   *
   *
   * @param {any} listener
   *
   * @memberOf RAF
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RAF, [{
    key: "add",
    value: function add(listener) {
      var index = this.listeners.indexOf(listener);
      if (index === -1) {
        this.listeners.push(listener);
      }
    }
    /**
     *
     *
     * @param {any} listener
     *
     * @memberOf RAF
     */

  }, {
    key: "remove",
    value: function remove(listener) {
      var index = this.listeners.indexOf(listener);
      if (index !== -1) {
        this.listeners.splice(index, 1);
      }
    }
    /**
     *
     *
     *
     * @memberOf RAF
     */

  }, {
    key: "_update",
    value: function _update() {
      this.listeners.forEach(this._updateListener);
      window.requestAnimationFrame(this._update);
    }
    /**
     *
     *
     * @param {any} listener
     *
     * @memberOf RAF
     */

  }, {
    key: "_updateListener",
    value: function _updateListener(listener) {
      listener();
    }
  }]);

  return RAF;
}();

/* harmony default export */ __webpack_exports__["a"] = (new RAF());

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a2a8bec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1023);
function injectStyle (ssrContext) {
  __webpack_require__(623)
  __webpack_require__(625)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a2a8bec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a2a8bec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bpXs":"767","bpSm":"991","bpMd":"1199","bpLg":"1399","bpMlg":"1699","bpXmlg":"1700","bpXlg":"1800","bpXxlg":"5000","cBackground":"#f9f8f7","headerHeight":"50","conceptSelectorDesktopHeight":"150","conceptSelectorMobileTrackPercent":"50","conceptSelectorDesktopTrackPercent":"25","conceptContainerDesktopWidth":"600","conceptContainerMobileRight":"75","conceptContainerMobileLeft":"25"};

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atoms_VersionInfo_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organisms_ARMarkerInstructions__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_TotemCanvasAR__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_FirePrerenderEvent__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__molecules_TotemCanvas__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__molecules_ConceptsSelectionWheel__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__molecules_CanvasConceptsSelectionWheel__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__organisms_ConceptDetailsPanel__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__organisms_TotemSaveForm__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_GoogleHopeService__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__organisms_IntroScreen__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_filter__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__atoms_Stats__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__organisms_ConceptImportanceUI__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__organisms_AboutPage__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__organisms_SharePanel__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__organisms_FinalSharePanel__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__molecules_HeaderStonesContainer__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__atoms_TotemDotsIndicator__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__atoms_HintsContainer__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__atoms_IntroPageAR__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_RAF__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_ElasticNumber__ = __webpack_require__(78);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























// import DetectRTC from 'detectrtc'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',

  components: {
    VersionInfo: __WEBPACK_IMPORTED_MODULE_2__atoms_VersionInfo_vue__["a" /* default */],
    TotemCanvas: __WEBPACK_IMPORTED_MODULE_8__molecules_TotemCanvas__["a" /* default */],
    ConceptsSelectionWheel: __WEBPACK_IMPORTED_MODULE_9__molecules_ConceptsSelectionWheel__["a" /* default */],
    CanvasConceptsSelectionWheel: __WEBPACK_IMPORTED_MODULE_10__molecules_CanvasConceptsSelectionWheel__["a" /* default */],
    TotemCanvasAR: __WEBPACK_IMPORTED_MODULE_6__molecules_TotemCanvasAR__["a" /* default */],
    ARMarkerInstructions: __WEBPACK_IMPORTED_MODULE_5__organisms_ARMarkerInstructions__["a" /* default */],
    ConceptDetailsPanel: __WEBPACK_IMPORTED_MODULE_11__organisms_ConceptDetailsPanel__["a" /* default */],
    IntroScreen: __WEBPACK_IMPORTED_MODULE_14__organisms_IntroScreen__["a" /* default */],
    AboutPage: __WEBPACK_IMPORTED_MODULE_18__organisms_AboutPage__["a" /* default */],
    IntroPageAR: __WEBPACK_IMPORTED_MODULE_24__atoms_IntroPageAR__["a" /* default */],
    TotemSaveForm: __WEBPACK_IMPORTED_MODULE_12__organisms_TotemSaveForm__["a" /* default */],
    ConceptImportanceUI: __WEBPACK_IMPORTED_MODULE_17__organisms_ConceptImportanceUI__["a" /* default */],
    HeaderStonesContainer: __WEBPACK_IMPORTED_MODULE_21__molecules_HeaderStonesContainer__["a" /* default */],
    SharePanel: __WEBPACK_IMPORTED_MODULE_19__organisms_SharePanel__["a" /* default */],
    FinalSharePanel: __WEBPACK_IMPORTED_MODULE_20__organisms_FinalSharePanel__["a" /* default */],
    TotemDotsIndicator: __WEBPACK_IMPORTED_MODULE_22__atoms_TotemDotsIndicator__["a" /* default */],
    Stats: __WEBPACK_IMPORTED_MODULE_16__atoms_Stats__["a" /* default */],
    HintsContainer: __WEBPACK_IMPORTED_MODULE_23__atoms_HintsContainer__["a" /* default */],
    ElButton: __WEBPACK_IMPORTED_MODULE_25_element_ui_packages_button__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_FirePrerenderEvent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Viewport__["a" /* default */]],

  props: {
    // version string of this specific build
    version: {
      type: String,
      required: true
    },
    // commit hash of this specific build
    commitHash: {
      type: String,
      required: true
    },
    // this is the domain where the site will stay
    // it varies from build to build so the site can be built to be hosted
    // on various domains
    // it can be set by using
    // npm run build --domain="http://www.example.com"
    targetDomain: {
      type: String,
      required: true
    },
    // this is a flag set to true
    // by the build system (or if you build the site with --deploy)
    // use this to enable debug stuff that needs to be hidden in the deploy version
    deployFlag: {
      type: Boolean,
      required: true
    },
    // the preloader instance used by the root app
    // set preloader.visible to show it / hide it
    preloader: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      // this flag is used to show the app once the preloading
      // (if present) is finished
      isReady: false,
      // platform, accessible with an import statement
      // or by using this.$root.platform
      // NOTE: import statement is preferred
      platform: __WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */],
      concepts: [],
      selectedConcepts: [],
      wheelPositions: [],
      currentMode: 'intro',
      markerInstructionsShown: true,
      clickedConcept: null,
      openAbout: false,
      relatedTotems: [],
      backend: __WEBPACK_IMPORTED_MODULE_13__services_GoogleHopeService__["a" /* default */],
      currentlySelectedTotem: null,
      totemReady: false,
      canvasMultiTotem: 0,
      canvasExplodeTotem: 0,
      blockedResize: false,
      finalModelShow: false,
      arIntro: false,
      tooltips: [],
      preventTotemScrollHint: false,
      introTextVisible: false,
      totemData: {},
      // totemDragHintVisible: false,
      inactivityTime: 0,
      shareOpenAlpha: 0,
      elasticShareOpenAlpha: new __WEBPACK_IMPORTED_MODULE_28__utils_ElasticNumber__["a" /* default */](0),
      webRTCSupported: (!!window.RTCPeerConnection || !!window.mozRTCPeerConnection || !!window.webkitRTCPeerConnection) && !!navigator.mediaDevices
    };
  },

  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.backend.getCategories();

            case 2:
              _context.next = 4;
              return this.backend.getConcepts();

            case 4:
              this.concepts = _context.sent;


              this.elasticShareOpenAlpha.speed = 10;
              __WEBPACK_IMPORTED_MODULE_27__utils_RAF__["a" /* default */].add(function () {
                _this.elasticShareOpenAlpha.target = _this.shareOpenAlpha;
                _this.elasticShareOpenAlpha.update(1 / 60);
              });

              window.onbeforeunload = function () {
                return 'Are you sure you want to leave?';
              };

              // set this.isReady = true
              // when all stuff that needs to be loaded for the app is loaded
              // if you need to preload stuff, delete this line and set to true later
              this.isReady = true;

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),

  computed: {
    sharePanelStyle: function sharePanelStyle() {
      if (this.elasticShareOpenAlpha.value === 0) return {};
      return {
        transform: 'translate(' + (1 - this.elasticShareOpenAlpha.value) * 100 + '%, 0)'
      };
    },
    canvasStyle: function canvasStyle() {
      if (this.elasticShareOpenAlpha.value === 0) return {};
      return {
        filter: 'blur(' + Math.round(this.elasticShareOpenAlpha.value * 20) + 'px)'
      };
    },
    userTotem: function userTotem() {
      // generate totem data here
      var totem = this.backend.userTotem || this.backend.getTotemData(this.selectedConcepts);
      if (totem && totem.stones.length > 0) {
        // totem.id = 'user-totem'
        totem.position = { x: 0, z: 0 };
        return totem;
      }
      return null;
    },
    totems: function totems() {
      return this.userTotem ? [this.userTotem].concat(this.relatedTotems) : [];
    },
    confirmingConcept: function confirmingConcept() {
      var ret = null;
      this.selectedConcepts.some(function (concept) {
        // check if concept is not confirmed
        if (!concept.confirmed) {
          ret = concept;
          return true;
        }
      });
      return ret;
    },
    // check if the concept is confirmed
    confirmedConcepts: function confirmedConcepts() {
      return __WEBPACK_IMPORTED_MODULE_15_lodash_filter___default()(this.wheelPositions, { concept: { confirmed: true } });
    }
  },

  methods: {
    onScrollUp: function onScrollUp() {
      this.canvasMultiTotem = 1;
      this.canvasExplodeTotem = 0;
    },
    onScrollDown: function onScrollDown() {
      this.canvasMultiTotem = 0;
      this.canvasExplodeTotem = 1;
    },


    tooltipStyle: function tooltipStyle(tootip) {
      var color = tootip.categoryObject ? tootip.categoryObject.color : tootip.color;
      return {
        transform: 'translate(' + tootip.x + 'px, ' + tootip.y + 'px)',
        color: tootip ? '#' + color.toString(16) : null
      };
    },
    getTootipLabel: function getTootipLabel(label) {
      if (__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].mobile && label.length > 20) {
        return label.slice(0, 18) + '...';
      }

      return label;
    },
    onDownloadClick: function onDownloadClick() {
      this.arIntro = true;
    },
    onFocus: function onFocus() {
      this.blockedResize = true;
    },
    onBlur: function onBlur() {
      this.blockedResize = false;
    },
    onTotemSave: function onTotemSave(data) {
      this.totemData = data;
    },

    onConceptClick: function onConceptClick(concept) {
      // console.log('concept click', concept)
      this.clickedConcept = concept;
    },
    onFinalModelShow: function onFinalModelShow() {
      this.shareOpenAlpha = 1;
      this.openAbout = false;
      this.finalModelShow = true;
    },
    onFinalModelClose: function onFinalModelClose() {
      this.shareOpenAlpha = 0;
      this.openAbout = false;
      this.finalModelShow = false;
    },

    confirmConcept: function confirmConcept(concept) {
      concept.confirmed = true;
    },
    removeConcept: function removeConcept(concept) {
      concept.importance = 0.5;
      concept.confirmed = false;
      var index = this.selectedConcepts.indexOf(concept);
      if (index !== -1) {
        this.selectedConcepts.splice(index, 1);
      }
    },

    onAboutClick: function onAboutClick() {
      this.openAbout = true;
      this.shareOpenAlpha = 0;
    },
    onShareClick: function onShareClick() {
      var _this2 = this;

      this.shareOpenAlpha = 0;
      this.openAbout = false;
      this.finalModelShow = false;

      setTimeout(function () {
        _this2.shareOpenAlpha = 1;
      }, 500);
    },
    onShareClose: function onShareClose() {
      this.shareOpenAlpha = 0;
    },
    onConceptNext: function onConceptNext() {
      var allConcepts = [];
      this.currentlySelectedTotem.stones.forEach(function (stone) {
        stone.concepts.forEach(function (concept) {
          allConcepts.push(concept);
        });
      });

      var index = allConcepts.indexOf(this.clickedConcept);

      var nextConcept = allConcepts[(index + 1) % allConcepts.length];
      this.clickedConcept = nextConcept;
    },
    onConceptPrev: function onConceptPrev() {
      var allConcepts = [];
      this.currentlySelectedTotem.stones.forEach(function (stone) {
        stone.concepts.forEach(function (concept) {
          allConcepts.push(concept);
        });
      });

      var index = allConcepts.indexOf(this.clickedConcept);

      var circularIndex = index - 1 < 0 ? allConcepts.length - 1 : index - 1;

      var nextConcept = allConcepts[circularIndex];
      this.clickedConcept = nextConcept;
    },
    onAboutClose: function onAboutClose() {
      this.openAbout = false;
    },


    switchAR: function switchAR() {
      if (this.currentMode === 'ar') {
        if (!this.arIntro) {
          this.arIntro = true;
          return;
        }
      }

      this.clickedConcept = null;
      this.tooltips = [];
      this.currentMode = this.currentMode === 'ar' ? 'totem' : 'ar';
    },

    gotoSaveTotemForm: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var related, relatedData, middle, spacing;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.clickedConcept = null;
                this.currentMode = 'save';

                // retrieve related totems
                _context2.next = 4;
                return this.backend.getRelatedTotems(this.selectedConcepts);

              case 4:
                related = _context2.sent;


                // console.log('related:', related)

                relatedData = [];
                // const maxTotems = 5

                middle = (related.length - 1) / 2;
                spacing = 5;

                related.forEach(function (r, i) {
                  console.log('related:', r, i);
                  var totem = _this3.backend.getTotemData(r);
                  totem.id = 'related-totem ' + i + Math.random();
                  totem.label = r[0].name;
                  totem.position = { x: spacing * (i - middle), z: -10 };
                  relatedData.push(totem);
                });
                this.relatedTotems = relatedData;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function gotoSaveTotemForm() {
        return _ref2.apply(this, arguments);
      }

      return gotoSaveTotemForm;
    }()
  },

  watch: {
    currentMode: function currentMode(value) {
      var _this4 = this;

      if (value === 'wheel') {
        this.introTextVisible = true;
        __WEBPACK_IMPORTED_MODULE_26_lodash_delay___default()(function () {
          _this4.introTextVisible = false;
        }, 2000);
      }
    },
    isReady: function isReady(value) {
      // hide / show preloader
      this.preloader.visible = !value && this.backend.loading;
    },
    'backend.loading': function backendLoading(value) {
      // hide / show preloader
      this.preloader.visible = value || !this.isReady;
    }
  },

  metaInfo: function metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Building Hopes',
      // all titles will be injected into this template
      // titleTemplate: '%s | ' + 'Google Hope',
      base: { href: '/' },
      meta: [{ 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' }, { name: 'fragment', content: '!' }, { name: 'apple-mobile-web-app-capable', content: 'yes' }, { name: 'mobile-web-app-capable', content: 'yes' }, { name: 'msapplication-tap-highlight', content: 'no' }, { name: 'msapplication-TileColor', content: '#100E17' }, { name: 'msapplication-TileImage', content: '/ms-icon-144x144.png' }, { name: 'theme-color', content: '#100E17' },
      // twitter
      { name: 'twitter:card', content: 'photo' }, { name: 'twitter:title', content: 'What are you hopeful for?' }, { name: 'twitter:image', content: this.targetDomain + '/static/img/share-tw.jpg' }, { name: 'twitter:description', content: 'Build a sculpture with your hopes for the future and let it live forever in place that is meaningful for you, for others to find, explore, and interact with.' },
      // generic description
      { vmid: 'description', name: 'description', content: 'Build a sculpture with your hopes for the future and let it live forever in place that is meaningful for you, for others to find, explore, and interact with.' },
      // og tags
      { vmid: 'ogtype', property: 'og:type', content: 'website' }, { vmid: 'ogurl', property: 'og:url', content: this.targetDomain + this.$route.fullPath + '/' }, { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: 'What are you hopeful for?' }, { vmid: 'ogdescription', property: 'og:description', content: 'Build a sculpture with your hopes for the future and let it live forever in place that is meaningful for you, for others to find, explore, and interact with.' }, { vmid: 'ogimage', property: 'og:image', content: this.targetDomain + '/static/img/share-fb.jpg' }],
      htmlAttrs: {
        lang: this.$language.current
      }
    };
  }
});

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VersionInfo_vue__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290fa388_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VersionInfo_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290fa388"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VersionInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290fa388_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VersionInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VersionInfo',
  props: {
    version: {
      type: String,
      required: true,
      default: 'untagged',
      validator: function validator(value) {
        return value.length > 0;
      }
    },
    commitHash: {
      type: String,
      required: false,
      default: 'nohash',
      validator: function validator(value) {
        return value.length > 0;
      }
    }
  }
});

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"slide-in"}},[_c('aside',{staticClass:"version-info"},[_vm._v("v"+_vm._s(_vm.version))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ARMarkerInstructions_vue__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f55ff9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ARMarkerInstructions_vue__ = __webpack_require__(666);
function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17f55ff9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ARMarkerInstructions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f55ff9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ARMarkerInstructions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_packages_button__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ARMarkerInstructions',
  components: {
    ElButton: __WEBPACK_IMPORTED_MODULE_0_element_ui_packages_button__["a" /* default */]
  },
  data: function data() {
    return {
      markerLink: 'goo.gl/hope19537',
      markerShareTitle: 'Open this link!',
      supportsShareApi: navigator.share !== undefined && typeof navigator.share === 'function'
    };
  },
  props: {
    shown: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    shareApiCall: function shareApiCall() {
      navigator.share({ title: 'Google Hope', text: this.markerShareTitle, url: this.markerLink });
    }
  }
});

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc2ea35_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__(665);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc2ea35_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElButton',

  inject: {
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    },
    handleInnerClick: function handleInnerClick(evt) {
      if (this.disabled) {
        evt.stopPropagation();
      }
    }
  }
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
    {
      'is-disabled': _vm.disabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round
    }
  ],attrs:{"disabled":_vm.disabled,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading",on:{"click":_vm.handleInnerClick}}):_vm._e(),_vm._v(" "),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon,on:{"click":_vm.handleInnerClick}}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',{on:{"click":_vm.handleInnerClick}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-marker-instructions-outer"},[_c('div',{staticClass:"ar-marker-instructions"},[_c('div',{staticClass:"button-container"},[_c('el-button',{staticClass:"cancel-btn",on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("CANCEL")])],1),_vm._v(" "),_c('div',{staticClass:"centered-stuff"},[_c('h1',{staticClass:"title"},[_vm._v("You will have to use your phone’s camera and print out a marker.")]),_vm._v(" "),_c('img',{staticClass:"marker-img",attrs:{"src":"/static/img/marker.png"}}),_vm._v(" "),_c('el-button',{staticClass:"done-btn",on:{"click":function($event){_vm.$emit('update:shown', false)}}},[_vm._v("LET’S START")]),_vm._v(" "),_c('h2',[_vm._v("BY THE WAY")]),_vm._v(" "),_c('p',[_vm._v("Take this at whole different level, download our AR native app!")]),_vm._v(" "),_c('div',{staticClass:"app-download-btn"},[(_vm.$root.platform.android)?_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=it.accurat.BuildingHopes","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(169)}})]):_vm._e(),_vm._v(" "),(_vm.$root.platform.ios)?_c('a',{attrs:{"href":"https://itunes.apple.com/app/building-hopes/id1424884572?ls=1&mt=8","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(170)}})]):_vm._e()])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemCanvasAR_vue__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cfa166_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemCanvasAR_vue__ = __webpack_require__(795);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42cfa166"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemCanvasAR_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42cfa166_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemCanvasAR_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 668:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_Stats__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atoms_HopeTotem__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_RAF__ = __webpack_require__(45);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import ControlKit from '@/atoms/ControlKit'



// import FirePrerenderEvent from '@/mixins/FirePrerenderEvent'


/* global THREE */
// import 'three/OrbitControls'
window.THREE = THREE;

/* global THREEx */
/* eslint-disable */
__webpack_require__(779);
__webpack_require__(781);
__webpack_require__(783);
__webpack_require__(785);
THREEx.ArToolkitContext.baseURL = '/';
__webpack_require__(787);
__webpack_require__(789);
__webpack_require__(791);
__webpack_require__(793);
/* eslint-enable */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TotemCanvasAR',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Viewport__["a" /* default */]],

  components: {
    Stats: __WEBPACK_IMPORTED_MODULE_0__atoms_Stats__["a" /* default */]
    // ControlKit
  },

  props: {
    totemData: {
      type: Object,
      required: false
    }
  },

  data: function data() {
    var _this = this;

    return {
      totemDistanceFromCamera: 100,
      totemVisible: false,

      controllableData: {
        numTotems: {
          label: 'Totems',
          type: 'InputNumber',
          range: [1, 10],
          step: 1,
          value: 10,
          onUpdate: function onUpdate(value) {
            _this._totems.forEach(function (totem, index) {
              if (index < value) {
                totem.visible = true;
              } else {
                totem.visible = false;
              }
            });
          }
        },
        shadowEnabled: {
          label: 'Shadows',
          type: 'Checkbox',
          value: false,
          onUpdate: function onUpdate(value) {
            _this._renderer.shadowMap.enabled = value;
            _this.shadowPlane.visible = value;
          }
        },
        shadowType: {
          label: 'Shadow Quality',
          type: 'Select',
          value: THREE.PCFSoftShadowMap,
          choices: [{
            label: 'BasicShadowMap',
            value: THREE.BasicShadowMap
          }, {
            label: 'PCFShadowMap',
            value: THREE.PCFShadowMap
          }, {
            label: 'PCFSoftShadowMap',
            value: THREE.PCFSoftShadowMap
          }],
          onUpdate: function onUpdate(value) {
            _this._renderer.shadowMap.type = value;
            _this.shadowPlane.material.needsUpdate = true;
          }
        },
        debug: {
          label: 'Debug Collisions',
          type: 'Checkbox',
          value: false,
          onUpdate: function onUpdate(value) {
            _this._totems.forEach(function (totem) {
              totem.debug = value;
            });
          }
        },
        collisionLOD: {
          label: 'Collisions LOD Level',
          type: 'InputNumber',
          range: [0, 2],
          step: 1,
          value: 0,
          onUpdate: function onUpdate(value) {
            _this._totems.forEach(function (totem) {
              totem.collisionLOD = value;
            });
          }
        },
        rotate: {
          label: 'Rotate Stones',
          type: 'Checkbox',
          value: true,
          onUpdate: function onUpdate(value) {
            _this._totems.forEach(function (totem) {
              totem.rotate = value;
            });
          }
        },
        oscillate: {
          label: 'Oscillate Stones',
          type: 'Checkbox',
          value: false,
          onUpdate: function onUpdate(value) {
            _this._totems.forEach(function (totem) {
              totem.oscillate = value;
            });
          }
        }
      }
    };
  },

  mounted: function mounted() {
    var _this2 = this;

    if (!__WEBPACK_IMPORTED_MODULE_2__platform__["a" /* default */].prerenderer) {
      this._renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: this.$refs.threeCanvas,
        alpha: true
      });

      this._clock = new THREE.Clock();
      this._renderer.toneMapping = THREE.LinearToneMapping;
      this._renderer.setClearColor(0xffffff, 0);
      // this._renderer.setPixelRatio(window.devicePixelRatio)
      this._renderer.setSize(this.viewPort.width, this.viewPort.height);
      this._renderer.shadowMap.enabled = this.controllableData.shadowEnabled;
      this._renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      /*
      this._camera = new THREE.PerspectiveCamera(50, this.viewPort.width / this.viewPort.height, 1, 25000)
      this._camera.position.z = 15
      this._camera.position.y = 3
      */
      this._camera = new THREE.Camera();

      this._scene = new THREE.Scene();

      this._totems = [];

      var materials = [];
      for (var _i = 0; _i < 10; _i++) {
        materials.push(new THREE.MeshToonMaterial({
          color: Math.random() * 0xffffff,
          specular: new THREE.Color(0x000000),
          shininess: 0
        }));
      }
      /*
      for (let i = 0; i < this.controllableData.numTotems.range[1]; i++) {
        // let totem = new HopeTotem(2 + Math.ceil(Math.random() * 8))
        let totem = new HopeTotem(10, materials)
        totem.position.x = THREE.Math.randFloatSpread(10)
        totem.position.z = THREE.Math.randFloatSpread(10)
        this._scene.add(totem)
        this._totems.push(totem)
        totem.visible = false
      }
      */
      this.shadowPlane = new THREE.Mesh(new THREE.PlaneGeometry(100, 100), new THREE.ShadowMaterial({ opacity: 0.2 }));
      this.shadowPlane.rotation.x = -Math.PI / 2;
      // this.shadowPlane.position.y = -0.5
      this.shadowPlane.receiveShadow = true;
      this._scene.add(this.shadowPlane);

      this.light = new THREE.DirectionalLight();
      this.light.castShadow = true;
      this.light.shadow.mapSize.width = 512;
      this.light.shadow.mapSize.height = 512;
      this.light.shadow.camera.far = 1000;
      this.light.shadow.camera.left = -6;
      this.light.shadow.camera.right = 6;
      this.light.shadow.camera.top = 6;
      this.light.shadow.camera.bottom = -6;
      this.light.position.set(-30, 30, 30);

      this._scene.add(this.light);
      /*
      this._controls = new THREE.OrbitControls(this._camera)
      this._controls.target.set(0, this._camera.position.y, 0)
      */
      for (var val in this.controllableData) {
        this.controllableData[val].onUpdate(this.controllableData[val].value);
      }

      /// /////////////////////////////////////////////////////////////////////////////
      //          initialize arToolkit
      /// /////////////////////////////////////////////////////////////////////////////

      this._arToolkitSource = new THREEx.ArToolkitSource({
        sourceType: 'webcam'

        // to read from an image
        // sourceType : 'image',
        // sourceUrl : THREEx.ArToolkitContext.baseURL + '../data/images/img.jpg',
        // sourceUrl : THREEx.ArToolkitContext.baseURL + '../data/images/armchair.jpg',

        // to read from a video
        // sourceType : 'video',
        // sourceUrl : THREEx.ArToolkitContext.baseURL + '../data/videos/headtracking.mp4',
      });
      this._arToolkitSource.init(function () {
        _this2.onResize();
        _this2._arToolkitSource.domElement.style.zIndex = 0;
        _this2.$refs.arSource.appendChild(_this2._arToolkitSource.domElement);
        _this2._arToolkitSource.domElement.play();
      });

      // create atToolkitContext
      this._arToolkitContext = new THREEx.ArToolkitContext({
        cameraParametersUrl: THREEx.ArToolkitContext.baseURL + 'static/data/camera_para.dat',
        // debug: true,
        // detectionMode: 'mono_and_matrix',
        detectionMode: 'mono',
        // detectionMode: 'color_and_matrix',
        // matrixCodeType: '3x3',

        canvasWidth: 80 * 3,
        canvasHeight: 60 * 3,

        maxDetectionRate: 30
      });
      // initialize it
      this._arToolkitContext.init(function () {
        // copy projection matrix to camera
        _this2._camera.projectionMatrix.copy(_this2._arToolkitContext.getProjectionMatrix());
      });

      this._markerRoot = new THREE.Group();
      this._scene.add(this._markerRoot);
      this._markerControls = new THREEx.ArMarkerControls(this._arToolkitContext, this._markerRoot, {
        // type: 'barcode',
        // barcodeValue: 5,

        type: 'pattern',
        // patternUrl: THREEx.ArToolkitContext.baseURL + 'static/data/barno-marker.patt'
        patternUrl: THREEx.ArToolkitContext.baseURL + 'static/data/pattern-marker.patt'
        // https://jeromeetienne.github.io/AR.js/three.js/examples/marker-training/examples/generator.html
        // for creating custom markers
      });

      // build a smoothedControls
      var smoothedRoot = new THREE.Group();
      this._scene.add(smoothedRoot);
      this._smoothedControls = new THREEx.ArSmoothedControls(smoothedRoot, {
        lerpPosition: 0.4,
        lerpQuaternion: 0.3,
        lerpScale: 1
        // minVisibleDelay: 1,
        // minUnvisibleDelay: 1,
      });

      var userTotemData = this.totemData;
      if (!userTotemData) {
        // create a testing totem
        userTotemData = {
          id: 'ar-totem',
          position: { x: 0, z: 0 },
          stones: []
        };
        for (var i = 0; i < 6; i++) {
          var stoneData = {
            averageActivity: Math.random(),
            color: Math.random() * 0xffffff,
            concepts: []
          };
          for (var k = 0; k < Math.ceil(Math.random() * 4); k++) {
            stoneData.concepts.push({
              activity: Math.random(),
              category: i,
              id: k,
              importance: 0,
              label: 'test'
            });
          }
          userTotemData.stones.push(stoneData);
        }
      }

      var totem = new __WEBPACK_IMPORTED_MODULE_3__atoms_HopeTotem__["a" /* default */](userTotemData, true);
      totem.scale.set(0.4, 0.4, 0.4);
      this._totems.push(totem);
      smoothedRoot.add(totem);
      smoothedRoot.add(this.light);
      smoothedRoot.add(this.shadowPlane);
      /*
      var geometry = new THREE.CubeGeometry(1, 1, 1)
      var material = new THREE.MeshNormalMaterial({
        transparent: true,
        opacity: 0.5,
        side: THREE.DoubleSide
      })
      var mesh = new THREE.Mesh(geometry, material)
      mesh.position.y = geometry.parameters.height / 2
      smoothedRoot.add(mesh)
      */
      __WEBPACK_IMPORTED_MODULE_4__utils_RAF__["a" /* default */].add(this.render);
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this._arToolkitSource.domElement.srcObject) {
      this._arToolkitSource.domElement.srcObject.getTracks().forEach(function (track) {
        return track.stop();
      });
    }
    this._scene.traverse(this.destroySceneChildren);
    this._renderer.dispose();
    this._renderer.forceContextLoss();
    __WEBPACK_IMPORTED_MODULE_4__utils_RAF__["a" /* default */].remove(this.render);
  },
  computed: {
    videoStyle: function videoStyle() {
      // distance : 8 = x :
      // let distanceBlurAmount = Math.max(0, 8 - this.totemDistanceFromCamera) * 1.5
      // let blurAmount = this.totemVisible ? distanceBlurAmount : 0
      return {
        // filter: `grayscale(100%) contrast(110%) blur(${blurAmount}px)`
        filter: 'grayscale(100%) contrast(110%)'
      };
    }
  },

  methods: {
    destroySceneChildren: function destroySceneChildren(value) {
      if (typeof value.destroy === 'function') {
        value.destroy();
      } else {
        if (value.geometry) {
          value.geometry.dispose();
        }
        if (value.material) {
          if (value.material.map) {
            value.material.map.dispose();
          }
          value.material.dispose();
        }
      }
    },
    render: function render() {
      var delta = this._clock.getDelta();
      this._renderer.render(this._scene, this._camera);

      // console.log(new Date().getTime())

      if (this._totems) {
        for (var i = 0; i < this._totems.length; i++) {
          if (this._totems[i].visible) {
            this._totems[i].update(delta);
          }
        }
      }

      if (this._arToolkitSource.ready) {
        this._arToolkitContext.update(this._arToolkitSource.domElement);
      }
      this._smoothedControls.update(this._markerRoot);

      this.totemVisible = this._markerRoot.visible;
      this.totemDistanceFromCamera = this._markerRoot.position.distanceTo(this._camera.position);
      // console.log(this._markerRoot.visible, this._markerRoot.position.distanceTo(this._camera.position))
    },
    onMouseDown: function onMouseDown(event) {},
    onMouseUp: function onMouseUp(event) {},
    onMouseMove: function onMouseMove(event) {},
    onResize: function onResize() {
      if (this._renderer) {
        //   this._renderer.setPixelRatio(window.devicePixelRatio)
        this._renderer.setSize(this.viewPort.width, this.viewPort.height);
      }

      // if (this._camera) {
      //   this._camera.aspect = this.viewPort.width / this.viewPort.height
      //   this._camera.updateProjectionMatrix()
      // }

      this._arToolkitSource.onResizeElement();
      this._arToolkitSource.copyElementSizeTo(this._renderer.domElement);
      if (this._arToolkitContext.arController !== null) {
        this._arToolkitSource.copyElementSizeTo(this._arToolkitContext.arController.canvas);
      }
      this._camera.projectionMatrix.copy(this._arToolkitContext.getProjectionMatrix());
    }
  },

  watch: {
    viewPort: function viewPort() {
      this.onResize();
    }
  },

  metaInfo: function metaInfo() {
    return {
      // home page browser title
      title: 'Home Page'
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);


//
//
// use this mixin when you want a component to be aware of the window.innerWidth and window.innerHeight
//
// USAGE:
//
// watch : {
//   viewPort: function (value) {
//      console.log(value.width, value.height)
//   }
// }
// to observe window size and react accordingly
//
//
/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {
      viewPort: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
  },

  mounted: function mounted() {
    this.__updateViewPort = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.__updateViewPort, 50);
    window.addEventListener('resize', this.__updateViewPort);
    this.__updateViewPort();
  },

  activated: function activated() {
    window.addEventListener('resize', this.__updateViewPort);
    this.__updateViewPort();
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.__updateViewPort);
  },

  deactivated: function deactivated() {
    window.removeEventListener('resize', this.__updateViewPort);
  },

  methods: {
    __updateViewPort: function __updateViewPort() {
      // console.log(this.$options.name, 'on resize')
      this.viewPort = {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
  }
});

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three_examples_js_libs_stats_min__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three_examples_js_libs_stats_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_three_examples_js_libs_stats_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_RAF__ = __webpack_require__(45);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Stats',

  data: function data() {
    return {
      stats: new __WEBPACK_IMPORTED_MODULE_0_three_examples_js_libs_stats_min___default.a()
    };
  },

  mounted: function mounted() {
    this.$refs.container.appendChild(this.stats.domElement);
    __WEBPACK_IMPORTED_MODULE_1__utils_RAF__["a" /* default */].add(this.onUpdate);
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__utils_RAF__["a" /* default */].remove(this.render);
  },
  methods: {
    onUpdate: function onUpdate() {
      this.stats.end();
      this.stats.begin();
    }
  }
});

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"stats"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atoms_HopeConceptStone__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atoms_HopeStoneTexture__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_applyToonLighting__ = __webpack_require__(97);





/* global THREE */




// import anime from 'animejs'

var HopeCategoryStone = function (_THREE$Group) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HopeCategoryStone, _THREE$Group);

  //
  function HopeCategoryStone(config, material) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HopeCategoryStone);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HopeCategoryStone.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HopeCategoryStone)).call(this));

    _this.unexplodedStone = new __WEBPACK_IMPORTED_MODULE_5__atoms_HopeConceptStone__["a" /* default */](config, material, true);
    // this.unexplodedStone.setVisible(false)
    _this.unexplodedStone.setVisible(true);
    _this.add(_this.unexplodedStone);

    _this._explodedStones = [];

    _this._exploded = false;
    _this.config = config;
    _this.exploded = false;
    _this._debug = false;
    _this._rotate = true;
    _this._spacing = 0;
    _this._oscillate = true;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HopeCategoryStone, [{
    key: 'setY',
    value: function setY(value) {
      this.unexplodedStone.position.y = this.unexplodedStone.elasticPosition.y = this.unexplodedStone.elasticPosition.value.y = value;
    }
  }, {
    key: 'getY',
    value: function getY() {
      return this.unexplodedStone.position.y;
    }
  }, {
    key: 'hasConcept',
    value: function hasConcept(concept) {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(this.config.concepts, { id: concept.id }) !== undefined;
    }
  }, {
    key: 'findConceptStoneByConcept',
    value: function findConceptStoneByConcept(concept) {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(this._explodedStones, { config: { id: concept.id } });
    }
  }, {
    key: 'createExplodedStones',
    value: function createExplodedStones() {
      var _this2 = this;

      // add/update stones
      this.config.concepts.forEach(function (concept) {
        var existingStone = _this2.findConceptStoneByConcept(concept);
        if (!existingStone) {
          var stone = new __WEBPACK_IMPORTED_MODULE_5__atoms_HopeConceptStone__["a" /* default */](concept, new THREE.MeshToonMaterial({
            specular: new THREE.Color(0x000000),
            shininess: 0,
            map: new __WEBPACK_IMPORTED_MODULE_6__atoms_HopeStoneTexture__["a" /* default */](_this2.config.color, 1),
            transparent: false
          }));
          stone.material.onBeforeCompile = __WEBPACK_IMPORTED_MODULE_8__utils_applyToonLighting__["a" /* default */];
          if (_this2._explodedStones.length > 0) {
            stone.elasticPosition.y = stone.position.y = _this2._explodedStones[_this2._explodedStones.length - 1].position.y + 0.25;
          } else {
            stone.elasticPosition.y = stone.position.y = _this2.unexplodedStone.y - 0.25;
          }
          stone.debug = false;
          stone.rotate = true;
          stone.oscillate = true;
          stone.activeCollisionLOD = _this2._activeCollisionLOD;
          stone.setVisible(_this2._exploded);
          _this2.add(stone);
          _this2._explodedStones.push(stone);
        } else {
          existingStone.config = concept;
        }
      });
    }
  }, {
    key: 'update',
    value: function update(parent, delta) {
      if (!this.exploded) {
        this.unexplodedStone.update(parent, delta);
      } else {
        for (var i = 0; i < this._explodedStones.length; i++) {
          if (i === 0) {
            this._explodedStones[i].update(parent, delta);
          } else {
            this._explodedStones[i].update(this._explodedStones[i - 1], delta);
          }
        }
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unexplodedStone.destroy();
      this.remove(this.unexplodedStone);
      this.unexplodedStone = null;
      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].destroy();
        this.remove(this._explodedStones[i]);
      }
      this._explodedStones = [];
    }
  }, {
    key: 'explodedStones',
    get: function get() {
      return this._explodedStones;
    }
  }, {
    key: 'exploded',
    get: function get() {
      return this._exploded;
    },
    set: function set(value) {
      this._exploded = value;
      // create exploded stones on demand
      if (this._exploded === true && this._explodedStones.length < this.config.concepts.length) {
        this.createExplodedStones();
      }

      this.unexplodedStone.setVisible(!value);

      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].setVisible(value);
        if (i === 0) {
          this._explodedStones[i].position.y = this._explodedStones[i].elasticPosition.y = this.unexplodedStone.position.y - 0.25;
        } else {
          this._explodedStones[i].position.y = this._explodedStones[i].elasticPosition.y = this._explodedStones[i - 1].position.y + 0.25;
        }
      }
    }
  }, {
    key: 'config',
    get: function get() {
      return this._config;
    },
    set: function set(value) {
      this._config = value;
      // unexploded
      this.unexplodedStone.config = value;

      // inverse loop for removing unused exploded stone
      for (var i = this._explodedStones.length - 1; i >= 0; i--) {
        var stone = this._explodedStones[i];
        if (!__WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(value.concepts, { id: stone.config.id })) {
          stone.destroy();
          this.remove(stone);
          this._explodedStones.splice(i, 1);
        }
      }
      // this.createExplodedStones()
    }
  }, {
    key: 'activeCollisionLOD',
    get: function get() {
      return this._activeCollisionLOD;
    },
    set: function set(value) {
      this._activeCollisionLOD = value;
      this.unexplodedStone.activeCollisionLOD = value;

      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].activeCollisionLOD = value;
      }
    }
  }, {
    key: 'collisionMesh',
    get: function get() {
      return this.unexplodedStone.collisionMesh;
    }
  }, {
    key: 'debug',
    get: function get() {
      return this._debug;
    },
    set: function set(value) {
      this._debug = value;
      this.unexplodedStone.debug = value;
      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].debug = value;
      }
    }
  }, {
    key: 'rotate',
    get: function get() {
      return this._rotate;
    },
    set: function set(value) {
      this._rotate = value;
      this.unexplodedStone.rotate = value;
      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].rotate = value;
      }
    }
  }, {
    key: 'spacing',
    get: function get() {
      return this._spacing;
    },
    set: function set(value) {
      this._spacing = value;
      this.unexplodedStone.spacing = value;
      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].spacing = value;
      }
    }
  }, {
    key: 'oscillate',
    get: function get() {
      return this._oscillate;
    },
    set: function set(value) {
      this._oscillate = value;
      this.unexplodedStone.oscillate = value;
      for (var i = 0; i < this._explodedStones.length; i++) {
        this._explodedStones[i].oscillate = value;
      }
    }
  }, {
    key: 'upperCollider',
    get: function get() {
      if (this.exploded) {
        return this._explodedStones[this._explodedStones.length - 1];
      }
      return this.unexplodedStone;
    }
  }]);

  return HopeCategoryStone;
}(THREE.Group);

/* harmony default export */ __webpack_exports__["a"] = (HopeCategoryStone);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);






/* global THREE */

var HopeTotemLabel = function (_THREE$Mesh) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HopeTotemLabel, _THREE$Mesh);

  function HopeTotemLabel() {
    var labelText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HopeTotemLabel);

    var width = 3; // 2
    var height = 0.75; // 0.5
    var geom = new THREE.PlaneBufferGeometry(width, height, 1, 1);
    geom.translate(0, height / 2, 0);

    var canvas = document.createElement('canvas');
    canvas.width = 1024;
    canvas.height = 256;
    var material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      map: new THREE.Texture(canvas)
    });
    material.onBeforeCompile = function (mat) {
      mat.fragmentShader = mat.fragmentShader.replace('#include <fog_fragment>', '#ifdef USE_FOG\nfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n gl_FragColor.a *= 1.0 - fogFactor;\n#endif');
    };

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HopeTotemLabel.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HopeTotemLabel)).call(this, geom, material));

    _this.canvas = canvas;
    // this.draw(labelText)
    _this._labelText = labelText;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HopeTotemLabel, [{
    key: 'disable',
    value: function disable() {
      var ctx = this.canvas.getContext('2d');
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      ctx.font = '600 76px Muli';
      ctx.fillStyle = 'rgb(97, 97, 97)';
      ctx.textAlign = 'center';
      ctx.fillText(this._labelText.toUpperCase(), this.canvas.width / 2, this.canvas.height / 2);

      this.material.map.needsUpdate = true;
    }
  }, {
    key: 'enable',
    value: function enable() {
      var ctx = this.canvas.getContext('2d');
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      ctx.font = '600 76px Muli';
      ctx.fillStyle = 'rgb(97, 97, 97)';
      ctx.textAlign = 'center';
      ctx.fillText(this._labelText.toUpperCase(), this.canvas.width / 2, this.canvas.height / 2);

      ctx.font = '400 65px Muli';
      ctx.fillStyle = '#b4b4b4';

      ctx.fillText(this._labelTextSubtitle, this.canvas.width / 2, this.canvas.height / 1.2);

      this.material.map.needsUpdate = true;
    }
  }, {
    key: 'draw',
    value: function draw(labelText) {
      var subtitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Your hopes, by topic';

      var ctx = this.canvas.getContext('2d');

      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this._labelTextSubtitle = subtitle;

      // ctx.fillStyle = '#ff0000'
      // ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)

      ctx.font = '600 76px Muli';
      ctx.fillStyle = 'rgb(97, 97, 97)';
      ctx.textAlign = 'center';
      ctx.fillText(labelText.toUpperCase(), this.canvas.width / 2, this.canvas.height / 2);

      ctx.font = '400 65px Muli';
      ctx.fillStyle = '#b4b4b4';
      ctx.fillText(subtitle, this.canvas.width / 2, this.canvas.height / 1.2);

      // let triangleSize = 50
      // ctx.moveTo(this.canvas.width / 2, this.canvas.height)
      // ctx.lineTo((this.canvas.width / 2) - triangleSize, this.canvas.height - triangleSize)
      // ctx.lineTo((this.canvas.width / 2) + triangleSize, this.canvas.height - triangleSize)
      // ctx.fill()

      this.material.map.needsUpdate = true;
    }
  }]);

  return HopeTotemLabel;
}(THREE.Mesh);

/* harmony default export */ __webpack_exports__["a"] = (HopeTotemLabel);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ElasticNumber = function () {
  function ElasticNumber(value) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ElasticNumber);

    this.value = value;
    this.target = value;
    this.speed = 3;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ElasticNumber, [{
    key: "update",
    value: function update(delta) {
      delta = Math.min(delta, 1 / 10);

      var dist = this.target - this.value;

      this.value += dist * (this.speed * delta);
    }
  }]);

  return ElasticNumber;
}();

/* harmony default export */ __webpack_exports__["a"] = (ElasticNumber);

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-view"},[_c('div',{ref:"arSource",staticClass:"ar-source",style:(_vm.videoStyle)}),_vm._v(" "),_c('canvas',{ref:"threeCanvas",staticClass:"three-canvas",on:{"mousedown":function($event){_vm.onMouseDown($event)},"mousemove":function($event){_vm.onMouseMove($event)},"mouseup":function($event){_vm.onMouseUp($event)},"touchstart":function($event){_vm.onMouseDown($event)},"touchmove":function($event){$event.preventDefault();_vm.onMouseMove($event)},"touchend":function($event){_vm.onMouseUp($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(40);

//
//
// use this mixin when a page is included in the prerenderer paths
// this allows the pre-renderer to capture the page after 1 second it's mounted.
//
// A page not using this mixin will be captured anyways after a maximum of 10 seconds but it will slow down the build times
//
// USAGE:
//
// include this in the mixin objects of the page. That's it
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0__platform__["a" /* default */].prerenderer) {
      setTimeout(function () {
        document.dispatchEvent(new Event('custom-post-render-event'));
      }, 1000);
    }
  }
});

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemCanvas_vue__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ae4977_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemCanvas_vue__ = __webpack_require__(851);
function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03ae4977"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemCanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03ae4977_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemCanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 798:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atoms_HopeTotem__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atoms_CameraController__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atoms_HopeConceptStone__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atoms_HopeStoneTexture__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ElasticNumber__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_RAF__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_MouseWheelInertiaDetector__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_Gyroscope__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_findIndex__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_animejs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_normalizeWheel__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_applyToonLighting__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_GoogleHopeService__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__variables_scss__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_three_OrbitControls__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_three_OrbitControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_three_OrbitControls__);


//
//
//
//
//
//
//
//
//
//
//
//
//





















/* global THREE */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TotemCanvas',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Viewport__["a" /* default */]],

  props: {

    /*
     array of
     {
      position: {x, z}
      stones: [
        {
          color: Number
          label : String
          concepts: [id, id, id, ...]
        }, ...
      ]
    }, ...
     */
    totems: {
      type: Array,
      required: true
    },
    // one of totem OR wheel
    mode: {
      type: String,
      required: true,
      default: 'wheel'
    },
    blockedResize: {
      type: Boolean,
      required: false,
      defualt: false
    },
    // stones rotating in the wheel
    wheelConcepts: {
      type: Array,
      required: false
    },
    // concepts selected by the user
    selectedConcepts: {
      type: Array,
      required: false
    },
    // currently selected totem
    currentTotem: {
      type: Object,
      required: false
    },
    wheelBlock: {
      type: Boolean,
      required: false
    },
    detailsPanelConcept: {
      required: true
    },
    multiTotem: {
      required: false
    },
    explodeTotem: {
      required: false
    },
    // dragHintVisible: {
    //   type: Boolean,
    //   required: false
    // },
    tooltips: {
      type: Array,
      required: false
    },
    inactivityTime: {
      type: Number,
      required: false
    },
    shareOpenAlpha: {
      type: Number,
      required: false,
      default: 0 // 0 - 1
    }
  },

  data: function data() {
    return {
      mouse: new THREE.Vector2(),
      mouseDown: new THREE.Vector2(),
      // mouseOnMultitotemAlpha0: new THREE.Vector2(),
      hasMouseOverStone: null,
      inForeground: false,
      animatingTopStones: false,
      currentTotemExploded: false,
      animatingWidth: false,
      finalModalShow: false,
      compareModePassed: false,
      takingScreenshot: false,
      isMouseDown: false,
      isMouseWheelActive: false,
      elasticWheel: new __WEBPACK_IMPORTED_MODULE_8__utils_ElasticNumber__["a" /* default */](0),
      doScreenshot: false, // set manually to true if you want the scene to be ready for a screenshot of background totems
      gyroscope: __WEBPACK_IMPORTED_MODULE_11__utils_Gyroscope__["a" /* default */]
    };
  },

  mounted: function mounted() {
    this._wheelConceptStones = [];
    this._totems = [];
    this._fixedTopConceptStones = [];
    this._fixedCenteredConceptStone = null;
    this._explodedStone = null;
    this._backgroundTotemPlanes = [];
    this._backgroundTotemsOffset = new __WEBPACK_IMPORTED_MODULE_8__utils_ElasticNumber__["a" /* default */](0); // from -x to +x

    this._mouseWheelInertiaDetector = new __WEBPACK_IMPORTED_MODULE_10__utils_MouseWheelInertiaDetector__["a" /* default */]();
    this._wheelFogNear = 50;
    this._wheelFogFar = 60;

    this._singleTotemFogNear = 10;
    this._singleTotemFogFar = 15;

    this._multiTotemFogNear = 20;
    this._multiTotemFogFar = 55;

    this._elasticFogNear = new __WEBPACK_IMPORTED_MODULE_8__utils_ElasticNumber__["a" /* default */](this._wheelFogNear);
    this._elasticFogFar = new __WEBPACK_IMPORTED_MODULE_8__utils_ElasticNumber__["a" /* default */](this._wheelFogFar);

    if (!__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].prerenderer) {
      this._renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: this.$refs.threeCanvas,
        alpha: true,
        gammaFactor: 10,
        gammaInput: true,
        gammaOutput: true,
        preserveDrawingBuffer: true
      });
      this._raycaster = new THREE.Raycaster();
      this._clock = new THREE.Clock();
      // this._renderer.toneMapping = THREE.LinearToneMapping
      this._renderer.setClearColor(0x000000, 0);
      this._renderer.setPixelRatio(window.devicePixelRatio);
      this._renderer.setSize(this.viewPort.width, this.viewPort.height);
      // this._renderer.shadowMap.enabled = true // !this.doScreenshot
      // this._renderer.shadowMap.type = THREE.PCFSoftShadowMap
      this._renderer.autoClear = false;

      this._totemScene = new THREE.Scene();
      this._totemCamera = new THREE.PerspectiveCamera(50, this.viewPort.width / this.viewPort.height, 1, 500);
      this._totemCamera.position.z = 8;
      this._totemCamera.position.y = 1.3;
      this._totemCamera.rotation.x = -0.02;
      this._totemScene.add(this._totemCamera);

      if (!this.doScreenshot) {
        this._totemScene.fog = new THREE.Fog(new THREE.Color(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.cBackground).getHex(), this._singleTotemFogNear, this._singleTotemFogFar);
      }

      var shadowMat = new THREE.MeshBasicMaterial();
      // let shadowMat = new THREE.ShadowMaterial({opacity: 0.1})
      // if (!this.doScreenshot) {
      //   shadowMat.onBeforeCompile = function (mat) {
      //     mat.fragmentShader = mat.fragmentShader.replace('#include <fog_fragment>', 'float fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n gl_FragColor.a *= 1.0 - fogFactor;')
      //   }
      // }

      this._totemGround = new THREE.Mesh(new THREE.PlaneBufferGeometry(100, 100), shadowMat);
      this._totemGround.rotation.x = -Math.PI / 2;
      this._totemGround.position.y = -0.5;
      this._totemGround.visible = false;
      // this._totemGround.receiveShadow = true
      this._totemScene.add(this._totemGround);

      this._totemLight = new THREE.DirectionalLight();
      // this._totemLight.castShadow = true
      // this._totemLight.shadow.mapSize.width = 512
      // this._totemLight.shadow.mapSize.height = 512
      // this._totemLight.shadow.camera.far = 200
      // this._totemLight.shadow.camera.left = -20
      // this._totemLight.shadow.camera.right = 25
      // this._totemLight.shadow.camera.top = 20
      // this._totemLight.shadow.camera.bottom = -7
      this._totemLight.position.set(20, 30, 20);

      this._totemScene.add(this._totemLight);

      this._singleTotemRadius = this.doScreenshot ? this._totemCamera.position.z * 2 : this._totemCamera.position.z;
      this._singleTotemTarget = new THREE.Vector3(0, this._totemCamera.position.y, 0);
      this._singleTotemTheta = -0.1;

      this._multiTotemRadius = this._singleTotemRadius + 2;
      this._multiTotemTarget = new THREE.Vector3(0, this._singleTotemTarget.y + 3, 2);
      this._multiTotemTheta = -0.5;

      // this.multiTotem = 0
      this._downMultiTotemAlpha = 0;
      this._downShareOpenAlpha = 0;
      this._explodeTotemAlpha = 0;

      this._controls = new __WEBPACK_IMPORTED_MODULE_5__atoms_CameraController__["a" /* default */](this._totemCamera, this.viewPort);
      this._controls.radius = this._singleTotemRadius;
      this._controls.target.copy(this._singleTotemTarget);
      this._controls.theta = this._singleTotemTheta;
      this._controls.thetaMax = 0.1;
      this._controls.phiMin = -0.5;
      this._controls.phiMax = 0.5;
      this._controls.mouseEnabled = false;

      // create background planes
      if (!this.doScreenshot) {
        for (var i = 0; i < 3; i++) {
          var numPlanes = 15 * (i + 1);
          var middle = (numPlanes - 1) / 2;
          var spacing = 5;
          for (var k = 0; k < numPlanes; k++) {
            var plane = this.createBackgroundTotemPlane();
            plane.position.z = -20 - 10 * i - Math.random() * 7;
            plane.position.x = spacing * (k - middle) + (0.5 - Math.random()) * 2;
            // plane.rotation.y = Math.random() < 0.5 ? 0 : Math.PI
            // plane.material.side = plane.rotation.y === 0 ? THREE.FrontSide : THREE.BackSide
            plane.visible = false;
            this._totemScene.add(plane);
            this._backgroundTotemPlanes.push(plane);
          }
        }
      }

      // wheel scene
      this._wheelScene = new THREE.Scene();
      this._wheelLight = new THREE.DirectionalLight();
      // this._wheelLight.castShadow = true
      // this._wheelLight.shadow.mapSize.width = 512
      // this._wheelLight.shadow.mapSize.height = 512
      // this._wheelLight.shadow.camera.far = 5
      // this._wheelLight.shadow.camera.left = -6
      // this._wheelLight.shadow.camera.right = 6
      // this._wheelLight.shadow.camera.top = 6
      // this._wheelLight.shadow.camera.bottom = -6
      this._wheelLight.position.set(0, 0, 5);
      this._wheelScene.add(this._wheelLight);

      // let wheelShadowPlane = new THREE.Mesh(new THREE.PlaneBufferGeometry(8, 8), new THREE.ShadowMaterial({opacity: 0.1}))
      // wheelShadowPlane.position.z = 0.8
      // wheelShadowPlane.receiveShadow = true
      // this._wheelScene.add(wheelShadowPlane)

      this._wheelScene.position.set(0, 0, -5);
      this._totemCamera.add(this._wheelScene);

      this._tooltipStones = [];

      this.updateMode(this.mode);
      this.onResize();
      __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(this.onResize, 1200);

      if (!this.$root.platform.mobile) {
        document.addEventListener('mousedown', this.onMouseDown);
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
        document.addEventListener('mousewheel', this.onMouseWheel);
        document.addEventListener('DOMMouseScroll', this.onMouseWheel);
      } else {
        document.addEventListener('touchstart', this.onMouseDown);
        document.addEventListener('touchmove', this.onMouseMove);
        document.addEventListener('touchend', this.onMouseUp);
      }

      __WEBPACK_IMPORTED_MODULE_9__utils_RAF__["a" /* default */].add(this.render);
    }
  },

  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
    document.removeEventListener('touchstart', this.onMouseDown);
    document.removeEventListener('touchmove', this.onMouseMove);
    document.removeEventListener('touchend', this.onMouseUp);
    document.removeEventListener('mousewheel', this.onMouseWheel);
    document.removeEventListener('DOMMouseScroll', this.onMouseWheel);
    this._wheelScene.traverse(this.destroySceneChildren);
    this._totemScene.traverse(this.destroySceneChildren);
    this._renderer.dispose();
    this._renderer.forceContextLoss();
    __WEBPACK_IMPORTED_MODULE_9__utils_RAF__["a" /* default */].remove(this.render);
  },
  computed: {
    canvasWidth: function canvasWidth() {
      // return this.detailsPanelConcept && this.viewPort.width > parseInt(cssVars.bpSm) ? this.viewPort.width / 2 : this.viewPort.width
      return this.viewPort.width;
    },
    canvasCenterPoint: function canvasCenterPoint() {
      return this.detailsPanelConcept && this.viewPort.width > parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.bpSm) ? 0.5 : 1;
    },
    importanceSelectionStoneTrackWidth: function importanceSelectionStoneTrackWidth() {
      if (this.viewPort.width <= parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.bpSm)) {
        return this.viewPort.width * (parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptSelectorMobileTrackPercent) / 100);
      }
      return this.viewPort.width * (parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptSelectorDesktopTrackPercent) / 100);
    },
    importanceSelectionStoneTrackY: function importanceSelectionStoneTrackY() {
      var halfHeight = this.viewPort.height / 2;
      var desktopY = -(halfHeight - parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptSelectorDesktopHeight) / 2) / halfHeight;
      // -1 : halfHeight = x : halfHeight - 200
      return this.viewPort.width <= parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.bpSm) ? -0.3 : desktopY;
    },
    cursorIsPointer: function cursorIsPointer() {
      return this.hasMouseOverStone;
    }
  },

  methods: {
    preventEvent: function preventEvent() {},
    createBackgroundTotemPlane: function createBackgroundTotemPlane() {
      var geometry = new THREE.PlaneBufferGeometry(4, 4);
      geometry.translate(0, 1.5, 0);
      var material = new THREE.MeshBasicMaterial({
        transparent: true,
        // color: 0xf7f7ef,
        map: new THREE.TextureLoader().load('/static/img/totem' + Math.floor(Math.random() * 9) + '.png'),
        depthWrite: false
      });
      // if (!this.doScreenshot) {
      //   material.onBeforeCompile = function (mat) {
      //     mat.fragmentShader = mat.fragmentShader.replace('#include <fog_fragment>', 'float fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n gl_FragColor.a *= 1.0 - fogFactor;')
      //   }
      // }
      return new THREE.Mesh(geometry, material);
    },

    destroySceneChildren: function destroySceneChildren(value) {
      if (typeof value.destroy === 'function') {
        // console.log('destroy')
        value.destroy();
      } else {
        if (value.geometry) {
          value.geometry.dispose();
        }
        if (value.material) {
          if (value.material.map) {
            value.material.map.dispose();
          }
          value.material.dispose();
        }
      }
    },

    setTotemAllStonesExplodedState: function setTotemAllStonesExplodedState(value, totem) {
      var _this = this;

      var totemObject = this.getTotem(totem);
      if (totemObject) {
        this.currentTotemExploded = value;
        totemObject.allStonesExploded = value;
        for (var i = 0; i < totemObject._stones.length; i++) {
          totemObject._stones[i].exploded = value;
        }
      }
      if (!value) {
        this.$emit('update:detailsPanelConcept', null);
      }
      this.$emit('update:explodeTotem', value ? 1 : 0);

      if (totemObject.config.id === this.currentTotem.id) {
        this._forceLabelsOpen = true;
        clearTimeout(this._forceLabelsOpenDelay);
        this._forceLabelsOpenDelay = __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(function () {
          _this._forceLabelsOpen = false;
          _this._tooltipStones = [];
        }, 4000);

        if (totemObject.allStonesExploded === false) {
          this._tooltipStones = totemObject._stones;
        } else {
          var stones = [];
          totemObject._stones.forEach(function (stone) {
            stones = stones.concat(stone._explodedStones);
          });
          this._tooltipStones = stones;
        }
      } else {
        this._tooltipStones = [];
      }
    },

    updateMode: function updateMode(value) {
      this.isMouseDown = false;
      switch (value) {
        case 'totem':
          if (this._explodedStone) {
            this._explodedStone.exploded = false;
            this._explodedStone = null;
          }
          this._lastInteractionTime = this._clock.elapsedTime;

          // this.multiTotem = 0
          this.$emit('update:multiTotem', 0);
          this._backgroundTotemsOffset.target = this._backgroundTotemsOffset.value = 0;
          if (this._fixedTopConceptStones.length === 0) {
            this._elasticFogNear.value = this._elasticFogNear.target = this.lerp(this._singleTotemFogNear, this._multiTotemFogNear, this.multiTotem);
            this._elasticFogFar.value = this._elasticFogFar.target = this.lerp(this._singleTotemFogFar, this._multiTotemFogFar, this.multiTotem);
            this.updateTotems(this.totems);
          } else {
            this.animateTopConceptStones();
          }
          break;
        case 'wheel':
          if (this._explodedStone) {
            this._explodedStone.exploded = false;
            this._explodedStone = null;
          }
          this.updateWheelConcepts(this.wheelConcepts);
          this.updateSelectedConcepts(this.selectedConcepts);
          this.syncTopStones();
          this._elasticFogNear.value = this._elasticFogNear.target = this._wheelFogNear;
          this._elasticFogFar.value = this._elasticFogFar.target = this._wheelFogFar;
          break;
      }
    },
    syncTopStones: function syncTopStones() {
      var _this2 = this;

      this.wheelConcepts.forEach(function (config) {
        if (config.concept.confirmed) {
          var existingTopStone = __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(_this2._fixedTopConceptStones, { config: { id: config.concept.id } });
          if (!existingTopStone) {
            // let cat = GoogleHopeService.getConceptCategory(config.concept)
            var top = new __WEBPACK_IMPORTED_MODULE_6__atoms_HopeConceptStone__["a" /* default */](config.concept, new THREE.MeshToonMaterial({
              specular: new THREE.Color(0x000000),
              shininess: 0,
              map: new __WEBPACK_IMPORTED_MODULE_7__atoms_HopeStoneTexture__["a" /* default */](config.concept.categoryObject.color, 1),
              transparent: false
            }));
            top.material.onBeforeCompile = __WEBPACK_IMPORTED_MODULE_17__utils_applyToonLighting__["a" /* default */];
            top.elasticPosition.speed = 4;
            top.setVisible(true);
            top.castShadow = false;
            _this2._fixedTopConceptStones.push(top);
            _this2._totemCamera.add(top);
            _this2.calculateFixedTopConceptStones();
          }
        }
      });
    },
    updateWheelConcepts: function updateWheelConcepts(value) {
      // remove stones
      for (var i = this._wheelConceptStones.length - 1; i >= 0; i--) {
        var concept = this._wheelConceptStones[i];
        if (!__WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(value, { concept: { id: concept.config.id } })) {
          this._wheelScene.remove(concept);
          concept.destroy();
          this._wheelConceptStones.splice(i, 1);
        }
      }

      var pos = new THREE.Vector3();

      // add / update stones
      for (var _i = 0; _i < value.length; _i++) {
        var _concept = value[_i];
        var existingConcept = __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(this._wheelConceptStones, { config: { id: _concept.concept.id } });
        if (!existingConcept) {
          var mesh = new __WEBPACK_IMPORTED_MODULE_6__atoms_HopeConceptStone__["a" /* default */](_concept.concept, new THREE.MeshToonMaterial({
            specular: new THREE.Color(0x000000),
            shininess: 0,
            map: new __WEBPACK_IMPORTED_MODULE_7__atoms_HopeStoneTexture__["a" /* default */](_concept.concept.categoryObject.color, 1),
            transparent: false
          }));
          mesh.material.onBeforeCompile = __WEBPACK_IMPORTED_MODULE_17__utils_applyToonLighting__["a" /* default */];
          mesh.addWheelShadowPlane();
          mesh.setVisible(true);
          this._wheelConceptStones.push(mesh);
          this._wheelScene.add(mesh);
        } else {
          pos.x = _concept.x;
          pos.y = -_concept.y;
          pos.z = 0.5;
          pos.unproject(this._totemCamera);
          // let pos = new THREE.Vector3(concept.x, -concept.y, 0.5).unproject(this._totemCamera)

          // pos.multiplyScalar(0.99)
          existingConcept.position.copy(this._wheelScene.worldToLocal(pos));
          existingConcept.rotation.z = -_concept.t;
        }
      }
    },
    animateTopConceptStones: function animateTopConceptStones() {
      var _this3 = this;

      this.animatingTopStones = true;
      this.updateTotems(this.totems);

      var targetTotem = this._totems[0];
      targetTotem.updateMatrixWorld(true);
      targetTotem.update(1 / 60);
      targetTotem.doUpdate = false;
      targetTotem.label.visible = false;

      var index = 0;

      var _loop = function _loop() {
        var stone = _this3._fixedTopConceptStones[0];
        _this3._fixedTopConceptStones.splice(0, 1);
        stone.position.copy(_this3._totemCamera.localToWorld(stone.position));
        _this3._totemScene.add(stone);
        var target = _this3.findTopStoneAnimationTarget(stone);
        var endPosition = target.getWorldPosition();
        var isLast = _this3._fixedTopConceptStones.length === 0;
        // draw 0 lines to target
        // target.exploded = false
        target.setScale(false, false);
        target.scale.set(0.00001, 0.00001, 0.00001);
        target.material.map.draw(target.config.color, 0);
        target.inAnimatedStonesNum = 0;
        __WEBPACK_IMPORTED_MODULE_15_animejs___default()({
          targets: stone.position,
          x: endPosition.x,
          y: endPosition.y,
          z: endPosition.z,
          duration: 500,
          easing: 'easeOutQuart',
          delay: 200 * (index + 1),
          complete: function complete(anim) {
            target.inAnimatedStonesNum++;
            target.cancelScaleAnimation();
            //
            target.animateScale(0.3 + target.inAnimatedStonesNum / 10);
            //
            target.material.map.draw(target.config.color, target.inAnimatedStonesNum);
            _this3._totemScene.remove(stone);
            stone.destroy();
            if (isLast) {
              _this3.onAnimateTopConceptStonesEnd(targetTotem);
            }
          }
        });
        index++;
      };

      while (this._fixedTopConceptStones.length > 0) {
        _loop();
      }
    },
    dataURItoBlob: function dataURItoBlob(dataURI) {
      // https://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata/9010182
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    onAnimateTopConceptStonesEnd: function onAnimateTopConceptStonesEnd(totem) {
      var _this4 = this;

      this._elasticFogNear.value = this._elasticFogNear.target = this.lerp(this._singleTotemFogNear, this._multiTotemFogNear, this.multiTotem);
      this._elasticFogFar.value = this._elasticFogFar.target = this.lerp(this._singleTotemFogFar, this._multiTotemFogFar, this.multiTotem);
      this.animatingTopStones = false;
      totem.doUpdate = true;

      this._forceLabelsOpen = true;
      clearTimeout(this._forceLabelsOpenDelay);
      this._forceLabelsOpenDelay = __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(function () {
        _this4._forceLabelsOpen = false;
        _this4._tooltipStones = [];
      }, 4000);

      this.takingScreenshot = true;

      __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(function () {
        // let screenshot = this.getScreenshot('image/png')
        _this4.getScreenshot('image/jpeg', 1200, 627, function (screenshot) {
          __WEBPACK_IMPORTED_MODULE_18__services_GoogleHopeService__["a" /* default */].saveThumbnail(_this4.totems[0].id, _this4.dataURItoBlob(screenshot));
          _this4.takingScreenshot = false;

          _this4._totems.forEach(function (totem) {
            totem.label.enable();
          });
        });

        // console.log(GoogleHopeService.saveThumbnail)
        // console.log(screenshot)
        // window.open(screenshot, '_blank')
      }, 2500);

      // this._lastInteractionTime = this._clock.elapsedTime
      this.$emit('totemReady');

      this._tooltipStones = this.getTotem(this.currentTotem)._stones;
      // totem.config = totem.config
      this.updateTotems(this.totems);
    },
    findTopStoneAnimationTarget: function findTopStoneAnimationTarget(stone) {
      var ret = null;
      this._totems.some(function (totem, i) {
        var categoryStone = totem.findCategoryStoneByConcept(stone.config);
        if (categoryStone) {
          ret = categoryStone.unexplodedStone;
          return true;
        }
        return false;
      });
      return ret;
    },
    updateTotems: function updateTotems(value) {
      var _this5 = this;

      // console.log('update totems')
      // remove totems
      for (var i = this._totems.length - 1; i >= 0; i--) {
        var totem = this._totems[i];
        if (!__WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(value, { id: totem.config.id })) {
          this._totemScene.remove(totem);
          totem.destroy();
          this._totems.splice(i, 1);
          // console.log('removed totem', totem)
        }
      }

      // add/update totems
      value.forEach(function (totemData, index) {
        var existingTotem = _this5.getTotem(totemData);
        if (!existingTotem) {
          // console.log('created totem', totemData)

          var _totem = {};

          if (index === 0) {
            // user totem
            _totem = new __WEBPACK_IMPORTED_MODULE_4__atoms_HopeTotem__["a" /* default */](totemData, true);
          } else {
            _totem = new __WEBPACK_IMPORTED_MODULE_4__atoms_HopeTotem__["a" /* default */](totemData, false, _this5._totems);
          }

          if (_this5.doScreenshot) {
            _totem.remove(_totem.label);
          }
          _totem.position.x = totemData.position.x;
          _totem.position.z = !_this5.doScreenshot ? totemData.position.z : 0;
          _totem.position.y = 0;
          _this5._totemScene.add(_totem);
          _this5._totems.push(_totem);
        } else {
          // console.log('updated totem', totemData)
          existingTotem.config = totemData;
        }
      });
      this.$emit('update:currentTotem', value[0]);
    },

    setTotemsVisible: function setTotemsVisible(userTotemVisible, backTotemsVisible) {
      for (var i = 0; i < this._totems.length; i++) {
        if (i === 0) {
          this._totems[i].visible = userTotemVisible;
        } else {
          this._totems[i].visible = this._totems[i].doUpdate = backTotemsVisible;
        }
      }
      for (var _i2 = 0; _i2 < this._backgroundTotemPlanes.length; _i2++) {
        this._backgroundTotemPlanes[_i2].visible = backTotemsVisible;
      }
    },

    currentTotemIsUserTotem: function currentTotemIsUserTotem() {
      return this.currentTotem ? this.currentTotem.id === this.totems[0].id : true;
    },

    backgroundTotemsVisible: function backgroundTotemsVisible() {
      var fogFar = 0;
      if (!this.doScreenshot) {
        fogFar = this._totemCamera.position.z - this._totemScene.fog.far;
      }
      // console.log(fogFar, this.totems[1])
      return this.doScreenshot || !this.animatingTopStones && fogFar < -8 || !this.currentTotemIsUserTotem();
      // return (!this.animatingTopStones && this._totemScene.fog.near >= this._singleTotemFogNear + 0.1) || !this.currentTotemIsUserTotem()
    },

    render: function render() {
      var _this6 = this;

      var delta = this._clock.getDelta();

      this.elasticWheel.target = 0;
      this.elasticWheel.update(delta);

      if (this.multiTotem === 1 && this.explodeTotem === 0) {
        this.compareModePassed = true;
      }

      if (this._totems && this.currentTotem) {
        if (this.currentTotem.id === this._totems[0]._config.id) {
          if (this.multiTotem === 0 && this.explodeTotem === 0 && this.compareModePassed && !this.finalModalShow) {
            this.finalModalShow = true;

            this.$emit('finalmodal:show');
          }
        }
      }

      if (this._controls) {
        this._explodeTotemAlpha = 0;
        var currentTotem = this.getTotem(this.currentTotem);
        var newMultiTotem = this.multiTotem;

        if (this.isMouseDown && this._downMultiTotemAlpha === 0 && newMultiTotem === 0) {
          this._explodeTotemAlpha = Math.max(-1, Math.min(1, -(this.mouseDown.y - this.mouse.y)));
        }

        if (this.isMouseWheelActive && this._downMultiTotemAlpha === 0 && newMultiTotem === 0 && !this._pauseWheelActions) {
          this._explodeTotemAlpha -= this.elasticWheel.value; // * 1.5
          var threshold = 0.4;
          if (this.elasticWheel.value < -threshold && this._explodeTotemAlpha > threshold && !currentTotem.allStonesExploded) {
            // console.log('wheel explode')
            this.setTotemAllStonesExplodedState(true, this.currentTotem);
            this._pauseWheelActions = true;
            clearTimeout(this.pauseWheelActionsDelay);
            this.pauseWheelActionsDelay = __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(function () {
              _this6._pauseWheelActions = false;
            }, 500);
            this.elasticWheel.value = this.elasticWheel.target = 0;
          } else if (this.elasticWheel.value > threshold && this._explodeTotemAlpha < -threshold && currentTotem.allStonesExploded) {
            // console.log('wheel unexplode')
            this.elasticWheel.value = this.elasticWheel.target = 0;
            this._pauseWheelActions = true;
            clearTimeout(this.pauseWheelActionsDelay);
            this.pauseWheelActionsDelay = __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(function () {
              _this6._pauseWheelActions = false;
            }, 500);
            this.setTotemAllStonesExplodedState(false, this.currentTotem);
          }
        }

        this._explodeTotemAlpha = Math.max(-1, Math.min(1, this._explodeTotemAlpha));
        if (currentTotem) currentTotem.spacing = Math.max(0, this._explodeTotemAlpha * 0.2);
        // console.log(this._explodeTotemAlpha)

        if (currentTotem && !currentTotem.allStonesExploded) {
          // we are on user totem and it isn't exploded

          var offsetLimit = (this.totems.length - 2) / 2;
          if (this.isMouseDown) {
            // move alpha
            newMultiTotem = Math.max(0, Math.min(1, this._downMultiTotemAlpha + (this.mouseDown.y - this.mouse.y)));

            if (newMultiTotem > 0.5) {
              // move background totems offset
              this._backgroundTotemsOffset.target = Math.max(-offsetLimit, Math.min(offsetLimit, this._backgroundTotemsOffsetDown + (this.mouse.x - this.mouseDown.x) * 2));
            } else {
              this._backgroundTotemsOffset.target = Math.round(this._backgroundTotemsOffset.target);
            }
          }

          if (this.isMouseWheelActive && !this._pauseWheelActions) {
            newMultiTotem += this.elasticWheel.value;
          }
        }

        if (!this.isMouseDown && !this.isMouseWheelActive) {
          newMultiTotem = Math.round(newMultiTotem);
          this._backgroundTotemsOffset.target = Math.round(this._backgroundTotemsOffset.target);
        }
        newMultiTotem = Math.max(0, Math.min(1, newMultiTotem));
        // console.log(this._controls._lookat.value.z, newMultiTotem)
        if (this._controls._lookat.value.z < -5 && newMultiTotem > 0.5) {
          // we should return to user totem
          this.$emit('update:currentTotem', this.totems[0]);
          // this.multiTotem = 1
          // this.isMouseDown = false
        }

        var _target = new THREE.Vector3();
        // lerps
        _target.lerpVectors(this._singleTotemTarget, this._multiTotemTarget, newMultiTotem);
        // center around current totem
        if (currentTotem) _target.add(currentTotem.position);
        this._controls.target.copy(_target);

        // lerp
        this._controls.theta = this.lerp(this._singleTotemTheta, this._multiTotemTheta, newMultiTotem) + this._explodeTotemAlpha * 0.2;
        this._controls.radius = this.lerp(this._singleTotemRadius, this._multiTotemRadius, newMultiTotem);

        if (!__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].mobile) {
          if (!this.isMouseDown) {
            this._controls.phi = -this._controls._mousePickingPosition.x * 0.25 * (1 - newMultiTotem);
            this._controls.theta += this._controls._mousePickingPosition.y * 0.1 * (1 - newMultiTotem);
          } else {
            this._controls.phi = 0;
          }
        } else {
          this._controls.phi = this.gyroscope.orientationY * 0.008 * (1 - newMultiTotem);
          var rad = this.gyroscope.orientationX * Math.PI / 180;
          this._controls.theta += (rad - Math.PI / 4) * 0.2 * (1 - newMultiTotem);
        }

        if (newMultiTotem !== this.multiTotem) {
          this.$emit('update:multiTotem', newMultiTotem);
        }
        if (!this.animatingTopStones) {
          this._controls.update(delta);
        }
      }

      if (this.mode === 'totem') {
        if (__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].mobile) this.gyroscope.update();
        this.handleTotemsUpdate(delta);

        if (!this.detailsPanelConcept) {
          this.$emit('update:inactivityTime', this._clock.elapsedTime - this._lastInteractionTime);
        } else {
          this._lastInteractionTime = this._clock.elapsedTime;
        }

        if (this.isMouseDown && this.detailsPanelConcept == null && __WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].mobile) {
          var newShareOpenAlpha = Math.max(0, Math.min(1, this._downShareOpenAlpha + (this.mouseDown.x - this.mouse.x) * 3));
          newShareOpenAlpha = Math.max(0, Math.min(1, newShareOpenAlpha * Math.pow(1 - this.multiTotem, 6) * Math.pow(1 - Math.abs(this._explodeTotemAlpha), 6)));
          this.$emit('update:shareOpenAlpha', newShareOpenAlpha);
        } else {
          if (this.shareOpenAlpha !== Math.round(this.shareOpenAlpha)) {
            this.$emit('update:shareOpenAlpha', Math.round(this.shareOpenAlpha));
          }
        }

        var updatedToolTips = [];
        if (this.multiTotem === 0) {
          for (var i = 0; i < this._tooltipStones.length; i++) {
            var _stone = this._tooltipStones[i];
            updatedToolTips.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.getTooltipPosition(_stone), _stone.config));
          }
        }
        this.$emit('update:tooltips', updatedToolTips);

        // this.setTotemsVisible(false, true)
        this.setTotemsVisible(!this.doScreenshot, this.backgroundTotemsVisible());
        if (!this.animatingTopStones) {
          this._elasticFogNear.target = this.lerp(this._singleTotemFogNear, this._multiTotemFogNear, this.multiTotem);
          this._elasticFogFar.target = this.lerp(this._singleTotemFogFar, this._multiTotemFogFar, this.multiTotem);
        } else {
          // when animating top concept
          this._elasticFogNear.target = this._wheelFogNear;
          this._elasticFogFar.target = this._wheelFogFar;
        }
      } else {
        this.setTotemsVisible(false, false);
        this._elasticFogNear.target = this._wheelFogNear;
        this._elasticFogFar.target = this._wheelFogFar;
      }

      this._elasticFogNear.update(delta);
      this._elasticFogFar.update(delta);
      if (this._totemScene.fog) {
        this._totemScene.fog.near = this._elasticFogNear.value;
        this._totemScene.fog.far = this._elasticFogFar.value;
      }

      if (this.mode === 'wheel') {
        this.handleCenterStoneDragging();
      }

      this.inForeground = this._fixedCenteredConceptStone !== null;
      // update top stones
      for (var _i3 = 0; _i3 < this._fixedTopConceptStones.length; _i3++) {
        this._fixedTopConceptStones[_i3].update(null, delta, true);
      }

      var wheelSceneVisible = this.viewPort.width <= parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.bpSm) ? !this._fixedCenteredConceptStone : true;

      this._wheelScene.visible = this.mode === 'wheel' && wheelSceneVisible;
      // this._totemGround.visible = this._totemLight.visible = !this._wheelScene.visible
      this._totemLight.visible = !this._wheelScene.visible;

      this._renderer.render(this._totemScene, this._totemCamera, null, true);
    },

    lerp: function lerp(v0, v1, t) {
      return v0 + t * (v1 - v0);
    },

    handleTotemsUpdate: function handleTotemsUpdate(delta) {
      this._mouseOverStone = null;
      this.hasMouseOverStone = false;
      this._backgroundTotemsOffset.update(delta);
      if (this._totems) {
        // totem stones raycast picking
        this._raycaster.setFromCamera(this.mouse, this._totemCamera);

        for (var i = 0; i < this._totems.length; i++) {
          var totem = this._totems[i];
          if (totem.doUpdate) {
            totem.update(delta, this._totemGround);
            if (totem.visible) {
              this.handleTotemPicking(totem);
            }
          }
          // background totems scroll
          if (i > 0) {
            // totem.position.x = this.totems[i].position.x + (this._backgroundTotemsOffset.value * 5)

            // circle related totems
            var center = new THREE.Vector3(0, 0, 30);
            var span = Math.PI / 7;
            var radius = 40;
            // Math.PI / 2 : 0.4 = span : x
            var offsetAngle = span / 2 + this._backgroundTotemsOffset.value * (span * 0.4 / (Math.PI / 2));
            var angle = span * (i - 1) / (this.totems.length - 2);
            angle += Math.PI;
            totem.position.x = center.x + radius * Math.sin(angle - offsetAngle);
            totem.position.z = center.z + radius * Math.cos(angle - offsetAngle);

            if (this.doScreenshot) {
              totem.position.x *= 0.55;
            }
          }
        }
      }
    },

    handleTotemPicking: function handleTotemPicking(totem) {
      if (!this.hasMouseOverStone) {
        var picking = [];
        for (var k = 0; k < totem.stones.length; k++) {
          var _stone2 = totem.stones[k];
          if (!_stone2.exploded) {
            // raycast collision mesh of unexploded stones
            _stone2.collisionMesh.raycast(this._raycaster, picking);
            if (picking.length > 0) {
              this.hasMouseOverStone = true;
              this._mouseOverStone = picking[0].object.parent.parent;
              return true;
            }
          } else {
            // stone is exploded
            // raycast exploded substones
            if (this.handleStonePicking(_stone2, picking)) {
              return true;
            }
          }
        }
      }
      return false;
    },
    handleStonePicking: function handleStonePicking(stone, picking) {
      for (var j = 0; j < stone.explodedStones.length; j++) {
        var expStone = stone.explodedStones[j];
        expStone.collisionMesh.raycast(this._raycaster, picking);
        if (picking.length > 0) {
          this.hasMouseOverStone = true;
          this._mouseOverStone = picking[0].object.parent;
          return true;
        }
      }
      return false;
    },
    handleCenterStoneDragging: function handleCenterStoneDragging() {
      this.hasMouseOverStone = false;
      this._mouseOverStone = null;
      // drag centered stone (importance)
      if (this._fixedCenteredConceptStone) {
        this._raycaster.setFromCamera(this.mouse, this._totemCamera);
        var picking = [];
        this._fixedCenteredConceptStone.raycast(this._raycaster, picking);
        if (picking.length > 0) {
          this.hasMouseOverStone = true;
          this._mouseOverStone = this._fixedCenteredConceptStone;
        }

        if (this.isDraggingCenterStone) {
          // let trackWidth = this.viewPort.width <= 1099 ? this.viewPort.width / 2 : this.viewPort.width / 4
          var mouseMult = this.viewPort.width / (this.importanceSelectionStoneTrackWidth * 2);
          this._fixedCenteredConceptStone.config.importance = Math.max(0, Math.min(1, this.mouse.x * mouseMult + 0.5));
          this.calculateFixedCenteredConceptStone();
        }
      }
    },
    getTotem: function getTotem(totemData) {
      if (!totemData) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(this._totems, { config: { id: totemData.id } });
    },
    onMouseDown: function onMouseDown(event) {
      if (this.recursiveDatasetSearch(event.target, 'blockInteraction')) return;
      // if (this.recursiveDatasetSearch(event.target, 'blockInteraction') || this.detailsPanelConcept) return

      if (this._controls) {
        this._controls.onMouseDown(event);
      }
      // this.$emit('update:dragHintVisible', false)
      this._lastInteractionTime = this._clock.elapsedTime;

      var x = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].clientY : event.clientY;
      this.mouse.x = x / this.canvasWidth * 2 - this.canvasCenterPoint;
      this.mouse.y = -(y / this.viewPort.height) * 2 + 1;
      this.mouseDown.copy(this.mouse);
      // this.mouseOnMultitotemAlpha0.copy(this.mouse)
      this.isMouseDown = true;
      this._downShareOpenAlpha = this.shareOpenAlpha;
      this._downMultiTotemAlpha = this.multiTotem;
      this._backgroundTotemsOffsetDown = this._backgroundTotemsOffset.target;

      if (this.mode === 'wheel') {
        this.handleCenterStoneDragging();
        if (this._fixedCenteredConceptStone && this.hasMouseOverStone) {
          this.isDraggingCenterStone = true;
        }
        // this.handleCenterStoneDragging()
      }
      // this._tooltipStone = null
      // this.$emit('update:tooltip', null)
    },
    onMouseUp: function onMouseUp(event) {
      if (this.takingScreenshot || this.wheelBlock) {
        this.isMouseDown = false;

        return;
      }

      if (this.recursiveDatasetSearch(event.target, 'blockInteraction')) return;
      // if (this.recursiveDatasetSearch(event.target, 'blockInteraction') || this.detailsPanelConcept) return
      // event.preventDefault()
      if (this._controls) {
        this._controls.onMouseUp(event);
      }
      this._lastInteractionTime = this._clock.elapsedTime;

      this.isDraggingCenterStone = false;
      this.isMouseDown = false;

      if (this._explodeTotemAlpha > 0.5 && !this.currentTotemExploded) {
        this.setTotemAllStonesExplodedState(true, this.currentTotem);
      } else if (this._explodeTotemAlpha < -0.5 && this.currentTotemExploded) {
        this.setTotemAllStonesExplodedState(false, this.currentTotem);
      }

      // this is not a click, skip the rest
      if (!this.isClick(this.mouse, this.mouseDown)) {
        this._tooltipStones = [];
        return;
      }

      // this is a click

      if (this.mode === 'totem') {
        if (this.doScreenshot) {
          this.saveScreenshot();
        }
        // let screenshot = this.getScreenshot('image/jpeg', 1200, 627)
        // console.log(screenshot)
        if (this.hasMouseOverStone) {
          // switch current totem
          if (!this.stoneIsPartOfTotem(this._mouseOverStone, this.currentTotem)) {
            this.$emit('update:currentTotem', this._mouseOverStone.parent.config);
          } else {
            if (!this._mouseOverStone.config.concepts) {
              // we clicked a concept stone
              // console.log('click on concept', this._mouseOverStone.config)
              this.$emit('concept:click', this._mouseOverStone.config);
              if (event.type === 'touchend') {
                this._tooltipStones = [];
              }
            } else {
              // we clicked a category stone
              if (this.multiTotem !== 0) this.$emit('update:multiTotem', 0);
              if (event.type === 'mouseup') {
                // desktop event
                this._tooltipStones = this.getTotem(this.currentTotem)._stones;
              } else if (event.type === 'touchend') {
                // mobile event on click on stone
                if (this._tooltipStones.length > 0 && this._tooltipStones[0] === this._mouseOverStone) {
                  // tapped on same cat stone 2 times
                  // this.$emit('update:dragHintVisible', true)
                } else {
                  // tapped on diffferent cat stone
                  this._tooltipStones = [this._mouseOverStone];
                }
              }
            }
          }
        } else {
          // click outside totem
          var currentTotem = this.getTotem(this.currentTotem);
          if (event.type === 'touchend') {
            var totem = this.getTotem(this.currentTotem);
            if (currentTotem.allStonesExploded) {
              var stones = [];
              totem._stones.forEach(function (stone) {
                stones = stones.concat(stone._explodedStones);
              });
              this._tooltipStones = stones;
            } else {
              // disabled as per request?
              // this._tooltipStones = totem._stones
            }
          }
        }
      }
    },
    getTooltipPosition: function getTooltipPosition(stone) {
      var pos = void 0;

      if (stone.config.concepts) {
        pos = stone.unexplodedStone.getWorldPosition();
        pos.x += stone.unexplodedStone.collisionGeometry.boundingSphere.radius * stone.unexplodedStone.scale.x;
      } else {
        pos = stone.getWorldPosition();
        pos.x += stone.collisionGeometry.boundingSphere.radius * stone.scale.x;
      }
      this._totemCamera.parent.worldToLocal(pos);
      pos = pos.project(this._totemCamera);
      pos.x = Math.round((pos.x + this.canvasCenterPoint) * this.viewPort.width / 2);
      pos.y = Math.round((-pos.y + 1) * this.viewPort.height / 2);
      pos.z = 0;
      return pos;
    },
    stoneIsPartOfTotem: function stoneIsPartOfTotem(stone, totem) {
      return stone.parent.config.stones ? stone.parent.config.id === totem.id : stone.parent.parent.config.id === totem.id;
    },
    isClick: function isClick(mouse, mouseDown) {
      return Math.abs(mouse.distanceTo(mouseDown)) < 0.01;
    },
    onMouseMove: function onMouseMove(event) {
      if (this.takingScreenshot || this.wheelBlock) {
        return;
      }

      if (this.recursiveDatasetSearch(event.target, 'blockInteraction')) return;
      // if (this.recursiveDatasetSearch(event.target, 'blockInteraction') || this.detailsPanelConcept) return
      // event.preventDefault()

      if (this.isMouseDown) {
        this._lastInteractionTime = this._clock.elapsedTime;
      }

      // only desktop mousemove
      if (event.type === 'mousemove' && this.mode === 'totem' && !this._forceLabelsOpen) {
        if (this._mouseOverStone && this.stoneIsPartOfTotem(this._mouseOverStone, this.currentTotem) && this.multiTotem === 0) {
          if (this._previousMouseOverStone !== this._mouseOverStone) {
            this._tooltipStones = [this._mouseOverStone];
          }
        } else {
          this._tooltipStones = [];
        }
      }

      this._previousMouseOverStone = this._mouseOverStone;

      if (this._controls) {
        this._controls.onMouseMove(event);
      }
      var x = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].clientY : event.clientY;
      this.mouse.x = x / this.canvasWidth * 2 - this.canvasCenterPoint;
      this.mouse.y = -(y / this.viewPort.height) * 2 + 1;
    },
    onMouseWheel: function onMouseWheel(event) {
      var _this7 = this;

      if (this.takingScreenshot || this.wheelBlock) {
        return;
      }

      if (this.recursiveDatasetSearch(event.target, 'blockInteraction') || this.mode !== 'totem' || this.animatingTopStones) return;
      event.preventDefault();
      var normalized = Object(__WEBPACK_IMPORTED_MODULE_16__utils_normalizeWheel__["a" /* default */])(event);
      // console.log(normalized.pixelY, this._mouseWheelInertiaDetector.check(normalized))
      if (this._mouseWheelInertiaDetector.check(normalized) === false) return;
      // if (Math.abs(delta) < 100) return
      var delta = normalized.pixelY;
      this.elasticWheel.value += delta * 0.002;
      this.elasticWheel.value = Math.max(-1, Math.min(1, this.elasticWheel.value));
      this._lastInteractionTime = this._clock.elapsedTime;

      if (!this.isMouseWheelActive) {
        this._downMultiTotemAlpha = this.multiTotem;
      }
      this.isMouseWheelActive = true;
      clearTimeout(this.wheelActiveDelay);
      this.wheelActiveDelay = __WEBPACK_IMPORTED_MODULE_14_lodash_delay___default()(function () {
        // if (this._explodeTotemAlpha > 0.5 && !this.currentTotemExploded) {
        //   this.setTotemAllStonesExplodedState(true, this.currentTotem)
        // } else if (this._explodeTotemAlpha < -0.5 && this.currentTotemExploded) {
        //   this.setTotemAllStonesExplodedState(false, this.currentTotem)
        // }
        _this7.isMouseWheelActive = false;
      }, 200);
    },
    calculateFixedTopConceptStones: function calculateFixedTopConceptStones() {
      var _this8 = this;

      var maxStones = 9;
      // const middle = (this._fixedTopConceptStones.length - 1) / 2
      // width : 1 = 500 : x
      var desktopTotalSpace = parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptContainerDesktopWidth) / this.viewPort.width;
      var mobileTotalSpace = 1 - (parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptContainerMobileRight) + parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptContainerMobileLeft)) / this.viewPort.width - 0.025;

      var totalSpace = this.viewPort.width > parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.bpSm) ? desktopTotalSpace : mobileTotalSpace;

      var spacing = totalSpace / (maxStones / 2);

      var leftSide = this.viewPort.width > parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.bpSm) ? -totalSpace : -(1 - parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.conceptContainerMobileRight) / this.viewPort.width) - 0.025;

      var halfHeight = this.viewPort.height / 2;
      var y = (halfHeight - parseInt(__WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.headerHeight) / 2) / halfHeight;
      // 1 : halfHeight = x : halfHeight - 200

      this._fixedTopConceptStones.forEach(function (stone, index) {
        var x = leftSide + spacing * index;

        var pos = new THREE.Vector3(x, y, 0.9).unproject(_this8._totemCamera);
        _this8._totemCamera.worldToLocal(pos);
        stone.elasticPosition.x = pos.x;
        stone.elasticPosition.y = pos.y;
        stone.elasticPosition.z = pos.z;
      });
    },
    calculateFixedCenteredConceptStone: function calculateFixedCenteredConceptStone() {
      // position fixed center
      // let trackWidth = this.viewPort.width / 2
      var excursion = this.importanceSelectionStoneTrackWidth / this.viewPort.width;
      var imp = (this._fixedCenteredConceptStone.config.importance - 0.5) * 2;
      this._fixedCenteredConceptStone.setScale(false, false);
      // let dist = -(this._fixedCenteredConceptStone.config.importance - 0.5) * 0.2
      // let pos = new THREE.Vector3(imp * excursion, 0, 0.5 + dist).unproject(this._totemCamera)
      var pos = new THREE.Vector3(imp * excursion, this.importanceSelectionStoneTrackY, 0.7).unproject(this._totemCamera);
      this._totemCamera.worldToLocal(pos);
      this._fixedCenteredConceptStone.position.copy(pos);
    },

    updateSelectedConcepts: function updateSelectedConcepts(value) {
      var _this9 = this;

      //
      // remove fixed centered concept stone if not selected anymore (remove button)
      if (this._fixedCenteredConceptStone && this.selectedConcepts.indexOf(this._fixedCenteredConceptStone.config) === -1) {
        this._totemCamera.remove(this._fixedCenteredConceptStone);
        this._fixedCenteredConceptStone.destroy();
        this._fixedCenteredConceptStone = null;
      }

      // remove top stones if not selected anymore (from wheel)
      for (var i = this._fixedTopConceptStones.length - 1; i >= 0; i--) {
        var _stone3 = this._fixedTopConceptStones[i];
        if (value.indexOf(_stone3.config) === -1) {
          this._fixedTopConceptStones.splice(i, 1);
          this._totemCamera.remove(_stone3);
          _stone3.destroy();
          this.calculateFixedTopConceptStones();
        }
      }

      // loop all selected concepts
      value.some(function (concept) {
        if (_this9._fixedCenteredConceptStone && _this9._fixedCenteredConceptStone.config === concept) {
          // current unconfirmed stone is fixed centered stone
          // already configuring this
          // stop
          return true;
        }

        // check if concept is not confirmed
        if (!concept.confirmed) {
          // search for concept in top stones
          var index = __WEBPACK_IMPORTED_MODULE_13_lodash_findIndex___default()(_this9._fixedTopConceptStones, { config: concept });

          if (index === -1) {
            // concept is not confirmed, create a concept stone and put in the middle of the screen
            _this9._fixedCenteredConceptStone = new __WEBPACK_IMPORTED_MODULE_6__atoms_HopeConceptStone__["a" /* default */](concept, new THREE.MeshToonMaterial({
              specular: new THREE.Color(0x000000),
              shininess: 0,
              map: new __WEBPACK_IMPORTED_MODULE_7__atoms_HopeStoneTexture__["a" /* default */](concept.categoryObject.color, 1),
              transparent: false
            }));
            _this9._fixedCenteredConceptStone.material.onBeforeCompile = __WEBPACK_IMPORTED_MODULE_17__utils_applyToonLighting__["a" /* default */];
          } else {
            // stone was already selected, re-use it
            _this9._fixedCenteredConceptStone = _this9._fixedTopConceptStones[index];
            _this9._fixedTopConceptStones.splice(index, 1);
            _this9.calculateFixedTopConceptStones();
          }
          _this9._fixedCenteredConceptStone.elasticPosition.speed = 4;
          _this9._fixedCenteredConceptStone.setVisible(true);
          _this9._fixedCenteredConceptStone.castShadow = false;
          _this9._totemCamera.add(_this9._fixedCenteredConceptStone);
          _this9.onResize();
          // stop here
          return true;
        }
        return false;
      });
    },
    onResize: function onResize() {
      var _this10 = this;

      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.blockedResize) {
        return;
      }

      if (this._renderer) {
        this._renderer.setPixelRatio(window.devicePixelRatio);
        this._renderer.setSize(this.canvasWidth, this.viewPort.height);
      }
      if (!animate) {
        if (this._totemCamera) {
          this._totemCamera.aspect = this.canvasWidth / this.viewPort.height;
          this._totemCamera.updateProjectionMatrix();
        }
      } else {
        var animDummy = {
          width: this.$refs.threeCanvas.width,
          height: this.$refs.threeCanvas.height
        };
        this.animatingWidth = true;
        __WEBPACK_IMPORTED_MODULE_15_animejs___default()({
          targets: animDummy,
          width: this.canvasWidth,
          duration: 500,
          ease: 'easeInOutQuad',
          update: function update(anim) {
            // this._renderer.setSize(anim.animations[0].currentValue, this.viewPort.height)
            _this10._totemCamera.aspect = anim.animations[0].currentValue / _this10.viewPort.height;
            _this10._totemCamera.updateProjectionMatrix();
          },
          complete: function complete() {
            // this._renderer.setSize(this.canvasWidth, this.viewPort.height)
            _this10.animatingWidth = false;
          }
        });
      }

      if (this._wheelFadePlane) {
        // let z = this.viewPort.height / this.viewPort.width
        // console.log(z)
        var pos = new THREE.Vector3(0, -1, 0.57).unproject(this._totemCamera);
        this._wheelScene.worldToLocal(pos);
        this._wheelFadePlane.position.y = pos.y;
        // this._wheelFadePlane.position.z = pos.z
      }

      this.calculateFixedTopConceptStones();

      if (this._fixedCenteredConceptStone) {
        this.calculateFixedCenteredConceptStone();
      }
    },
    recursiveDatasetSearch: function recursiveDatasetSearch(element, datasetName) {
      if (element.dataset) {
        var dataset = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(element.dataset));
        if (dataset[datasetName] === '') {
          return true;
        }
      }
      var parent = element.parentElement || element.parentNode;
      if (parent && parent !== document.body) {
        return this.recursiveDatasetSearch(parent, datasetName);
      }
      return false;
    },

    getScreenshot: function getScreenshot(strMime) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var cb = arguments[3];

      if (width === -1 || height === -1) {
        try {
          return this._renderer.domElement.toDataURL(strMime);
        } catch (e) {
          console.warn(e);
        }
      } else {
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var sx = 0;
        var sy = 0;
        var sWidth = this._renderer.domElement.width;
        var sHeight = this._renderer.domElement.height;

        var scale = 0.9;

        var dWidth = this._renderer.domElement.width / window.devicePixelRatio * scale;
        var dHeight = this._renderer.domElement.height / window.devicePixelRatio * scale;
        var dx = -(dWidth - width) / 2;
        var dy = -(dHeight - height) / 2;

        var renderer = this._renderer.domElement;

        var ctx = canvas.getContext('2d');

        ctx.fillStyle = __WEBPACK_IMPORTED_MODULE_19__variables_scss___default.a.cBackground;
        ctx.fillRect(0, 0, width, height);

        this._totems.forEach(function (totem) {
          totem.label.disable();
        });

        var background = new Image();
        background.src = '/static/img/facebook-card-jpg.jpg';

        // Make sure the image is loaded first otherwise nothing will draw.
        background.onload = function () {
          ctx.drawImage(background, 0, 0);

          // replace here
          ctx.drawImage(renderer, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);

          try {
            return cb(canvas.toDataURL(strMime));
          } catch (e) {
            console.warn(e);
          }
        };
      }
    },
    saveScreenshot: function saveScreenshot() {
      var _this11 = this;

      try {
        var strDownloadMime = 'image/octet-stream';
        var strMime = 'image/png';
        this.getScreenshot(strMime, this._renderer.domElement.width, this._renderer.domElement.height, function (imgData) {
          _this11.saveFile(imgData.replace(strMime, strDownloadMime), 'screen.png');
        });
      } catch (e) {
        console.log(e);
      }
    },

    saveFile: function saveFile(strData, filename) {
      var link = document.createElement('a');
      if (typeof link.download === 'string') {
        document.body.appendChild(link); // Firefox requires the link to be in the body
        link.download = filename;
        link.href = strData;
        link.click();
        document.body.removeChild(link); // remove the link when done
      } else {
          // location.replace(uri)
        }
    }
  },
  watch: {
    explodeTotem: function explodeTotem(value) {
      this._lastInteractionTime = this._clock.elapsedTime;
      this.setTotemAllStonesExplodedState(value === 1, this.currentTotem);
    },
    multiTotem: function multiTotem(value) {
      this._lastInteractionTime = this._clock.elapsedTime;
    },
    // detailsPanelConcept: function (value) {
    //   this._lastInteractionTime = this._clock.elapsedTime
    // },
    currentTotem: function currentTotem(value) {
      var _this12 = this;

      this._lastInteractionTime = this._clock.elapsedTime;
      this.totems.forEach(function (totem) {
        _this12.setTotemAllStonesExplodedState(false, totem);
      });
      // this.multiTotem = 0
      if (value.id !== this.totems[0].id) {
        this.$emit('update:multiTotem', 0);
      }
      this.elasticWheel.value = 0;
      // console.log('current totem change')
    },
    // watch selected concepts and finds unconfirmed stones
    // and adds them to the center of the screen
    selectedConcepts: function selectedConcepts(value) {
      this.updateSelectedConcepts(value);
    },
    viewPort: function viewPort() {
      this.onResize();
    },
    totems: function totems(value) {
      if (this.mode === 'totem' && !this.animatingTopStones) {
        this.updateTotems(value);
      }
    },
    wheelConcepts: function wheelConcepts(value) {
      if (this.mode === 'wheel') {
        this.updateWheelConcepts(value);
      }

      // move fixed centered stone to top if it has become selected
      if (this._fixedCenteredConceptStone && this._fixedCenteredConceptStone.config.confirmed) {
        this._fixedTopConceptStones.push(this._fixedCenteredConceptStone);
        this._fixedCenteredConceptStone = null;
        this.calculateFixedTopConceptStones();
      }
    },
    mode: function mode(value) {
      this.updateMode(value);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ElasticVector3__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ElasticVector2__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ElasticNumber__ = __webpack_require__(78);


/* global THREE */




var CameraController = function () {
  function CameraController(camera, viewPort) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CameraController);

    this._camera = camera;
    this._viewport = viewPort;

    this.mouseSensitivity = 10;
    this.mouseEnabled = true;
    this.enabled = true;
    this.thetaMax = 0.8;
    this.thetaMin = -0.8;
    this.phiMax = Number.POSITIVE_INFINITY;
    this.phiMin = Number.NEGATIVE_INFINITY;

    this._mousePosition = new THREE.Vector2(0, 0);
    this._cameraRadius = new __WEBPACK_IMPORTED_MODULE_4__utils_ElasticNumber__["a" /* default */](20);
    this._lookat = new __WEBPACK_IMPORTED_MODULE_2__utils_ElasticVector3__["a" /* default */](new THREE.Vector3(0, 0, 0));
    this._phiTheta = new __WEBPACK_IMPORTED_MODULE_3__utils_ElasticVector2__["a" /* default */](new THREE.Vector2(0, 0));
    this._phiThetaDownPosition = new THREE.Vector2(0, 0);
    this._mouseDownPosition = new THREE.Vector2(0, 0);
    this._mousePickingPosition = new THREE.Vector2(0, 0);
    this._isMouseDown = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CameraController, [{
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      this._updateMousePosition(event);
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(event) {
      this._isMouseDown = true;
      this._updateMousePosition(event);
      this._mouseDownPosition.copy(this._mousePosition);
      this._phiThetaDownPosition.copy(this._phiTheta);
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp(event) {
      this._isMouseDown = false;
    }
  }, {
    key: '_getMousePositionX',
    value: function _getMousePositionX(event) {
      if (event.touches && event.touches.length > 0) {
        return event.touches[0].pageX - event.touches[0].target.offsetLeft;
      }
      return event.offsetX;
    }
  }, {
    key: '_getMousePositionY',
    value: function _getMousePositionY(event) {
      if (event.touches && event.touches.length > 0) {
        return event.touches[0].pageY - event.touches[0].target.offsetTop;
      }
      return event.offsetY;
    }
  }, {
    key: '_updateMousePosition',
    value: function _updateMousePosition(event) {
      this._mousePosition.x = this._getMousePositionX(event);
      this._mousePosition.y = this._getMousePositionY(event);

      this._mousePickingPosition.x = this._mousePosition.x / this._viewport.width * 2 - 1;
      this._mousePickingPosition.y = -(this._mousePosition.y / this._viewport.height) * 2 + 1;
    }
  }, {
    key: 'update',
    value: function update(delta) {
      this._lookat.update(delta);
      this._phiTheta.update(delta);
      this._cameraRadius.update(delta);

      if (this._isMouseDown && this.mouseEnabled) {
        var mouseDeltaX = this._mouseDownPosition.x - this._mousePosition.x;
        var sensitivityScaleX = this._viewport.width / this.mouseSensitivity;
        this._phiTheta.x = this._phiThetaDownPosition.x + mouseDeltaX / sensitivityScaleX;

        var mouseDeltaY = this._mouseDownPosition.y - this._mousePosition.y;
        var sensitivityScaleY = this._viewport.height / this.mouseSensitivity;
        this._phiTheta.y = this._phiThetaDownPosition.y + mouseDeltaY / sensitivityScaleY;
      }

      if (isNaN(this._phiTheta.x)) this._phiTheta.x = 0;
      if (isNaN(this._phiTheta.y)) this._phiTheta.y = 0;

      this._phiTheta.x = Math.max(this.phiMin, Math.min(this.phiMax, this._phiTheta.x));
      this._phiTheta.y = Math.max(this.thetaMin, Math.min(this.thetaMax, this._phiTheta.y));

      if (this.enabled) {
        this._camera.position.z = this._lookat.value.z + this._cameraRadius.value * Math.sin(this._phiTheta.value.y + Math.PI / 2) * Math.cos(this._phiTheta.value.x);
        this._camera.position.x = this._lookat.value.x + this._cameraRadius.value * Math.sin(this._phiTheta.value.y + Math.PI / 2) * Math.sin(this._phiTheta.value.x);
        this._camera.position.y = this._lookat.value.y + this._cameraRadius.value * Math.cos(this._phiTheta.value.y + Math.PI / 2);
        this._camera.lookAt(this._lookat.value);
      }
    }
  }, {
    key: 'radius',
    set: function set(value) {
      this._cameraRadius.target = value;
    },
    get: function get() {
      return this._cameraRadius.target;
    }
  }, {
    key: 'target',
    get: function get() {
      return this._lookat;
    },
    set: function set(value) {
      return this._lookat.copy(value);
    }
  }, {
    key: 'phi',
    get: function get() {
      return this._phiTheta.x;
    },
    set: function set(value) {
      this._phiTheta.x = value;
    }
  }, {
    key: 'theta',
    get: function get() {
      return this._phiTheta.y;
    },
    set: function set(value) {
      this._phiTheta.y = value;
    }
  }]);

  return CameraController;
}();

/* harmony default export */ __webpack_exports__["a"] = (CameraController);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ElasticVector2 = function () {
  function ElasticVector2(value) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ElasticVector2);

    this.value = value;
    this.x = value.x;
    this.y = value.y;
    this.speed = 3;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ElasticVector2, [{
    key: "set",
    value: function set(x, y) {
      this.x = x;
      this.y = y;
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
    }
  }, {
    key: "update",
    value: function update(delta) {
      delta = Math.min(delta, 1 / 10);

      var distx = this.x - this.value.x;
      var disty = this.y - this.value.y;

      this.value.x += distx * (this.speed * delta);
      this.value.y += disty * (this.speed * delta);
    }
  }]);

  return ElasticVector2;
}();

/* harmony default export */ __webpack_exports__["a"] = (ElasticVector2);

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



// https://github.com/d4nyll/lethargy/blob/master/lethargy.js

var MouseWheelInertiaDetector = function () {
  function MouseWheelInertiaDetector(stability, sensitivity, tolerance, delay) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MouseWheelInertiaDetector);

    this.stability = stability != null ? Math.abs(stability) : 8;
    this.sensitivity = sensitivity != null ? 1 + Math.abs(sensitivity) : 10;
    this.tolerance = tolerance != null ? 1 + Math.abs(tolerance) : 1.1;
    this.delay = delay != null ? delay : 0;

    this.lastUpDeltas = this.initializeLastUpDeltas();
    this.lastDownDeltas = this.initializeLastDownDeltas();
    this.deltasTimestamp = this.initializeDeltasTimestamp();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MouseWheelInertiaDetector, [{
    key: "initializeLastUpDeltas",
    value: function initializeLastUpDeltas() {
      var i, ref, results;
      results = [];
      for (i = 1, ref = this.stability * 2; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
        // eslint-disable-line yoda
        results.push(null);
      }
      return results;
    }
  }, {
    key: "initializeLastDownDeltas",
    value: function initializeLastDownDeltas() {
      var i, ref, results;
      results = [];
      for (i = 1, ref = this.stability * 2; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
        // eslint-disable-line yoda
        results.push(null);
      }
      return results;
    }
  }, {
    key: "initializeDeltasTimestamp",
    value: function initializeDeltasTimestamp() {
      var i, ref, results;
      results = [];
      for (i = 1, ref = this.stability * 2; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
        // eslint-disable-line yoda
        results.push(null);
      }
      return results;
    }
  }, {
    key: "check",
    value: function check(e) {
      var lastDelta;
      if (e.pixelY) {
        lastDelta = e.pixelY;
      } else {
        e = e.originalEvent || e;
        if (e.wheelDelta != null) {
          lastDelta = e.wheelDelta;
        } else if (e.deltaY != null) {
          lastDelta = e.deltaY * -40;
        } else if (e.detail != null || e.detail === 0) {
          lastDelta = e.detail * -40;
        }
      }

      this.deltasTimestamp.push(Date.now());
      this.deltasTimestamp.shift();
      if (lastDelta > 0) {
        this.lastUpDeltas.push(lastDelta);
        this.lastUpDeltas.shift();
        return this.isInertia(1);
      } else {
        this.lastDownDeltas.push(lastDelta);
        this.lastDownDeltas.shift();
        return this.isInertia(-1);
      }
    }
  }, {
    key: "isInertia",
    value: function isInertia(direction) {
      var lastDeltas, lastDeltasNew, lastDeltasOld, newAverage, newSum, oldAverage, oldSum;
      lastDeltas = direction === -1 ? this.lastDownDeltas : this.lastUpDeltas;
      if (lastDeltas[0] === null) {
        return direction;
      }
      if (this.deltasTimestamp[this.stability * 2 - 2] + this.delay > Date.now() && lastDeltas[0] === lastDeltas[this.stability * 2 - 1]) {
        return false;
      }
      lastDeltasOld = lastDeltas.slice(0, this.stability);
      lastDeltasNew = lastDeltas.slice(this.stability, this.stability * 2);
      oldSum = lastDeltasOld.reduce(function (t, s) {
        return t + s;
      });
      newSum = lastDeltasNew.reduce(function (t, s) {
        return t + s;
      });
      oldAverage = oldSum / lastDeltasOld.length;
      newAverage = newSum / lastDeltasNew.length;
      if (Math.abs(oldAverage) < Math.abs(newAverage * this.tolerance) && this.sensitivity < Math.abs(newAverage)) {
        return direction;
      } else {
        return false;
      }
    }
  }, {
    key: "showLastUpDeltas",
    value: function showLastUpDeltas() {
      return this.lastUpDeltas;
    }
  }, {
    key: "showLastDownDeltas",
    value: function showLastDownDeltas() {
      return this.lastDownDeltas;
    }
  }]);

  return MouseWheelInertiaDetector;
}();

/* harmony default export */ __webpack_exports__["a"] = (MouseWheelInertiaDetector);

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RAF__ = __webpack_require__(45);



__webpack_require__(808);

var Gyroscope = function () {
  function Gyroscope() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Gyroscope);

    // console.info('New Gyroscope Instance created')
    this.orientationX = 0;
    this.orientationY = 0;
    this.enabled = true;
    this.update = this.update.bind(this);
    this.numZeroValues = 0;
    // RAF.add(this._update)
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Gyroscope, [{
    key: 'update',
    value: function update() {
      var _this = this;

      if (!this.enabled) return;

      var fulltiltPromise = new window.FULLTILT.getDeviceOrientation({ 'type': 'game' }); // eslint-disable-line new-cap

      fulltiltPromise.then(function (deviceOrientation) {
        if (_this.numZeroValues > 60) {
          _this.enabled = false;
          __WEBPACK_IMPORTED_MODULE_2__RAF__["a" /* default */].remove(_this._update);
          console.warn('Disabling Gyroscope, reason: number of values at 0 > 60');
          return;
        }
        _this.enabled = true;

        var euler = deviceOrientation.getScreenAdjustedEuler();

        _this.orientationX = euler.beta;
        _this.orientationY = euler.gamma;

        if (_this.orientationX === 0 && _this.orientationY === 0) {
          _this.numZeroValues++;
        } else {
          _this.numZeroValues = 0;
        }

        if (_this.orientationX > 90) {
          _this.orientationY = -_this.orientationY;
        }
        // console.log(this.orientationX, this.orientationY)
      }).catch(function (message) {
        console.warn('Disabling Gyroscope, reason:', message);
        _this.enabled = false;
        // RAF.remove(this._update)
      });
    }
  }]);

  return Gyroscope;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Gyroscope());

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 275,
	"./af.js": 275,
	"./ar": 276,
	"./ar-dz": 277,
	"./ar-dz.js": 277,
	"./ar-kw": 278,
	"./ar-kw.js": 278,
	"./ar-ly": 279,
	"./ar-ly.js": 279,
	"./ar-ma": 280,
	"./ar-ma.js": 280,
	"./ar-sa": 281,
	"./ar-sa.js": 281,
	"./ar-tn": 282,
	"./ar-tn.js": 282,
	"./ar.js": 276,
	"./az": 283,
	"./az.js": 283,
	"./be": 284,
	"./be.js": 284,
	"./bg": 285,
	"./bg.js": 285,
	"./bm": 286,
	"./bm.js": 286,
	"./bn": 287,
	"./bn.js": 287,
	"./bo": 288,
	"./bo.js": 288,
	"./br": 289,
	"./br.js": 289,
	"./bs": 290,
	"./bs.js": 290,
	"./ca": 291,
	"./ca.js": 291,
	"./cs": 292,
	"./cs.js": 292,
	"./cv": 293,
	"./cv.js": 293,
	"./cy": 294,
	"./cy.js": 294,
	"./da": 295,
	"./da.js": 295,
	"./de": 296,
	"./de-at": 297,
	"./de-at.js": 297,
	"./de-ch": 298,
	"./de-ch.js": 298,
	"./de.js": 296,
	"./dv": 299,
	"./dv.js": 299,
	"./el": 300,
	"./el.js": 300,
	"./en-au": 301,
	"./en-au.js": 301,
	"./en-ca": 302,
	"./en-ca.js": 302,
	"./en-gb": 303,
	"./en-gb.js": 303,
	"./en-ie": 304,
	"./en-ie.js": 304,
	"./en-il": 305,
	"./en-il.js": 305,
	"./en-nz": 306,
	"./en-nz.js": 306,
	"./eo": 307,
	"./eo.js": 307,
	"./es": 308,
	"./es-do": 309,
	"./es-do.js": 309,
	"./es-us": 310,
	"./es-us.js": 310,
	"./es.js": 308,
	"./et": 311,
	"./et.js": 311,
	"./eu": 312,
	"./eu.js": 312,
	"./fa": 313,
	"./fa.js": 313,
	"./fi": 314,
	"./fi.js": 314,
	"./fo": 315,
	"./fo.js": 315,
	"./fr": 316,
	"./fr-ca": 317,
	"./fr-ca.js": 317,
	"./fr-ch": 318,
	"./fr-ch.js": 318,
	"./fr.js": 316,
	"./fy": 319,
	"./fy.js": 319,
	"./gd": 320,
	"./gd.js": 320,
	"./gl": 321,
	"./gl.js": 321,
	"./gom-latn": 322,
	"./gom-latn.js": 322,
	"./gu": 323,
	"./gu.js": 323,
	"./he": 324,
	"./he.js": 324,
	"./hi": 325,
	"./hi.js": 325,
	"./hr": 326,
	"./hr.js": 326,
	"./hu": 327,
	"./hu.js": 327,
	"./hy-am": 328,
	"./hy-am.js": 328,
	"./id": 329,
	"./id.js": 329,
	"./is": 330,
	"./is.js": 330,
	"./it": 331,
	"./it.js": 331,
	"./ja": 332,
	"./ja.js": 332,
	"./jv": 333,
	"./jv.js": 333,
	"./ka": 334,
	"./ka.js": 334,
	"./kk": 335,
	"./kk.js": 335,
	"./km": 336,
	"./km.js": 336,
	"./kn": 337,
	"./kn.js": 337,
	"./ko": 338,
	"./ko.js": 338,
	"./ky": 339,
	"./ky.js": 339,
	"./lb": 340,
	"./lb.js": 340,
	"./lo": 341,
	"./lo.js": 341,
	"./lt": 342,
	"./lt.js": 342,
	"./lv": 343,
	"./lv.js": 343,
	"./me": 344,
	"./me.js": 344,
	"./mi": 345,
	"./mi.js": 345,
	"./mk": 346,
	"./mk.js": 346,
	"./ml": 347,
	"./ml.js": 347,
	"./mn": 348,
	"./mn.js": 348,
	"./mr": 349,
	"./mr.js": 349,
	"./ms": 350,
	"./ms-my": 351,
	"./ms-my.js": 351,
	"./ms.js": 350,
	"./mt": 352,
	"./mt.js": 352,
	"./my": 353,
	"./my.js": 353,
	"./nb": 354,
	"./nb.js": 354,
	"./ne": 355,
	"./ne.js": 355,
	"./nl": 356,
	"./nl-be": 357,
	"./nl-be.js": 357,
	"./nl.js": 356,
	"./nn": 358,
	"./nn.js": 358,
	"./pa-in": 359,
	"./pa-in.js": 359,
	"./pl": 360,
	"./pl.js": 360,
	"./pt": 361,
	"./pt-br": 362,
	"./pt-br.js": 362,
	"./pt.js": 361,
	"./ro": 363,
	"./ro.js": 363,
	"./ru": 364,
	"./ru.js": 364,
	"./sd": 365,
	"./sd.js": 365,
	"./se": 366,
	"./se.js": 366,
	"./si": 367,
	"./si.js": 367,
	"./sk": 368,
	"./sk.js": 368,
	"./sl": 369,
	"./sl.js": 369,
	"./sq": 370,
	"./sq.js": 370,
	"./sr": 371,
	"./sr-cyrl": 372,
	"./sr-cyrl.js": 372,
	"./sr.js": 371,
	"./ss": 373,
	"./ss.js": 373,
	"./sv": 374,
	"./sv.js": 374,
	"./sw": 375,
	"./sw.js": 375,
	"./ta": 376,
	"./ta.js": 376,
	"./te": 377,
	"./te.js": 377,
	"./tet": 378,
	"./tet.js": 378,
	"./tg": 379,
	"./tg.js": 379,
	"./th": 380,
	"./th.js": 380,
	"./tl-ph": 381,
	"./tl-ph.js": 381,
	"./tlh": 382,
	"./tlh.js": 382,
	"./tr": 383,
	"./tr.js": 383,
	"./tzl": 384,
	"./tzl.js": 384,
	"./tzm": 385,
	"./tzm-latn": 386,
	"./tzm-latn.js": 386,
	"./tzm.js": 385,
	"./ug-cn": 387,
	"./ug-cn.js": 387,
	"./uk": 388,
	"./uk.js": 388,
	"./ur": 389,
	"./ur.js": 389,
	"./uz": 390,
	"./uz-latn": 391,
	"./uz-latn.js": 391,
	"./uz.js": 390,
	"./vi": 392,
	"./vi.js": 392,
	"./x-pseudo": 393,
	"./x-pseudo.js": 393,
	"./yo": 394,
	"./yo.js": 394,
	"./zh-cn": 395,
	"./zh-cn.js": 395,
	"./zh-hk": 396,
	"./zh-hk.js": 396,
	"./zh-tw": 397,
	"./zh-tw.js": 397
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848;

/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"threeCanvas",staticClass:"three-canvas",class:{'pointer-cursor': _vm.cursorIsPointer, 'in-foreground': _vm.inForeground, 'on-the-side': _vm.detailsPanelConcept !== null},on:{"touchmove":function($event){$event.preventDefault();_vm.preventEvent($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_shuffle__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_RAF__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ElasticNumber__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atoms_CurvedText__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atoms_CurvedTextCanvas__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_normalizeWheel__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_delay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import rand from 'random-seed'







/* global THREE */

// this allows multiple instances of selection wheel
// to share the same data
// allows the frozen glass effect
var sharedData = {
  radii: [],
  angles: [],
  wheelRotation: new __WEBPACK_IMPORTED_MODULE_4__utils_ElasticNumber__["a" /* default */](0),
  isMouseDown: false,
  isPreparing: true,
  mouseDownT: 0,
  mouseDownWheelRot: 0
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConceptsSelectionWheel',

  components: {
    CurvedText: __WEBPACK_IMPORTED_MODULE_5__atoms_CurvedText__["a" /* default */],
    CurvedTextCanvas: __WEBPACK_IMPORTED_MODULE_6__atoms_CurvedTextCanvas__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Viewport__["a" /* default */]],

  props: {
    concepts: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: false
    },
    positions: {
      type: Array,
      required: true
    },
    maxSelection: {
      type: Number,
      required: false,
      default: 10
    },
    preventBlurOnDesktop: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return sharedData;
  },

  mounted: function mounted() {
    var _this = this;

    this._clock = new THREE.Clock();
    this.onConceptsChange(this.concepts);
    this._tempPositionObject = {};
    __WEBPACK_IMPORTED_MODULE_3__utils_RAF__["a" /* default */].add(this.render);
    __WEBPACK_IMPORTED_MODULE_8_lodash_delay___default()(function () {
      _this.isPreparing = false;
    }, 500);
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils_RAF__["a" /* default */].remove(this.render);
  },

  methods: {
    conceptOnScreen: function conceptOnScreen(reference) {
      // let rect = reference.$el.getBoundingClientRect()
      // console.log(rect)
      return true;
    },
    render: function render() {
      var delta = this._clock.getDelta();
      if (this.running && !this.isMouseDown) {
        this.wheelRotation.target -= 0.0015;
      }
      this.wheelRotation.update(delta);

      var positions = [];
      for (var i = 0; i < this.concepts.length; i++) {
        var concept = this.concepts[i];
        if (this.conceptIsSelected(concept)) {
          // position is based on index so we need to loop all concepts
          this.conceptLabelPosition(i, this._tempPositionObject, -40, true);
          var concPos = this._internalConceptPositions[i];
          concPos.x = this._tempPositionObject.x / this.viewPort.width * 2 - 1;
          concPos.y = this._tempPositionObject.y / this.viewPort.height * 2 - 1;
          concPos.t = this._tempPositionObject.t;
          concPos.r = this._tempPositionObject.r;
          positions.push(concPos);
        }
      }
      this.$emit('update:positions', positions);
    },
    onConceptClick: function onConceptClick(concept) {
      var sel = this.selected.concat();
      if (this.conceptIsSelected(concept)) {
        // if concept is already selected then remove it from selection
        concept.confirmed = false;
        // push it at the end of the selection
        var index = sel.indexOf(concept);
        if (index !== -1) {
          sel.splice(index, 1);
          sel.push(concept);
        }
      } else {
        // concept is not selected = add it to selection
        sel.push(concept);
      }
      this.$emit('update:selected', sel);
    },
    conceptIsSelected: function conceptIsSelected(concept) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(this.selected, { label: concept.label }) !== undefined;
    },
    conceptIsConfirmed: function conceptIsConfirmed(concept) {
      return concept.confirmed;
    },
    conceptLabelPosition: function conceptLabelPosition(index) {
      var targetObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var radiusOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var includeWheelRotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var x = this.viewPort.width / 2;
      // add (this.viewPort.height / 2) to make circle center below screen
      var y = this.viewPort.height * 2;
      var r = this.radii[index] * y + radiusOffset;

      var wheelRotation = includeWheelRotation ? this.wheelRotation.value + Math.PI / 2 : 0;

      var t = this.angles[index] + wheelRotation;

      var posX = x + r * Math.cos(t);
      var posY = y + r * Math.sin(t);

      if (targetObject) {
        // write to targetObject to save memory
        // if required
        targetObject.x = posX;
        targetObject.y = posY;
        targetObject.t = t;
        targetObject.r = r;
        return;
      }

      return {
        x: posX,
        y: posY,
        t: t,
        r: r
      };
    },
    wholeWheelStyle: function wholeWheelStyle() {
      if (!this.isPreparing) {
        var x = this.viewPort.width / 2;
        // add (this.viewPort.height / 2) to make circle center below screen
        var y = this.viewPort.height * 2;
        return {
          transform: 'rotate3d(0, 0, 1, ' + (this.wheelRotation.value + Math.PI / 2) + 'rad)',
          transformOrigin: x + 'px ' + y + 'px'
        };
      }
      return {};
    },
    conceptLabelStyle: function conceptLabelStyle(concept, index) {
      if (!this._tempPositionObject) {
        return {};
      }
      this.conceptLabelPosition(index, this._tempPositionObject);
      var color = this.conceptIsSelected(concept) ? '#' + concept.categoryObject.color.toString(16) : null;
      return {
        // transform: `translateX(${this._tempPositionObject.x}px) translateY(${this._tempPositionObject.y}px) rotate(${this._tempPositionObject.t + Math.PI / 2}rad)`,
        transform: 'translate3d(' + this._tempPositionObject.x + 'px, ' + this._tempPositionObject.y + 'px, 0) rotate3d(0, 0, 1, ' + (this._tempPositionObject.t + Math.PI / 2) + 'rad)',
        color: color
      };
    },
    generateRandomPlacement: function generateRandomPlacement() {
      var _this2 = this;

      if (this.radii.length > 0 || this.angles.length > 0) {
        return;
      }
      this.radii = [];
      this.angles = [];
      // this.randRadii.seed('dasdasdsa') // initialize random number generator
      // this.randAngles.seed('sax<dxcsda34asef') // initialize random number generator
      // minimum radius (0 - 1)
      var minrad = 0.65;
      // maximum radius (0 - 1)
      var maxrad = 0.95;
      // number of radii to subdivide our circle into
      // less == more sparse word cloud
      // more == more randomized (but closer)
      var numradii = 6;
      // more angles = more close to each other words
      var numAnglesPerRadius = 5;

      var radiiAngles = [];
      var radStep = (maxrad - minrad) / numradii;

      for (var r = 0; r < numradii; r++) {
        var startAngle = Math.random() * (Math.PI * 2);
        var rad = minrad + r * radStep;
        var nA = Math.round(numAnglesPerRadius + r * Math.PI); // more radius = more angles
        for (var t = 0; t < nA; t++) {
          radiiAngles.push({
            angle: startAngle + t / nA * (Math.PI * 2),
            radius: rad
          });
        }
      }
      // number of concepts we can accomodate
      console.log('max number of concepts wheel can accomodate', radiiAngles.length);
      console.log('number of concepts', this.concepts.length);
      radiiAngles = __WEBPACK_IMPORTED_MODULE_1_lodash_shuffle___default()(radiiAngles);

      this.concepts.forEach(function (concept, index) {
        _this2.radii.push(radiiAngles[index].radius);
        _this2.angles.push(radiiAngles[index].angle);
      });
    },


    onMouseDown: function onMouseDown(event) {
      var x = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].clientY : event.clientY;

      x = this.viewPort.width / 2 - x;
      y = this.viewPort.height - y;
      this.mouseDownT = Math.atan2(x, y);

      this.isMouseDown = true;
      this.mouseDownWheelRot = this.wheelRotation.value;
    },
    onMouseUp: function onMouseUp(event) {
      this.isMouseDown = false;
    },
    onMouseMove: function onMouseMove(event) {
      var x = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].clientY : event.clientY;

      if (this.isMouseDown) {
        x = this.viewPort.width / 2 - x;
        y = this.viewPort.height - y;
        var deltaT = this.mouseDownT - Math.atan2(x, y);
        this.wheelRotation.target = this.mouseDownWheelRot + deltaT * 2;
      }
    },
    onMouseWheel: function onMouseWheel(event) {
      var normalized = Object(__WEBPACK_IMPORTED_MODULE_7__utils_normalizeWheel__["a" /* default */])(event);
      event.preventDefault();
      // console.log(normalized.pixelY, normalized.pixelX)
      this.wheelRotation.target -= (normalized.pixelY + normalized.pixelX) * 0.001;
    },
    onConceptsChange: function onConceptsChange(value) {
      this._internalConceptPositions = value.map(function (concept) {
        return {
          x: 0,
          y: 0,
          concept: concept
        };
      });
      this.generateRandomPlacement();
    }
  },

  computed: {
    running: function running() {
      var running = true;
      this.selected.some(function (concept) {
        if (!concept.confirmed) {
          running = false;
          return true;
        }
      });
      return running;
    }
  },

  watch: {
    concepts: function concepts(value) {
      // console.log('concepts change')
      this.onConceptsChange(value);
    }
  }

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurvedText_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc0d4bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurvedText_vue__ = __webpack_require__(863);
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurvedText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc0d4bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurvedText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 861:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_defer__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_defer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_defer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(82);
//
//
//
//
//
//
//
//
//



var radiansPerDegree = Math.PI / 180;
var degreesPerRadian = 180 / Math.PI;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CurvedText',
  props: {
    enabled: {
      type: Boolean,
      requied: false,
      default: true
    },
    text: {
      type: String,
      required: true
    },
    radius: {
      type: Number,
      required: true
    },
    dir: {
      type: Number,
      required: false,
      default: 1
    },
    forceWidth: {
      type: Boolean,
      required: false,
      default: true
    },
    forceHeight: {
      type: Boolean,
      required: false,
      default: true
    },
    externalStyle: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    internalTransform: {
      type: String,
      required: false,
      // default: 'translateX(-50%)'
      default: 'translate3d(-50%, 0, 0)'
    }
  },

  data: function data() {
    return {
      styles: [],
      calculating: true,
      height: 0,
      width: 0
    };
  },

  computed: {
    letters: function letters() {
      return this.text.trim().split('');
    },
    computedExternalStyle: function computedExternalStyle() {
      // return {}
      if (this.calculating) {
        return {};
      }
      return this.externalStyle;
    },

    computedInternalStyle: function computedInternalStyle() {
      // return {}
      if (this.calculating) {
        return {};
      }
      return {
        height: this.height === 0 ? 'auto' : this.height,
        width: this.width === 0 ? 'auto' : this.width,
        position: 'absolute',
        transform: this.internalTransform
      };
    }
  },

  watch: {
    radius: function radius() {
      this.recalculateStyles();
    },
    dir: function dir() {
      this.recalculateStyles();
    },
    forceWidth: function forceWidth() {
      this.recalculateStyles();
    },
    forceHeight: function forceHeight() {
      this.recalculateStyles();
    },
    text: function text() {
      this.calculateMetrics();
    }
  },

  mounted: function mounted() {
    this.calculateMetrics();
    // this.calculating = false
  },

  methods: {
    calculateMetrics: function calculateMetrics() {
      var _this = this;

      this.styles = [];
      this.height = 0;
      this.width = 0;
      // this.internalStyle = {}
      this.calculating = true;

      __WEBPACK_IMPORTED_MODULE_0_lodash_defer___default()(function () {
        if (!_this.$refs.letterSpan) {
          _this.calculating = false;
          return;
        }

        var _window$getComputedSt = window.getComputedStyle(_this.$el),
            fontSize = _window$getComputedSt.fontSize,
            lineHeight = _window$getComputedSt.lineHeight;

        _this._fontSize = parseFloat(fontSize);
        _this._lineHeight = parseFloat(lineHeight) || _this._fontSize;
        _this._metrics = _this.$refs.letterSpan.map(_this.getRect);
        var totalWidth = _this._metrics.reduce(function (sum, _ref) {
          var width = _ref.width;
          return sum + width;
        }, 0);
        _this._minRadius = totalWidth / Math.PI / 2 + _this._lineHeight;

        _this.recalculateStyles();
        _this.calculating = false;
      });
    },
    recalculateStyles: function recalculateStyles() {
      var _this2 = this;

      if (this._metrics && this._metrics.length > 0) {
        this.styles = [];
        // this.internalStyle = {}

        var radius = this.radius,
            dir = this.dir;

        var originY = dir === -1 ? -radius + this._lineHeight : radius;
        var transformOrigin = 'center ' + originY / this._fontSize + 'em';
        var innerRadius = radius - this._lineHeight;

        var _getLetterRotations = this.getLetterRotations(this._metrics, innerRadius),
            rotations = _getLetterRotations.rotations,
            θ = _getLetterRotations.θ;

        this.$refs.letterSpan.forEach(function (letter, index) {
          // const { style } = letter
          var rotate = (θ * -0.5 + rotations[index]) * dir;
          var translateX = _this2._metrics[index].width * -0.5 / _this2._fontSize;
          var transform = 'translateX(' + translateX + 'em) rotate(' + rotate + 'deg)';
          // const transform = `translate3d(${translateX}em, 0, 0) rotate3d(0, 0, 1, ${rotate}deg)`
          // const transform = `o-translate3d(${translateX}em, 0, 0) rotate3d(0, 0, 1, ${rotate}deg)`

          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(_this2.styles, index, {
            position: 'absolute',
            // top: `-${this._fontSize / 2}px`,
            bottom: dir === -1 ? 0 : 'auto',
            left: '50%',
            transform: transform,
            transformOrigin: transformOrigin
          });
        });

        if (this.forceHeight) {
          var height = θ > 180 ? this.sagitta(radius, θ) : this.sagitta(innerRadius, θ) + this._lineHeight;
          this.height = height / this._fontSize + 'em';
        }

        if (this.forceWidth) {
          var width = this.chord(radius, Math.min(180, θ));
          this.width = width / this._fontSize + 'em';
        }
      }
    },
    splitNode: function splitNode(node) {
      var wrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

      var wrapperElement = document.createElement(wrapper);

      return node.innerText.trim().split('').map(function (char) {
        var parent = wrapperElement.cloneNode();
        parent.insertAdjacentHTML('afterbegin', char === ' ' ? '&nbsp;' : char);
        return parent;
      });
    },
    sagitta: function sagitta(r, θ) {
      return r * (1 - Math.cos(this.degreesToRadians(θ / 2)));
    },
    getRect: function getRect(element) {
      var rect = element.getBoundingClientRect();
      return {
        height: rect.height,
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        width: rect.width
      };
    },
    getLetterRotations: function getLetterRotations(metrics, r) {
      var _this3 = this;

      return metrics.reduce(function (data, _ref2) {
        var width = _ref2.width;

        var rotation = _this3.radiansToDegrees(width / r);

        return {
          θ: data.θ + rotation,
          rotations: data.rotations.concat([data.θ + rotation / 2])
        };
      }, { θ: 0, rotations: [] });
    },
    degreesToRadians: function degreesToRadians(angleInDegrees) {
      return angleInDegrees * radiansPerDegree;
    },
    radiansToDegrees: function radiansToDegrees(angleInRadians) {
      return angleInRadians * degreesPerRadian;
    },
    chord: function chord(r, θ) {
      return 2 * r * Math.sin(this.degreesToRadians(θ / 2));
    }
  }
});

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curved-text-outer-layer",style:(_vm.computedExternalStyle)},[_c('div',{staticClass:"curved-text-inner-layer",style:(_vm.computedInternalStyle)},[_vm._l((_vm.letters),function(letter,index){return (_vm.enabled)?_c('span',{ref:"letterSpan",refInFor:true,staticClass:"curved-text-letter",class:{invisible: _vm.calculating},style:(_vm.styles[index])},[_vm._v(_vm._s(letter))]):_vm._e()}),_vm._v(" "),(!_vm.enabled)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 864:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurvedTextCanvas_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5840e6e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurvedTextCanvas_vue__ = __webpack_require__(867);
function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CurvedTextCanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5840e6e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CurvedTextCanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 865:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CurvedTextCanvas',

  props: {
    text: {
      type: String,
      required: true
    },
    radius: {
      type: Number,
      required: true
    }
  },

  mounted: function mounted() {
    this._context = this.$refs.canvas.getContext('2d');
    this._context.font = '600 14px Muli';
    this._context.textAlign = 'center';
    this.updateText();
  },


  watch: {
    text: function text() {
      this.updateText();
    }
  },

  methods: {
    updateText: function updateText() {
      this._context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      this.drawTextAlongArc(this._context, this.text, 250, 300, 20, Math.PI * 0.2);
    },
    drawTextAlongArc: function drawTextAlongArc(context, str, centerX, centerY, radius, angle) {
      context.save();
      context.translate(centerX, centerY);
      context.rotate(-1 * angle / 2);
      context.rotate(-1 * (angle / str.length) / 2);

      for (var n = 0; n < str.length; n++) {
        context.rotate(angle / str.length);
        context.save();
        context.translate(0, -1 * radius);
        var char = str[n];
        context.fillText(char, 0, 0);
        context.restore();
      }
      context.restore();
    }
  }
});

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticClass:"curved-text-canvas",attrs:{"width":"500","height":"300"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 868:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection-wheel",class:{running: _vm.running, 'prevent-blur-on-desktop': _vm.preventBlurOnDesktop},on:{"mousedown":function($event){$event.preventDefault();_vm.onMouseDown($event)},"mousemove":function($event){$event.preventDefault();_vm.onMouseMove($event)},"mouseup":function($event){$event.preventDefault();_vm.onMouseUp($event)},"touchstart":_vm.onMouseDown,"touchmove":function($event){$event.preventDefault();_vm.onMouseMove($event)},"touchend":_vm.onMouseUp,"mousewheel":_vm.onMouseWheel,"DOMMouseScroll":_vm.onMouseWheel}},[_c('div',{staticClass:"rotating-wheel",style:(_vm.wholeWheelStyle())},_vm._l((_vm.concepts),function(concept,i){return _c('CurvedText',{key:concept.id,staticClass:"concept",class:{selected: _vm.conceptIsSelected(concept), confirmed: _vm.conceptIsConfirmed(concept), disabled: !_vm.conceptIsSelected(concept) && _vm.selected.length >= _vm.maxSelection},attrs:{"enabled":concept.label.length > 20,"text":concept.label.toUpperCase(),"radius":_vm.conceptLabelPosition(i).r,"externalStyle":_vm.conceptLabelStyle(concept, i)},nativeOn:{"click":function($event){_vm.onConceptClick(concept)}}})})),_vm._v(" "),_c('div',{staticClass:"fader"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasConceptsSelectionWheel_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c3bde9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasConceptsSelectionWheel_vue__ = __webpack_require__(881);
function injectStyle (ssrContext) {
  __webpack_require__(870)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52c3bde9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasConceptsSelectionWheel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c3bde9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasConceptsSelectionWheel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 870:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_shuffle__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_RAF__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ElasticNumber__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_normalizeWheel__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_defer__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_defer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_defer__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* global THREE */

// cache for text measument width
var textMeasurementCache = {};
var textBitmaps = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConceptsSelectionWheel',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Viewport__["a" /* default */]],

  props: {
    concepts: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: false
    },
    positions: {
      type: Array,
      required: true
    },
    maxSelection: {
      type: Number,
      required: false,
      default: 10
    },
    preventBlurOnDesktop: {
      type: Boolean,
      default: false
    },
    inactivityTime: {
      type: Number,
      required: false
    },
    forMore: {
      type: Boolean,
      required: false
    }
  },

  data: function data() {
    return {
      radii: [],
      angles: [],
      wheelRotation: new __WEBPACK_IMPORTED_MODULE_6__utils_ElasticNumber__["a" /* default */](0),
      isMouseDown: false,
      overConceptWord: null,
      mouse: new THREE.Vector2(),
      mouseDown: new THREE.Vector2(),
      mouseDownT: 0,
      mouseDownWheelRot: 0,
      fontBase: 1680,
      fontSize: 14
      // hintVisible: false
    };
  },

  mounted: function mounted() {
    this._clock = new THREE.Clock();
    this._conceptWords = [];
    this.onConceptsChange(this.concepts);
    this._tempPositionObject = {};
    this._ctx = this.$refs.canvas.getContext('2d');
    this._lastInteractionTime = this._clock.elapsedTime;

    __WEBPACK_IMPORTED_MODULE_5__utils_RAF__["a" /* default */].add(this.render);
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__utils_RAF__["a" /* default */].remove(this.render);
  },

  methods: {
    onClickOnContainer: function onClickOnContainer(event) {
      if (!this.running) {
        var sel = this.selected.concat();
        sel.splice(-1, 1);
        this.$emit('update:selected', sel);
      }
    },
    render: function render() {
      var delta = this._clock.getDelta();
      if (this.running && !this.isMouseDown) {
        this.wheelRotation.target -= 0.001; // 0.0015
      }
      this.wheelRotation.update(delta);

      var positions = [];
      for (var i = 0; i < this.concepts.length; i++) {
        var concept = this.concepts[i];
        if (this.conceptIsSelected(concept)) {
          // position is based on index so we need to loop all concepts
          this.conceptLabelPosition(i, this._tempPositionObject, 0, true);
          var concPos = this._internalConceptPositions[i];
          concPos.x = this._tempPositionObject.x / this.width * 2 - 1;
          concPos.y = this._tempPositionObject.y / this.height * 2 - 1;
          concPos.t = this._tempPositionObject.t;
          concPos.r = this._tempPositionObject.r;
          positions.push(concPos);
        }
      }
      this.drawCanvas(delta);

      if (!this.running) {
        this._lastInteractionTime = this._clock.elapsedTime;
        // this.hintVisible = false
      }

      this.$emit('update:inactivityTime', this._clock.elapsedTime - this._lastInteractionTime);

      // if (this._clock.elapsedTime - this._lastInteractionTime > 10 && this.$root.platform.mobile) {
      //   this.hintVisible = true
      // }

      this.$emit('update:positions', positions);
    },

    drawCanvas: function drawCanvas(delta) {
      var ctx = this._ctx;

      ctx.clearRect(0, 0, this.width, this.height);

      var overConceptWords = [];

      for (var i = 0; i < this._conceptWords.length; i++) {
        this.conceptLabelPosition(i, this._tempPositionObject, 0, true);

        var conceptWord = this._conceptWords[i];
        conceptWord.selected = this.conceptIsSelected(this.concepts[i]);
        conceptWord.enabled = !(!conceptWord.selected && this.selected.length >= this.maxSelection);

        conceptWord.draw(delta, ctx, this._tempPositionObject.cx, this._tempPositionObject.cy, this._tempPositionObject.t, this._tempPositionObject.r);

        if (conceptWord.isOnScreen) {
          var hitTest = this._conceptWords[i].hitTest(this.mouse);
          if (hitTest !== null) {
            overConceptWords.push({ word: this._conceptWords[i], distance: hitTest });
          }
        }
      }
      if (overConceptWords.length > 0) {
        this.overConceptWord = __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy___default()(overConceptWords, ['distance'])[0].word;
      } else {
        this.overConceptWord = null;
      }
    },
    onConceptClick: function onConceptClick(concept) {
      var sel = this.selected.concat();
      if (this.conceptIsSelected(concept)) {
        // if concept is already selected then remove it from selection
        concept.confirmed = false;
        // push it at the end of the selection
        var index = sel.indexOf(concept);
        if (index !== -1) {
          sel.splice(index, 1);
          sel.push(concept);
        }
      } else {
        // concept is not selected = add it to selection
        sel.push(concept);
      }
      this.$emit('update:selected', sel);
    },
    conceptIsSelected: function conceptIsSelected(concept) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.selected, { label: concept.label }) !== undefined;
    },
    conceptIsConfirmed: function conceptIsConfirmed(concept) {
      return concept.confirmed;
    },
    conceptLabelPosition: function conceptLabelPosition(index) {
      var targetObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var radiusOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var includeWheelRotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var x = this.width / 2;
      // add (this.viewPort.height / 2) to make circle center below screen
      var y = this.height * 2;
      var r = this.radii[index] * y + radiusOffset;

      var wheelRotation = includeWheelRotation ? this.wheelRotation.value + Math.PI / 2 : 0;

      var t = this.angles[index] + wheelRotation;

      var posX = x + r * Math.cos(t);
      var posY = y + r * Math.sin(t);

      if (targetObject) {
        // write to targetObject to save memory
        // if required
        targetObject.x = posX;
        targetObject.y = posY;
        targetObject.t = t;
        targetObject.r = r;
        targetObject.cx = x;
        targetObject.cy = y;
        return;
      }

      return {
        x: posX,
        y: posY,
        t: t,
        r: r,
        cx: x,
        cy: y
      };
    },
    generateRandomPlacement: function generateRandomPlacement() {
      var _this = this;

      if (this.radii.length > 0 || this.angles.length > 0) {
        return;
      }
      this.radii = [];
      this.angles = [];
      // this.randRadii.seed('dasdasdsa') // initialize random number generator
      // this.randAngles.seed('sax<dxcsda34asef') // initialize random number generator
      // minimum radius (0 - 1)
      var minrad = 0.65;
      // maximum radius (0 - 1)
      var maxrad = 0.95;
      // number of radii to subdivide our circle into
      // less == more sparse word cloud
      // more == more randomized (but closer)
      var numradii = 6;
      // more angles = more close to each other words
      var numAnglesPerRadius = 5;

      var radiiAngles = [];
      var radStep = (maxrad - minrad) / numradii;

      for (var r = 0; r < numradii; r++) {
        var startAngle = Math.random() * (Math.PI * 2);
        var rad = minrad + r * radStep;
        var nA = Math.round(numAnglesPerRadius + r * Math.PI); // more radius = more angles
        for (var t = 0; t < nA; t++) {
          radiiAngles.push({
            angle: startAngle + t / nA * (Math.PI * 2),
            radius: rad
          });
        }
      }
      // number of concepts we can accomodate
      console.log('max number of concepts wheel can accomodate', radiiAngles.length);
      console.log('number of concepts', this.concepts.length);
      radiiAngles = __WEBPACK_IMPORTED_MODULE_3_lodash_shuffle___default()(radiiAngles);

      this.concepts.forEach(function (concept, index) {
        _this.radii.push(radiiAngles[index].radius);
        _this.angles.push(radiiAngles[index].angle);
      });
    },


    onMouseDown: function onMouseDown(event) {
      var x = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].clientY : event.clientY;

      x *= window.devicePixelRatio;
      y *= window.devicePixelRatio;

      this.mouse.set(x, y);
      this.mouseDown.set(x, y);

      this._lastInteractionTime = this._clock.elapsedTime;

      x = this.width / 2 - x;
      y = this.height - y;
      this.mouseDownT = Math.atan2(x, y);
      this.isMouseDown = true;
      this.mouseDownWheelRot = this.wheelRotation.value;
    },
    onMouseUp: function onMouseUp(event) {
      this.isMouseDown = false;

      this._lastInteractionTime = this._clock.elapsedTime;
      if (this.overConceptWord && Math.abs(this.mouseDown.distanceTo(this.mouse)) < 20) {
        __WEBPACK_IMPORTED_MODULE_9_lodash_defer___default()(this.onConceptClick, this.overConceptWord.concept);
        // this.onConceptClick(this.overConceptWord.concept)
        // this.hintVisible = false
      } else if (this.$root.platform.mobile) {
        if (Math.abs(this.mouseDown.distanceTo(this.mouse) < 20)) {
          // this is a tap on nothing
          // this.hintVisible = true
        }
      }
    },
    onMouseMove: function onMouseMove(event) {
      var x = event.touches && event.touches.length > 0 ? event.touches[0].clientX : event.clientX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].clientY : event.clientY;

      x *= window.devicePixelRatio;
      y *= window.devicePixelRatio;
      this.mouse.set(x, y);

      // this.hintVisible = false
      if (this.isMouseDown) {
        this._lastInteractionTime = this._clock.elapsedTime;
        x = this.width / 2 - x;
        y = this.height - y;
        var deltaT = this.mouseDownT - Math.atan2(x, y);
        this.wheelRotation.target = this.mouseDownWheelRot + deltaT * 2;
      }
    },
    onMouseWheel: function onMouseWheel(event) {
      var normalized = Object(__WEBPACK_IMPORTED_MODULE_7__utils_normalizeWheel__["a" /* default */])(event);
      this._lastInteractionTime = this._clock.elapsedTime;
      event.preventDefault();
      // console.log(normalized.pixelY, normalized.pixelX)
      this.wheelRotation.target -= (normalized.pixelY + normalized.pixelX) * 0.001;
    },
    onConceptsChange: function onConceptsChange(value) {
      var _this2 = this;

      this._internalConceptPositions = value.map(function (concept) {
        return {
          x: 0,
          y: 0,
          concept: concept
        };
      });
      this.generateRandomPlacement();

      this._conceptWords = value.map(function (concept) {
        return new ConceptWord(concept, { width: _this2.width, height: _this2.height }, window.devicePixelRatio);
      });
    }
  },

  computed: {
    width: function width() {
      return this.viewPort.width * window.devicePixelRatio;
    },
    height: function height() {
      return this.viewPort.height * window.devicePixelRatio;
    },
    pointerCursor: function pointerCursor() {
      return this.overConceptWord !== null;
    },
    running: function running() {
      var running = true;
      this.selected.some(function (concept) {
        if (!concept.confirmed) {
          running = false;
          return true;
        }
      });
      return running;
    }
  },

  watch: {
    viewPort: function viewPort(value) {
      var _this3 = this;

      this._conceptWords.forEach(function (word) {
        word.viewPort = { width: _this3.width, height: _this3.height };
      });
    },
    concepts: function concepts(value) {
      // console.log('concepts change')
      this.onConceptsChange(value);
    }
  }
});

var ConceptWord = function () {
  function ConceptWord(concept, viewPort, pixelRatio) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ConceptWord);

    this.concept = concept;
    this.pixelRatio = pixelRatio;
    this.normalFontSize = 14 * pixelRatio;
    this.fontSize = this.normalFontSize;
    this.selectedFontSize = 24 * pixelRatio;

    this.normalFontColor = new THREE.Color('rgb(111,111,110)');
    this.selectedFontColor = new THREE.Color(concept.categoryObject.color);

    this.selectedAlpha = new __WEBPACK_IMPORTED_MODULE_6__utils_ElasticNumber__["a" /* default */](0);
    this.selectedAlpha.speed = 10;

    this.label = this.concept.label.toUpperCase();
    this.bounds = new THREE.Box2();
    this.screenBounds = new THREE.Box2();
    this.selected = false;
    this.enabled = true;
    this.cachedAngles = {};
    this.cachedCumulativeAngle = [];
    this.viewPort = viewPort;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ConceptWord, [{
    key: 'draw',
    value: function draw(delta, ctx, x, y, t, r) {
      // ctx.clearRect(this.bounds.min.x, this.bounds.min.y, this.bounds.max.x - this.bounds.min.x, this.bounds.max.y - this.bounds.min.y)

      this.selectedAlpha.target = this.selected ? 1 : 0;
      this.selectedAlpha.update(delta);

      // this.fontSize = Math.round(this.lerpNumber(this.normalFontSize, this.selectedFontSize, this.selectedAlpha.value) * 1) / 1
      this.fontSize = this.lerpNumber(this.normalFontSize, this.selectedFontSize, this.selectedAlpha.value);
      var font = '600 ' + this.fontSize + 'px Muli';
      // let font = (this.selected ? '600' : '700') + ' ' + this.fontSize + 'px Muli'
      ctx.font = font;
      // let fillStyle = '#' + this.normalFontColor.clone().lerp(this.selectedFontColor, this.selectedAlpha.value).getHexString()
      var fillStyle = this.selected ? '#' + this.selectedFontColor.getHexString() : '#' + this.normalFontColor.getHexString();
      ctx.fillStyle = fillStyle;

      var angles = [];
      var cumulativeAngle = 0;
      var lastWidth = 0;

      // first pass determine angles
      for (var i = 0; i < this.label.length; i++) {
        var char = this.label.charAt(i);
        // let width = ctx.measureText(char).width

        // use cached widths
        var width = void 0;
        if (!textMeasurementCache[char + '-' + font]) {
          width = ctx.measureText(char).width;
          textMeasurementCache[char + '-' + font] = width;
        } else {
          width = textMeasurementCache[char + '-' + font];
        }
        angles.push(t + cumulativeAngle);
        cumulativeAngle += 2 * Math.asin(width / (r * 2));
        if (i === this.label.length - 1) lastWidth = width;
      }
      var startAngle = -(cumulativeAngle / 2);

      // second pass determine bounds + positions
      var minX = Number.POSITIVE_INFINITY;
      var minY = Number.POSITIVE_INFINITY;
      var maxX = -Number.POSITIVE_INFINITY;
      var maxY = -Number.POSITIVE_INFINITY;
      var posXArray = [];
      var posYArray = [];
      this.screenBounds.min.set(0, 0);
      this.screenBounds.max.set(this.viewPort.width, this.viewPort.height);

      var margin = 10 * this.pixelRatio;

      for (var _i = 0; _i < this.label.length; _i++) {
        var _t = startAngle + angles[_i];
        var posX = posXArray[_i] = x + r * Math.cos(_t);
        var posY = posYArray[_i] = y + r * Math.sin(_t);
        if (posX + margin < 0 || posY + margin < 0 || posX > this.viewPort.width || posY > this.viewPort.height) continue;
        minX = Math.min(posX, minX);
        minY = Math.min(posY - this.fontSize, minY);
        maxX = Math.max(posX + lastWidth, maxX);
        maxY = Math.max(posY, maxY);
      }
      this.bounds.min.set(minX, minY);
      this.bounds.max.set(maxX, maxY);
      this.bounds.expandByScalar(20);

      // 3rd pass draw
      if (this.screenBounds.intersectsBox(this.bounds) && !this.concept.confirmed) {
        for (var _i2 = 0; _i2 < this.label.length; _i2++) {
          var _t2 = startAngle + angles[_i2];
          var _posX = posXArray[_i2];
          var _posY = posYArray[_i2];
          if (_posX + margin < 0 || _posY + margin < 0 || _posX > this.viewPort.width || _posY > this.viewPort.height) continue;
          ctx.save();

          var rotation = _t2 + Math.PI / 2;
          ctx.globalAlpha = this.enabled ? 1 : 0.5;
          // ctx.translate(posX, posY)
          ctx.translate(_posX, _posY - this.fontSize);
          ctx.rotate(rotation);
          // ctx.fillText(this.label.charAt(i), 0, 0)

          var bmp = this.getLetterBitmap(this.label.charAt(_i2), '600 ' + this.selectedFontSize + 'px Muli', fillStyle);

          // bmp.width : selectedFontSize = x : fontSize
          var w = bmp.width * this.fontSize / this.selectedFontSize;
          var h = bmp.height * this.fontSize / this.selectedFontSize;
          ctx.drawImage(bmp, 0, 0, bmp.width, bmp.height, 0, 0, w, h);

          ctx.restore();
        }
        // ctx.strokeRect(this.bounds.min.x, this.bounds.min.y, this.bounds.max.x - this.bounds.min.x, this.bounds.max.y - this.bounds.min.y)
      }
    }
  }, {
    key: 'getLetterBitmap',
    value: function getLetterBitmap(char, font, fillStyle) {
      if (!textBitmaps[char + '-' + font + '-' + fillStyle]) {
        // console.log('create new text bitmap', char, font, fillStyle)
        var canvas = textBitmaps[char + '-' + font + '-' + fillStyle] = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var width = void 0;
        ctx.font = font;
        if (!textMeasurementCache[char + '-' + font]) {
          width = ctx.measureText(char).width;
          textMeasurementCache[char + '-' + font] = width;
        } else {
          width = textMeasurementCache[char + '-' + font];
        }
        var height = this.selectedFontSize;
        canvas.width = width;
        canvas.height = height;
        ctx.font = font;
        ctx.fillStyle = fillStyle;
        ctx.fillText(char, 0, height * 0.85);
      }
      return textBitmaps[char + '-' + font + '-' + fillStyle];
    }
  }, {
    key: 'lerpNumber',
    value: function lerpNumber(v0, v1, t) {
      return v0 + t * (v1 - v0);
    }
  }, {
    key: 'hitTest',
    value: function hitTest(v) {
      if (this.enabled && this.bounds.containsPoint(v)) {
        return Math.abs(this.bounds.getCenter().distanceTo(v));
      }
      return null;
    }
  }, {
    key: 'isOnScreen',
    get: function get() {
      return this.screenBounds.intersectsBox(this.bounds);
    }
  }]);

  return ConceptWord;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection-wheel",class:{running: _vm.running, 'prevent-blur-on-desktop': _vm.preventBlurOnDesktop, 'pointer-cursor': _vm.pointerCursor},on:{"click":_vm.onClickOnContainer}},[_c('canvas',{ref:"canvas",staticClass:"canvas",attrs:{"width":_vm.width,"height":_vm.height},on:{"mousedown":function($event){$event.preventDefault();_vm.onMouseDown($event)},"mousemove":function($event){$event.preventDefault();_vm.onMouseMove($event)},"mouseup":function($event){$event.preventDefault();_vm.onMouseUp($event)},"touchstart":_vm.onMouseDown,"touchmove":function($event){$event.preventDefault();_vm.onMouseMove($event)},"touchend":_vm.onMouseUp,"mousewheel":_vm.onMouseWheel,"DOMMouseScroll":_vm.onMouseWheel}}),_vm._v(" "),_c('div',{staticClass:"fader",class:{'done': _vm.forMore}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptDetailsPanel_vue__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42637936_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptDetailsPanel_vue__ = __webpack_require__(953);
function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42637936"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptDetailsPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42637936_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptDetailsPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 883:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_StoneCanvas__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__molecules_InterestOverTimeGraph__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atoms_MarkdownBlock__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__variables_scss__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_arrow_dx_svg__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_arrow_dx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_arrow_dx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_arrow_sx_svg__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_arrow_sx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_arrow_sx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_close_button_svg__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_close_button_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_close_button_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConceptDetailsPanel',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Viewport__["a" /* default */]],
  components: {
    StoneCanvas: __WEBPACK_IMPORTED_MODULE_1__atoms_StoneCanvas__["a" /* default */],
    InterestOverTimeGraph: __WEBPACK_IMPORTED_MODULE_2__molecules_InterestOverTimeGraph__["a" /* default */],
    MarkdownBlock: __WEBPACK_IMPORTED_MODULE_4__atoms_MarkdownBlock__["a" /* default */],
    ElButton: __WEBPACK_IMPORTED_MODULE_5_element_ui_packages_button__["a" /* default */],
    ArrowNext: __WEBPACK_IMPORTED_MODULE_7__assets_img_arrow_dx_svg___default.a,
    CloseIcon: __WEBPACK_IMPORTED_MODULE_9__assets_img_close_button_svg___default.a,
    ArrowPrev: __WEBPACK_IMPORTED_MODULE_8__assets_img_arrow_sx_svg___default.a
  },
  data: function data() {
    return {
      graphIndex: -1,
      visibleText: true,
      active: true,
      mouse: { x: 0, y: 0 },
      interestOver: null
    };
  },
  props: {
    concept: {
      type: Object,
      required: true
    }
  },
  activated: function activated() {
    this.active = true;

    if (__WEBPACK_IMPORTED_MODULE_0__platform__["a" /* default */].ios) {
      window.addEventListener('resize', this.onIphoneResize.bind(this));
    }
  },
  deactivated: function deactivated() {
    this.active = false;

    if (__WEBPACK_IMPORTED_MODULE_0__platform__["a" /* default */].ios) {
      window.removeEventListener('resize', this.onIphoneResize.bind(this));
    }
  },
  methods: {
    onIphoneResize: function onIphoneResize() {
      var _this = this;

      this.visibleText = false;

      setTimeout(function () {
        _this.visibleText = true;
      });
    },
    onMouseLeave: function onMouseLeave(event, interest) {
      var _this2 = this;

      setTimeout(function () {
        _this2.interestOver = null;
      }, 100);
    },
    onMouseMove: function onMouseMove(event) {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
    },
    onMouseEnter: function onMouseEnter(event, interest) {
      var _this3 = this;

      this._timeout = setTimeout(function () {
        _this3.interestOver = interest;
      }, 100);
    },
    onAboutClick: function onAboutClick() {
      this.$emit('about:click');
    },
    onNextClick: function onNextClick() {
      this.$emit('concept:prev');
    },
    onPrevClick: function onPrevClick() {
      this.$emit('concept:next');
    },

    updateMousePos: function updateMousePos(event) {
      var x = event.touches && event.touches.length > 0 ? event.touches[0].pageX : event.pageX;
      var y = event.touches && event.touches.length > 0 ? event.touches[0].pageY : event.pageY;

      var leftSide = this.viewPort.width > parseInt(__WEBPACK_IMPORTED_MODULE_6__variables_scss___default.a.bpSm) ? this.viewPort.width / 2 : 0;
      if (this.viewPort.height <= y + 110) {
        y -= y + 100 - this.viewPort.height + 50;
      }

      this.mouse.x = Math.min(this.viewPort.width - 280, x) - leftSide;
      this.mouse.y = y;
    },
    interestByRegionConcept: function interestByRegionConcept(interest) {
      return {
        id: this.concept.id,
        category: this.concept.category,
        categoryObject: this.concept.categoryObject,
        activity: interest.interest,
        label: interest.name
      };
    }
  },
  computed: {
    graphActivity: function graphActivity() {
      var value = this.concept.activity;
      var trend = this.concept.trend;
      if (this.graphIndex !== -1) {
        var interest = this.concept.interestOverTime[this.graphIndex].interest;
        var prevIndex = Math.max(0, this.graphIndex - 1);
        var prevInterest = this.concept.interestOverTime[prevIndex].interest;
        value = interest;
        trend = interest > prevInterest ? 1 : -1;
      }
      return { value: value, trend: trend };
    },
    titleStoneCanvasSize: function titleStoneCanvasSize() {
      var width = this.viewPort.width > parseInt(__WEBPACK_IMPORTED_MODULE_6__variables_scss___default.a.bpSm) ? this.viewPort.width / 2 : this.viewPort.width;
      return Math.min(250, Math.min(width, this.viewPort.height) * 0.8) - 40;
    },
    interestCanvasStyle: function interestCanvasStyle() {
      var width = this.viewPort.width > parseInt(__WEBPACK_IMPORTED_MODULE_6__variables_scss___default.a.bpSm) ? this.viewPort.width / 2 : this.viewPort.width;
      return width * 0.3333;
    }
  }
});

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoneCanvas_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f55ce31e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoneCanvas_vue__ = __webpack_require__(888);
function injectStyle (ssrContext) {
  __webpack_require__(886)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f55ce31e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoneCanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f55ce31e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoneCanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 886:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atoms_HopeConceptStone__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atoms_HopeStoneTexture__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_RAF__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_applyToonLighting__ = __webpack_require__(97);

//
//
//
//







/* global THREE */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StoneCanvas',

  // mixins: [Viewport],

  props: {
    width: {
      type: Number,
      required: true,
      default: 100
    },
    height: {
      type: Number,
      required: true,
      default: 100
    },
    // doScreenshot: {
    //   type: Boolean,
    //   required: false,
    //   default: false
    // },
    concept: {
      type: Object,
      required: true,
      default: {
        id: 1,
        category: 1,
        activity: 0.1,
        label: 'social justice'
      }
    },
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    overrideActivity: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          value: -1,
          trend: 1
        };
      }
    }
  },

  data: function data() {
    return {};
  },

  mounted: function mounted() {
    if (!__WEBPACK_IMPORTED_MODULE_1__platform__["a" /* default */].prerenderer) {
      this._renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: this.$refs.threeCanvas,
        alpha: true
        // preserveDrawingBuffer: true
      });
      this._clock = new THREE.Clock();
      this._renderer.toneMapping = THREE.LinearToneMapping;
      this._renderer.setClearColor(0xffffff, 0);
      this._renderer.setPixelRatio(window.devicePixelRatio);
      this._renderer.setSize(this.width, this.height);

      this._scene = new THREE.Scene();

      this._camera = new THREE.PerspectiveCamera(50, this.width / this.height, 0.001, 10);
      this._camera.position.set(0, 0, 0.5);

      this._directionalLight = new THREE.DirectionalLight();
      this._directionalLight.position.set(0, 5, 5);
      this._scene.add(this._directionalLight);

      this.updateStoneConcept(this.concept);
      __WEBPACK_IMPORTED_MODULE_4__utils_RAF__["a" /* default */].add(this.render);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this._scene.traverse(this.destroySceneChildren);
    this._renderer.dispose();
    this._renderer.forceContextLoss();
    // this._renderer.context.getExtension('WEBGL_lose_context').loseContext()
    // console.log('dispose')
    __WEBPACK_IMPORTED_MODULE_4__utils_RAF__["a" /* default */].remove(this.render);
  },

  methods: {
    destroySceneChildren: function destroySceneChildren(value) {
      if (typeof value.destroy === 'function') {
        // console.log('destroy')
        value.destroy();
      } else {
        if (value.geometry) {
          value.geometry.dispose();
        }
        if (value.material) {
          if (value.material.map) {
            value.material.map.dispose();
          }
          value.material.dispose();
        }
      }
    },

    updateStoneConcept: function updateStoneConcept(concept) {
      if (this._conceptStone) {
        if (this.isDifferent(this._conceptStone.config, concept)) {
          this._scene.remove(this._conceptStone);
          this._conceptStone.destroy();
        } else {
          return;
        }
      }
      if (concept) {
        var copyConcept = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, concept);
        copyConcept.importance = 0.1;
        if (this.overrideActivity.value !== -1) {
          copyConcept.activity = this.overrideActivity.value;
          copyConcept.trend = this.overrideActivity.trend;
        }

        // let cat = GoogleHopeService.getConceptCategory(copyConcept)
        this._conceptStone = new __WEBPACK_IMPORTED_MODULE_2__atoms_HopeConceptStone__["a" /* default */](copyConcept, new THREE.MeshToonMaterial({
          specular: new THREE.Color(0x000000),
          shininess: 0,
          map: new __WEBPACK_IMPORTED_MODULE_3__atoms_HopeStoneTexture__["a" /* default */](copyConcept.categoryObject.color, 1),
          transparent: false
        }));
        this._conceptStone.material.onBeforeCompile = __WEBPACK_IMPORTED_MODULE_5__utils_applyToonLighting__["a" /* default */];
        this._conceptStone.setVisible(true);
        this._conceptStone.castShadow = false;
        this._scene.add(this._conceptStone);
        this._ticksBeforeScreenShot = 0;
      }
    },

    isDifferent: function isDifferent(a, b) {
      return a.id !== b.id || a.activity !== b.activity || a.category !== b.category || a.label !== b.label;
    },

    render: function render() {
      if (!this.active) return;

      var delta = this._clock.getDelta();
      if (this._conceptStone) {
        this._conceptStone.update(null, delta, true);

        // if (this.doScreenshot) {
        //   this._ticksBeforeScreenShot++
        //   if (this._ticksBeforeScreenShot === 60) {
        //     this.$emit('screenshot', this._renderer.domElement.toDataURL('image/png'))
        //   }
        // }
      }
      this._renderer.render(this._scene, this._camera, null, true);
    },
    onResize: function onResize() {
      if (this._renderer) {
        this._renderer.setPixelRatio(window.devicePixelRatio);
        this._renderer.setSize(this.width, this.height);
      }

      if (this._camera) {
        this._camera.aspect = this.width / this.height;
        this._camera.updateProjectionMatrix();
      }
    }
  },
  watch: {
    overrideActivity: {
      depp: true,
      handler: function handler(value) {
        this._conceptStone.config.activity = value.value;
        this._conceptStone.config.trend = value.trend;
        this._conceptStone.config = this._conceptStone.config;
      }
    },
    concept: function concept(value) {
      this.updateStoneConcept(value);
    },
    width: function width(value) {
      setTimeout(this.onResize.bind(this));
    },
    height: function height(value) {
      setTimeout(this.onResize.bind(this));
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"threeCanvas",staticClass:"three-canvas"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterestOverTimeGraph_vue__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50422e1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterestOverTimeGraph_vue__ = __webpack_require__(892);
function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50422e1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterestOverTimeGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50422e1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterestOverTimeGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 890:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 891:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InterestOverTimeGraph',
  props: {
    concept: {
      type: Object,
      required: true
    },
    selectedIndex: {
      type: Number
    }
  },

  data: function data() {
    return {};
  },

  methods: {
    detectOverArea: function detectOverArea(event) {
      var element = document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY);
      if (element && element.dataset) {
        var dataset = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(element.dataset));
        if (dataset['overIndex']) {
          this.onOverAreaMouseEnter(parseInt(dataset['overIndex']));
        }
      }
    },
    onMouseLeave: function onMouseLeave() {
      this.$emit('update:selectedIndex', -1);
    },
    onOverAreaMouseEnter: function onOverAreaMouseEnter(index) {
      this.$emit('update:selectedIndex', index);
    },
    getOverAreaStyle: function getOverAreaStyle(index) {
      var l = this.concept.interestOverTime.length;
      var w = 100 / l;

      var backgroundColor = void 0;
      // let pointerEvents

      if (index === this.selectedIndex) {
        backgroundColor = '#' + this.concept.categoryObject.color.toString(16);
        // pointerEvents = 'none'
      }

      return {
        width: w + '%',
        left: w * index + '%',
        backgroundColor: backgroundColor
        // pointerEvents
      };
    },
    getYearStyle: function getYearStyle(year) {
      var l = this.concept.interestOverTime.length;
      var w = 100 / l;
      var index = year.dataIndex;
      return {
        left: w / 2 + w * index + '%'
      };
    }
  },

  computed: {
    selectedDateStyle: function selectedDateStyle() {
      var index = this.selectedIndex === -1 ? this.concept.interestOverTime.length - 1 : this.selectedIndex;
      var l = this.concept.interestOverTime.length;
      var w = 100 / l;
      var x = w / 2 + w * index;

      var margin = 3;
      x = Math.min(100 - margin, Math.max(margin, x));

      return {
        left: x + '%'
      };
    },
    selectedValueStyle: function selectedValueStyle() {
      var index = this.selectedIndex === -1 ? this.concept.interestOverTime.length - 1 : this.selectedIndex;
      var l = this.concept.interestOverTime.length;
      var w = 100 / l;
      var x = w / 2 + w * index;

      var margin = 1;
      x = Math.min(100 - margin, Math.max(margin, x));

      return {
        left: x + '%',
        color: '#' + this.concept.categoryObject.color.toString(16)
      };
    },
    graphPoints: function graphPoints() {
      var ret = '';
      var l = this.concept.interestOverTime.length;
      var w = 100 / l;
      for (var i = 0; i < this.concept.interestOverTime.length; i++) {
        var x = w / 2 + w * i;
        var y = 100 - this.concept.interestOverTime[i].interest * 100;
        y = 2 + y * 0.96;
        ret += x + ',' + y + ' ';
      }
      return ret;
    },
    years: function years() {
      var r = [];
      for (var i = 0; i < this.concept.interestOverTime.length; i++) {
        var entry = this.concept.interestOverTime[i];
        var year = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entry.date).year();
        if (!__WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(r, { label: year })) {
          r.push({
            label: year,
            dataIndex: i
          });
        }
      }
      // push last one
      r.push({
        label: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).year(),
        dataIndex: this.concept.interestOverTime.length - 1
      });
      return r;
    },
    selectedDate: function selectedDate() {
      var year = void 0;

      if (this.selectedIndex !== -1) {
        year = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.selectedIndex].date).year();
      } else {
        year = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).year();
      }

      if (year === __WEBPACK_IMPORTED_MODULE_1_moment___default()().year()) {
        if (this.selectedIndex !== -1) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.selectedIndex].date).format('DD MMM');
        }

        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).format('DD MMM');
      } else {
        if (this.selectedIndex !== -1) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.selectedIndex].date).format('DD MMM YYYY');
        }

        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].date).format('DD MMM YYYY');
      }
    },
    selectedValue: function selectedValue() {
      if (this.selectedIndex !== -1) {
        return Math.round(this.concept.interestOverTime[this.selectedIndex].interest * 100);
      }
      return Math.round(this.concept.interestOverTime[this.concept.interestOverTime.length - 1].interest * 100);
    }
  },

  watch: {}
});

/***/ }),

/***/ 892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interest-over-time-graph",on:{"mouseleave":_vm.onMouseLeave,"touchmove":_vm.detectOverArea}},[_c('transition',{attrs:{"name":"selected-date","mode":"out-in"}},[_c('div',{key:_vm.concept.id,staticClass:"selected-value",style:(_vm.selectedValueStyle)},[_c('div',{staticClass:"selected-value-internal"},[_vm._v(_vm._s(_vm.selectedValue))])])]),_vm._v(" "),_c('transition',{attrs:{"name":"selected-date","mode":"out-in"}},[_c('div',{key:_vm.concept.id,staticClass:"selected-date",style:(_vm.selectedDateStyle)},[_c('div',{staticClass:"selected-date-internal"},[_vm._v(_vm._s(_vm.selectedDate))])])]),_vm._v(" "),_c('div',{staticClass:"graph-container"},[_c('svg',{staticClass:"graph",attrs:{"width":"100%","height":"100%","viewBox":"0 0 100 100","preserveAspectRatio":"none"}},[_c('transition',{attrs:{"mode":"out-in","name":"line"}},[_c('polyline',{key:_vm.concept.id,staticClass:"graph-line",style:({stroke: '#' + _vm.concept.categoryObject.color.toString(16)}),attrs:{"vector-effect":"non-scaling-stroke","points":_vm.graphPoints}})])],1),_vm._v(" "),_c('transition-group',{staticClass:"years-container",attrs:{"tag":"div"}},_vm._l((_vm.years),function(year,index){return _c('div',{key:year.label,staticClass:"year-separator",style:(_vm.getYearStyle(year))},[_c('span',[_vm._v(_vm._s(year.label))])])})),_vm._v(" "),_vm._l((_vm.concept.interestOverTime),function(activity,index){return _c('div',{staticClass:"over-area",style:(_vm.getOverAreaStyle(index)),attrs:{"data-over-index":index},on:{"mouseenter":function($event){_vm.onOverAreaMouseEnter(index)},"touchstart":function($event){_vm.onOverAreaMouseEnter(index)}}})})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 893:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarkdownBlock_vue__ = __webpack_require__(894);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarkdownBlock_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_MarkdownParser__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(82);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    // the text to be displayed formatted in markdown
    text: {
      type: String,
      required: true,
      default: ''
    },
    // decides wether block tags are rendered or not, example:
    // ## input ##
    // some paragraph
    //
    // some other paragraph
    // ## output with true ##
    // <span>
    //   <p>some paragraph</p>
    //   <p>some other paragraph</p>
    // </span>
    // ## output with false ##
    // <span>some paragraph some other paragraph</span>
    inline: {
      type: Boolean,
      default: true
    },
    // the base root tag of this element, can be any tag (div, span, p, etc)
    tag: {
      type: String,
      default: 'span'
    }
  },

  render: function render(createElement, context) {
    var t = Object(__WEBPACK_IMPORTED_MODULE_0__utils_MarkdownParser__["a" /* getTemplate */])(context.props.text, context.props.inline, context.props.tag);
    var compiled = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].compile(t);

    // create a new scope for the compiled markdown template
    var scope = {
      _c: context.parent._c,
      _v: context.parent._v,
      _m: context.parent._m,
      _staticTrees: [],
      _renderProxy: context.parent._renderProxy,
      $options: {
        staticRenderFns: compiled.staticRenderFns
      }
    };

    return createElement({ name: 'MarkdownBlock', render: compiled.render.bind(scope) }, context.data);
  }
});

/***/ }),

/***/ 895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown_it__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_markdown_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_it_link_attributes__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_it_link_attributes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_markdown_it_link_attributes__);


var md = new __WEBPACK_IMPORTED_MODULE_0_markdown_it___default.a().use(__WEBPACK_IMPORTED_MODULE_1_markdown_it_link_attributes___default.a, {
  target: '_blank',
  rel: 'noopener'
});
/* unused harmony default export */ var _unused_webpack_default_export = (md);

/**
 *
 *
 * @param {any} text
 * @param {boolean} [inline=false]
 * @param {string} [rootTag='span']
 * @returns
 */
var gt = function gt(text) {
  var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var rootTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'span';

  // check if root tag exists when inline = true
  if (inline === true && !rootTag) {
    throw new Error('[MarkdownParser] When using inline option you must specify a root tag');
  }
  var templateMarkdown = void 0;
  if (inline) {
    // we parse this with markdown
    // and add a root tag of our choice
    templateMarkdown = (rootTag ? '<' + rootTag + '>' : '') + md.renderInline(text) + (rootTag ? '</' + rootTag + '>' : '');
  } else {
    // or use this if you have multiline elements or you want a <p> tag as root of a single line
    templateMarkdown = (rootTag ? '<' + rootTag + '>' : '') + md.render(text) + (rootTag ? '</' + rootTag + '>' : '');
  }

  // QUICK HACK:
  // [Else](Something "Optional") will get compiled to html links
  // so we replace any <a href="Something" title="Optional">Else</a>
  // with <router-link :to="{name: 'Something' params: {Optional}}">Else</router-link>
  // NOTE: this should leave alone links wich contains non-word characters like . or / so wexternal links still work
  var template = templateMarkdown.replace(/<a href="([\w]+)"[ ]*(title="([^"]*)")?[^>]*>([^<]+)<\/a>/igm, function (match, p1, p2, p3, p4) {
    return '<router-link :to="{name: \'' + p1 + '\'' + (p2 ? ', params: {' + p3 + '}' : '') + '}">' + p4 + '</router-link>';
  });
  // return a new component so that router-links get parsed and rendered
  return template;
};
var gc = function gc(text) {
  var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var rootTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'div';

  return {
    name: 'Markdown',
    template: gt(text, inline, rootTag)
  };
};



/***/ }),

/***/ 898:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);





/* global THREE */
var pattern = new Image();
pattern.src = '/static/img/pattern.jpg';

var HopeStoneTexture = function (_THREE$Texture) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HopeStoneTexture, _THREE$Texture);

  function HopeStoneTexture() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0xffffff;
    var numLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HopeStoneTexture);

    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 128;

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HopeStoneTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HopeStoneTexture)).call(this, canvas));

    _this.canvas = canvas;

    _this.ctx = _this.canvas.getContext('2d');

    _this.magFilter = THREE.NearestFilter;
    _this.minFilter = THREE.NearestFilter;
    _this.wrapS = _this.wrapT = THREE.RepeatWrapping;

    _this.threeColor = new THREE.Color();
    _this.draw(color, numLines);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HopeStoneTexture, [{
    key: 'draw',
    value: function draw(color, numLines) {
      this.ctx.globalAlpha = 1;
      this.ctx.globalCompositeOperation = 'source-over';
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.threeColor.set(color);
      this.ctx.fillStyle = '#' + this.threeColor.getHexString();
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.globalCompositeOperation = 'color-burn';
      this.ctx.drawImage(pattern, 0, 0, this.canvas.width, this.canvas.height);
      this.ctx.globalCompositeOperation = 'source-over';

      this.ctx.strokeStyle = '#ffffff';
      this.ctx.globalAlpha = 0.8;
      this.ctx.lineWidth = this.canvas.height / 40;
      var separation = this.ctx.lineWidth * 4;

      if (numLines > 0) {
        for (var i = 0; i < numLines; i++) {
          var y = this.ctx.lineWidth * 0.5 + i * separation;
          this.ctx.beginPath();
          this.ctx.moveTo(0, y);
          this.ctx.lineTo(this.canvas.width, y);
          this.ctx.stroke();
        }

        this.offset.y = 0.5;
        this.offset.y -= separation * (numLines / 2) / this.canvas.height;
        this.offset.y += separation * 0.5 / this.canvas.height;
      }

      this.needsUpdate = true;
    }
  }]);

  return HopeStoneTexture;
}(THREE.Texture);

/* harmony default export */ __webpack_exports__["a"] = (HopeStoneTexture);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"id":"Livello_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 13.9"}},[_c('path',{staticClass:"st0",attrs:{"d":"M1 13L13 1M1 1l12 12"}})])}}};

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"concept-details",attrs:{"data-block-interaction":""},on:{"mousemove":_vm.updateMousePos,"mouseleave":_vm.onMouseLeave,"touchstart":_vm.updateMousePos,"touchmove":_vm.updateMousePos}},[_c('div',{staticClass:"concept-header"},[_c('span',{staticClass:"back-btn",attrs:{"data-block-interaction":""},on:{"click":function($event){_vm.$emit('update:concept', null)}}},[_vm._v("✕")]),_vm._v(" "),_c('transition',{attrs:{"name":"change-content","mode":"out-in"}},[_c('h1',{key:_vm.concept.id},[_vm._v(_vm._s(_vm.concept.label))])]),_vm._v(" "),_c('span',{staticClass:"about-desktop hover-link",attrs:{"data-block-interaction":""},on:{"click":_vm.onAboutClick}},[_vm._v("ABOUT")])],1),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in"}},[_c('span',{staticClass:"about-mobile",attrs:{"data-block-interaction":""},on:{"click":_vm.onAboutClick}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"centered-stuff"},[_c('transition',{attrs:{"name":"change-content","mode":"out-in"}},[_c('h2',{key:_vm.concept.id},[_vm._v("worldwide")])]),_vm._v(" "),_c('div',{staticClass:"control-arrows"},[_c('div',{staticClass:"arrow arrow-left",on:{"click":_vm.onPrevClick}},[_c('ArrowPrev',{staticClass:"arrow-svg"})],1),_vm._v(" "),_c('div',{staticClass:"arrow arrow-right",on:{"click":_vm.onNextClick}},[_c('ArrowNext',{staticClass:"arrow-svg"})],1)]),_vm._v(" "),_c('StoneCanvas',{attrs:{"width":_vm.titleStoneCanvasSize,"height":_vm.titleStoneCanvasSize,"concept":_vm.concept,"overrideActivity":_vm.graphActivity,"active":_vm.active}}),_vm._v(" "),_c('div',{staticClass:"align-left"},[_c('transition',{attrs:{"name":"change-content","mode":"out-in"}},[_c('h2',{key:_vm.concept.id},[_vm._v("interest over time")])]),_vm._v(" "),_c('transition',{attrs:{"name":"change-content","mode":"out-in"}},[(_vm.visibleText)?_c('p',{key:_vm.concept.id},[_vm._v("This is how people around the world searched for "),_c('span',{style:({color: '#' + _vm.concept.categoryObject.color.toString(16)})},[_vm._v(_vm._s(_vm.concept.entity))]),_vm._v(" on Google in the past 2 years.")]):_vm._e()]),_vm._v(" "),_c('InterestOverTimeGraph',{staticClass:"graph",attrs:{"concept":_vm.concept,"selectedIndex":_vm.graphIndex},on:{"update:selectedIndex":function($event){_vm.graphIndex=$event}}}),_vm._v(" "),_c('transition',{attrs:{"name":"change-content","mode":"out-in"}},[_c('h2',{key:_vm.concept.id},[_vm._v("interest by region")])]),_vm._v(" "),_c('transition',{attrs:{"name":"change-content","mode":"out-in"}},[(_vm.visibleText)?_c('p',{key:_vm.concept.id},[_vm._v("These are the top 6 locations in which the term "),_c('span',{style:({color: '#' + _vm.concept.categoryObject.color.toString(16)})},[_vm._v(_vm._s(_vm.concept.entity))]),_vm._v(" was most popular during the past 2 years.")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.concept.interestByRegion),function(interest){return _c('div',{staticClass:"interest-region",on:{"mouseenter":function($event){_vm.onMouseEnter($event, interest)},"mouseleave":_vm.onMouseLeave,"touchstart":function($event){_vm.onMouseEnter($event, interest)},"touchmove":function($event){_vm.onMouseMove($event)},"touchend":_vm.onMouseLeave}},[_c('StoneCanvas',{staticClass:"interest-region-canvas",attrs:{"width":_vm.interestCanvasStyle,"height":_vm.interestCanvasStyle,"concept":_vm.interestByRegionConcept(interest),"active":_vm.active}}),_vm._v(" "),_c('transition',{attrs:{"name":"interest-region-label","mode":"out-in"}},[_c('div',{key:_vm.concept.id,staticClass:"interest-region-label"},[_vm._v(_vm._s(interest.name))])])],1)})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.interestOver),expression:"interestOver"}],staticClass:"interest-region-popup",style:({transform: 'translate(' + _vm.mouse.x + 'px, ' + _vm.mouse.y + 'px)'})},[_c('div',{staticClass:"title",style:({color: '#' + _vm.concept.categoryObject.color.toString(16)})},[_c('span',[_vm._v(_vm._s(_vm.concept.label))])]),_vm._v(" "),_c('div',{staticClass:"country"},[_c('span',[_vm._v(_vm._s(_vm.interestOver ? _vm.interestOver.name : ''))])]),_vm._v(" "),_c('div',{staticClass:"search-interest"},[_vm._m(0,false,false),_vm._v(" "),_c('span',{staticClass:"interest",style:({color: '#' + _vm.concept.categoryObject.color.toString(16)})},[_vm._v(_vm._s(_vm.interestOver ? Math.round(_vm.interestOver.interest * 100) : ''))])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label"},[_vm._v("SEARCH"),_c('br'),_vm._v("INTEREST")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemSaveForm_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5faecc2b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemSaveForm_vue__ = __webpack_require__(965);
function injectStyle (ssrContext) {
  __webpack_require__(955)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5faecc2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemSaveForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5faecc2b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemSaveForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 955:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_GoogleHopeService__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_packages_input__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_await_to_js__ = __webpack_require__(274);



//
//
//
//
//
//
//
//
//
//
//
//

/* global google */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TotemSaveForm',
  components: {
    ElButton: __WEBPACK_IMPORTED_MODULE_4_element_ui_packages_button__["a" /* default */],
    ElInput: __WEBPACK_IMPORTED_MODULE_5_element_ui_packages_input__["a" /* default */]
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    concepts: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      name: '',
      location: '',
      latitude: null,
      longitude: null,
      error: null
    };
  },

  mounted: function mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs['placeInput'].$el.children[0], { types: ['geocode'] });
    this.autocomplete.addListener('place_changed', this.fillInAddress);
  },

  beforeDestroy: function beforeDestroy() {
    this.autocomplete.unbindAll();
    google.maps.event.clearInstanceListeners(this.$refs['placeInput'].$el.children[0]);
    // google.maps.event.removeListener(this.fillInAddress)
  },

  computed: {
    validForm: function validForm() {
      return this.name !== '' && this.location !== '' && this.name.length > 1 && this.latitude !== null && this.longitude !== null;
    }
  },

  methods: {
    onInputFocus: function onInputFocus(ev) {
      this.$emit('input:focus');
    },
    onInputBlur: function onInputBlur(ev) {
      this.$emit('input:blur');
    },

    onSaveClick: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, _ref3, error, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.error = null;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6_await_to_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__services_GoogleHopeService__["a" /* default */].saveTotem(this.concepts, this.name, { lat: this.latitude, lng: this.longitude }));

              case 3:
                _ref2 = _context.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                error = _ref3[0];
                response = _ref3[1];

                this.error = error;
                if (!error) {
                  console.log('saved', response);
                  this.$emit('update:mode', 'totem');
                  this.$emit('totem:save', response.data);
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSaveClick() {
        return _ref.apply(this, arguments);
      }

      return onSaveClick;
    }(),
    fillInAddress: function fillInAddress() {
      console.log(this.autocomplete, this.autocomplete.getPlace, this.autocomplete.getPlace());

      var place = this.autocomplete.getPlace();
      this.location = place.formatted_address;
      this.latitude = place.geometry.location.lat();
      this.longitude = place.geometry.location.lng();
      // console.log(place.geometry.location.lat(), place.geometry.location.lng())
    }
  }
});

/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_input_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4d554740_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__(964);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4d554740_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_src_mixins_emitter__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_src_mixins_migrating__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calcTextareaHeight__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_src_utils_merge__ = __webpack_require__(963);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElInput',

  componentName: 'ElInput',

  mixins: [__WEBPACK_IMPORTED_MODULE_0_element_ui_src_mixins_emitter__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_element_ui_src_mixins_migrating__["a" /* default */]],

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  data: function data() {
    return {
      currentValue: this.value,
      textareaCalcStyle: {},
      prefixOffset: null,
      suffixOffset: null,
      hovering: false,
      focused: false
    };
  },


  props: {
    value: [String, Number],
    placeholder: String,
    size: String,
    resize: String,
    name: String,
    form: String,
    id: String,
    maxlength: Number,
    minlength: Number,
    readonly: Boolean,
    autofocus: Boolean,
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    autoComplete: {
      type: String,
      default: 'off'
    },
    max: {},
    min: {},
    step: {},
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    validateState: function validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_element_ui_src_utils_merge__["a" /* default */])({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    isGroup: function isGroup() {
      return this.$slots.prepend || this.$slots.append;
    },
    showClear: function showClear() {
      return this.clearable && this.currentValue !== '' && (this.focused || this.hovering);
    }
  },

  watch: {
    'value': function value(val, oldValue) {
      this.setCurrentValue(val);
    }
  },

  methods: {
    focus: function focus() {
      (this.$refs.input || this.$refs.textarea).focus();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
      }
    },
    inputSelect: function inputSelect() {
      (this.$refs.input || this.$refs.textarea).select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: Object(__WEBPACK_IMPORTED_MODULE_2__calcTextareaHeight__["a" /* default */])(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = Object(__WEBPACK_IMPORTED_MODULE_2__calcTextareaHeight__["a" /* default */])(this.$refs.textarea, minRows, maxRows);
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleInput: function handleInput(event) {
      var value = event.target.value;
      this.$emit('input', value);
      this.setCurrentValue(value);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    setCurrentValue: function setCurrentValue(value) {
      var _this = this;

      if (value === this.currentValue) return;
      this.$nextTick(function (_) {
        _this.resizeTextarea();
      });
      this.currentValue = value;
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
      }
    },
    calcIconOffset: function calcIconOffset(place) {
      var pendantMap = {
        'suf': 'append',
        'pre': 'prepend'
      };

      var pendant = pendantMap[place];

      if (this.$slots[pendant]) {
        return { transform: 'translateX(' + (place === 'suf' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)' };
      }
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.setCurrentValue('');
      this.focus();
    }
  },

  created: function created() {
    this.$on('inputSelect', this.inputSelect);
  },
  mounted: function mounted() {
    this.resizeTextarea();
    if (this.isGroup) {
      this.prefixOffset = this.calcIconOffset('pre');
      this.suffixOffset = this.calcIconOffset('suf');
    }
  }
});

/***/ }),

/***/ 964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
  _vm.inputSize ? 'el-input--' + _vm.inputSize : '',
  {
    'is-disabled': _vm.disabled,
    'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
    'el-input-group--append': _vm.$slots.append,
    'el-input-group--prepend': _vm.$slots.prepend,
    'el-input--prefix': _vm.$slots.prefix || _vm.prefixIcon,
    'el-input--suffix': _vm.$slots.suffix || _vm.suffixIcon
  }
  ],on:{"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false}}},[(_vm.type !== 'textarea')?[(_vm.$slots.prepend)?_c('div',{staticClass:"el-input-group__prepend",attrs:{"tabindex":"0"}},[_vm._t("prepend")],2):_vm._e(),_vm._v(" "),(_vm.type !== 'textarea')?_c('input',_vm._b({ref:"input",staticClass:"el-input__inner",attrs:{"autocomplete":_vm.autoComplete,"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'input',_vm.$props,false)):_vm._e(),_vm._v(" "),(_vm.$slots.prefix || _vm.prefixIcon)?_c('span',{staticClass:"el-input__prefix",style:(_vm.prefixOffset)},[_vm._t("prefix"),_vm._v(" "),(_vm.prefixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.prefixIcon}):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.$slots.suffix || _vm.suffixIcon || _vm.showClear || _vm.validateState && _vm.needStatusIcon)?_c('span',{staticClass:"el-input__suffix",style:(_vm.suffixOffset)},[_c('span',{staticClass:"el-input__suffix-inner"},[(!_vm.showClear)?[_vm._t("suffix"),_vm._v(" "),(_vm.suffixIcon)?_c('i',{staticClass:"el-input__icon",class:_vm.suffixIcon}):_vm._e()]:_c('i',{staticClass:"el-input__icon el-icon-circle-close el-input__clear",on:{"click":_vm.clear}})],2),_vm._v(" "),(_vm.validateState)?_c('i',{staticClass:"el-input__icon",class:['el-input__validateIcon', _vm.validateIcon]}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$slots.append)?_c('div',{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c('textarea',_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:(_vm.textareaStyle),attrs:{"aria-label":_vm.label},domProps:{"value":_vm.currentValue},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"change":_vm.handleChange}},'textarea',_vm.$props,false))],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"totem-save-form",attrs:{"data-block-interaction":""}},[_c('h1',[_vm._v("We're balancing your Hopes!")]),_vm._v(" "),_c('div',[_c('el-input',{attrs:{"placeholder":"What’s your name?"},on:{"focus":_vm.onInputFocus,"blur":_vm.onInputBlur},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('div',[_c('el-input',{ref:"placeInput",attrs:{"placeholder":"Where are you now?"},on:{"focus":_vm.onInputFocus,"blur":_vm.onInputBlur},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1),_vm._v(" "),(_vm.error && _vm.error.response && _vm.error.response.data)?_c('div',{staticClass:"error"},_vm._l((_vm.error.response.data.details),function(detail,index){return _c('div',[_vm._v(_vm._s(detail.message))])})):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"done-btn",attrs:{"disabled":!_vm.validForm},on:{"click":_vm.onSaveClick}},[_vm._v("DONE")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroScreen_vue__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286bd0c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroScreen_vue__ = __webpack_require__(973);
function injectStyle (ssrContext) {
  __webpack_require__(967)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-286bd0c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntroScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286bd0c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntroScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 967:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_HopeConceptStone__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atoms_HopeStoneTexture__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_RAF__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_random_seed__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_random_seed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_random_seed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animejs__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_applyToonLighting__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_about_5_svg__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_about_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_about_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_desktop_logo1_svg__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_desktop_logo1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_desktop_logo1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_desktop_logo2_svg__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_desktop_logo2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_desktop_logo2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_mobile_logo1_svg__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_mobile_logo1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_mobile_logo1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_mobile_logo2_svg__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_mobile_logo2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_mobile_logo2_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global THREE */

















// import Viewport from '@/mixins/Viewport'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntroScreen',
  // mixins: [Viewport],
  components: {
    ElButton: __WEBPACK_IMPORTED_MODULE_7_element_ui_packages_button__["a" /* default */],
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_9__assets_img_about_5_svg___default.a,
    AccuratLogo: __WEBPACK_IMPORTED_MODULE_10__assets_img_desktop_logo1_svg___default.a,
    GoogleLogo: __WEBPACK_IMPORTED_MODULE_11__assets_img_desktop_logo2_svg___default.a,
    GoogleLogoMobile: __WEBPACK_IMPORTED_MODULE_13__assets_img_mobile_logo2_svg___default.a,
    AccuratLogoMobile: __WEBPACK_IMPORTED_MODULE_12__assets_img_mobile_logo1_svg___default.a
  },
  props: {
    mode: {
      required: true,
      type: String
    }
  },
  data: function data() {
    return {
      stoneShapeIndex: 0,
      stoneStates: [{ color: 0x925DE8 }, { color: 0x2B71E2 }, { color: 0xFFBE2E }, { color: 0xFF85CE }, { color: 0xFF556A }, { color: 0x48C4EF }, { color: 0xFF8E55 }, { color: 0x64E2BB }],
      showDownload: false,
      width: 200,
      height: 200,
      stoneChangeDelay: 1000,
      stoneChangeSpeed: 500,
      // stoneChangeDelay: 5000,
      // stoneChangeSpeed: 700,
      stoneColorAlpha: 0,
      stoneMorphComplete: false
    };
  },

  mounted: function mounted() {
    if (!__WEBPACK_IMPORTED_MODULE_0__platform__["a" /* default */].prerenderer) {
      this._renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: this.$refs.threeCanvas,
        alpha: true
      });
      this._clock = new THREE.Clock();
      this._renderer.toneMapping = THREE.LinearToneMapping;
      this._renderer.setClearColor(0xffffff, 0);
      this._renderer.setPixelRatio(window.devicePixelRatio);
      this._renderer.setSize(this.width, this.height);

      this._scene = new THREE.Scene();

      this._camera = new THREE.PerspectiveCamera(50, this.width / this.height, 0.001, 10);
      this._camera.position.set(0, 0, 1);

      this._directionalLight = new THREE.DirectionalLight();
      this._directionalLight.position.set(0, 5, 5);
      this._scene.add(this._directionalLight);

      var concept = {
        activity: 0.5,
        category: 0,
        id: 0,
        importance: 0.5,
        label: 'intro',
        trend: -1
      };

      this._texture = new __WEBPACK_IMPORTED_MODULE_2__atoms_HopeStoneTexture__["a" /* default */](this.stoneStates[this.stoneShapeIndex].color, 1);

      this._conceptStone = new __WEBPACK_IMPORTED_MODULE_1__atoms_HopeConceptStone__["a" /* default */](concept, new THREE.MeshToonMaterial({
        specular: new THREE.Color(0x000000),
        shininess: 0,
        map: this._texture,
        transparent: false,
        morphTargets: true
      }), false, false);

      this._conceptStone.material.onBeforeCompile = __WEBPACK_IMPORTED_MODULE_8__utils_applyToonLighting__["a" /* default */];

      var randomGenerator = __WEBPACK_IMPORTED_MODULE_4_random_seed___default.a.create();
      this._conceptStone.geometry = this.generateGeometry(randomGenerator);

      for (var i = 0; i < this.stoneStates.length; i++) {
        var newGeo = this.generateGeometry(randomGenerator);
        this._conceptStone.geometry.morphTargets.push({ name: 'target' + i, vertices: newGeo.vertices, influence: i === 0 ? 1 : 0 });
      }

      this._conceptStone.updateMorphTargets();
      this._conceptStone.setVisible(true);
      this._scene.add(this._conceptStone);

      __WEBPACK_IMPORTED_MODULE_5_lodash_delay___default()(this.changeStone, this.stoneChangeDelay);

      __WEBPACK_IMPORTED_MODULE_3__utils_RAF__["a" /* default */].add(this.render);
    }
  },

  beforeDestroy: function beforeDestroy() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_lodash_delay___default()(function () {
      _this._scene.traverse(_this.destroySceneChildren);
      _this._renderer.dispose();
      _this._renderer.forceContextLoss();
      __WEBPACK_IMPORTED_MODULE_3__utils_RAF__["a" /* default */].remove(_this.render);
      _this._destroyed = true;
    }, 2000);
  },

  computed: {},

  methods: {
    onStoneClick: function onStoneClick() {
      if (this.stoneMorphComplete) {
        this.$emit('update:mode', 'wheel');
      }
    },
    onMouseEnter: function onMouseEnter() {
      this.showDownload = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.showDownload = false;
    },


    generateGeometry: function generateGeometry(randomGenerator) {
      var vTotal = new THREE.Vector3();
      var vNumber = 0;
      var geometry = new THREE.IcosahedronGeometry(1, 0);

      geometry.rotateX(randomGenerator.floatBetween(-Math.PI / 4, Math.PI / 4));
      geometry.rotateZ(randomGenerator.floatBetween(-Math.PI / 4, Math.PI / 4));
      // geometry.rotateY(randomGenerator.floatBetween(0, Math.PI))
      // geometry.rotateZ(randomGenerator.floatBetween(0, Math.PI))

      geometry.vertices.forEach(function (vertex) {
        vertex.multiplyScalar(randomGenerator.floatBetween(0.3, 1));
        vTotal.add(vertex);
        vNumber++;
      });

      vTotal.divideScalar(vNumber);
      geometry.translate(-vTotal.x, -vTotal.y, -vTotal.z);

      var sub = new THREE.SubdivisionModifier(2);
      sub.modify(geometry);

      return geometry;
    },

    changeStone: function changeStone() {
      var _this2 = this;

      if (this._destroyed) return;
      this.stoneShapeIndex++;
      if (this.stoneShapeIndex < this.stoneStates.length) {
        var prevIndex = this.stoneShapeIndex === 0 ? this._conceptStone.geometry.morphTargets.length - 1 : this.stoneShapeIndex - 1;
        __WEBPACK_IMPORTED_MODULE_6_animejs___default()({
          targets: this._conceptStone.geometry.morphTargets[prevIndex],
          influence: 0,
          duration: this.stoneChangeSpeed,
          easing: 'easeOutCubic'
        });
        __WEBPACK_IMPORTED_MODULE_6_animejs___default()({
          targets: this._conceptStone.geometry.morphTargets[this.stoneShapeIndex],
          influence: 1,
          duration: this.stoneChangeSpeed,
          easing: 'easeOutCubic'
        });
        // let state = this.stoneStates[this.stoneShapeIndex]
        // this._texture.draw(state.color, 1)

        this.stoneColorAlpha = 0;
        __WEBPACK_IMPORTED_MODULE_6_animejs___default()({
          targets: this,
          stoneColorAlpha: 1,
          duration: this.stoneChangeSpeed,
          easing: 'easeOutCubic',
          update: function update(anim) {
            // if (!this.stoneStates[prevIndex] || this.stoneStates[prevIndex]) {
            //   return
            // }

            var prevColor = new THREE.Color(_this2.stoneStates[prevIndex].color);
            var nowColor = new THREE.Color(_this2.stoneStates[_this2.stoneShapeIndex].color);
            prevColor.lerp(nowColor, anim.animations[0].currentValue);
            _this2._texture.draw(prevColor.getHex(), 1);
          }
        });

        __WEBPACK_IMPORTED_MODULE_5_lodash_delay___default()(this.changeStone, this.stoneChangeDelay);
      } else {
        if (__WEBPACK_IMPORTED_MODULE_0__platform__["a" /* default */].mobile) {
          this.$emit('update:mode', 'wheel');
        } else {
          this.stoneMorphComplete = true;
          this.stoneShapeIndex = -1;
          this.changeStone();
          // delay(this.changeStone, this.stoneChangeDelay)
        }
      }
    },
    render: function render() {
      var _this3 = this;

      // if (!this.active) return

      this._conceptStone.geometry.morphTargets.forEach(function (target, i) {
        _this3._conceptStone.morphTargetInfluences[i] = target.influence;
      });

      var delta = this._clock.getDelta();
      if (this._conceptStone) {
        this._conceptStone.update(null, delta, true);
      }
      this._renderer.render(this._scene, this._camera, null, true);
    },
    onResize: function onResize() {

      // if (this._renderer) {
      //   this._renderer.setPixelRatio(window.devicePixelRatio)
      //   this._renderer.setSize(this.viewPort.width, this.viewPort.height)
      // }

      // if (this._camera) {
      //   this._camera.aspect = this.viewPort.width / this.viewPort.height
      //   this._camera.updateProjectionMatrix()
      // }
    },
    destroySceneChildren: function destroySceneChildren(value) {
      if (typeof value.destroy === 'function') {
        // console.log('destroy')
        value.destroy();
      } else {
        if (value.geometry) {
          value.geometry.dispose();
        }
        if (value.material) {
          if (value.material.map) {
            value.material.map.dispose();
          }
          value.material.dispose();
        }
      }
    }
  },

  watch: {
    stoneMorphComplete: function stoneMorphComplete() {
      if (__WEBPACK_IMPORTED_MODULE_0__platform__["a" /* default */].mobile) {
        this.$emit('update:mode', 'wheel');
      }
    },
    viewPort: function viewPort(value) {
      this.onResize();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 211.64 15.96"}},[_c('title',[_v("desktop_logo1")]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M102.8 6.72a.76.76 0 0 0 .66-.42 1.32 1.32 0 0 0 .1-.55 1.17 1.17 0 0 0-.56-1.07 2.66 2.66 0 0 0-1.48-.33A2 2 0 0 0 100 5a2.17 2.17 0 0 0-.34 1h-1.39a2.48 2.48 0 0 1 1-2.21 4.13 4.13 0 0 1 2.29-.61 4.65 4.65 0 0 1 2.45.57 1.94 1.94 0 0 1 .93 1.8v4.92a.64.64 0 0 0 .1.36c.05.1.19.14.38.14a.82.82 0 0 0 .21 0 1.09 1.09 0 0 0 .25 0V12a4.51 4.51 0 0 1-.52.11 3.18 3.18 0 0 1-.48 0 1.13 1.13 0 0 1-1.06-.53 1.94 1.94 0 0 1-.25-.78 3.5 3.5 0 0 1-1.26 1 4 4 0 0 1-1.82.42 2.66 2.66 0 0 1-1.94-.73 2.42 2.42 0 0 1-.77-1.81 2.35 2.35 0 0 1 .75-1.85 3.4 3.4 0 0 1 2-.8zm-3 3.89a1.79 1.79 0 0 0 1.09.37 3.34 3.34 0 0 0 1.47-.35 2 2 0 0 0 1.2-1.91V7.56a2.64 2.64 0 0 1-.67.29A4.55 4.55 0 0 1 102 8l-.88.11a3.24 3.24 0 0 0-1.16.33 1.29 1.29 0 0 0-.67 1.2 1.14 1.14 0 0 0 .47.97zM113.92 3.8A3.33 3.33 0 0 1 115 6.22h-1.39a2.75 2.75 0 0 0-.57-1.31 1.83 1.83 0 0 0-1.45-.52 2 2 0 0 0-2 1.34 5.34 5.34 0 0 0-.38 2.13 4 4 0 0 0 .53 2.16 2.08 2.08 0 0 0 3.11.33 3.07 3.07 0 0 0 .73-1.49H115a3.66 3.66 0 0 1-1.2 2.48 3.79 3.79 0 0 1-2.46.78 3.26 3.26 0 0 1-2.68-1.22 4.7 4.7 0 0 1-1-3.05 5.19 5.19 0 0 1 1.09-3.52 3.53 3.53 0 0 1 2.79-1.26 3.73 3.73 0 0 1 2.38.73zM123.09 3.8a3.32 3.32 0 0 1 1.08 2.42h-1.39a2.59 2.59 0 0 0-.59-1.31 1.84 1.84 0 0 0-1.47-.52 2 2 0 0 0-2 1.34 5.34 5.34 0 0 0-.38 2.13 3.83 3.83 0 0 0 .55 2.16 1.87 1.87 0 0 0 1.7.88 1.89 1.89 0 0 0 1.42-.55 3.07 3.07 0 0 0 .72-1.49h1.39a3.66 3.66 0 0 1-1.2 2.48 3.81 3.81 0 0 1-2.44.78 3.23 3.23 0 0 1-2.67-1.22 4.65 4.65 0 0 1-1-3.05 5.24 5.24 0 0 1 1.09-3.52 3.53 3.53 0 0 1 2.79-1.26 3.82 3.82 0 0 1 2.4.73zM128 3.34V9a2.22 2.22 0 0 0 .21 1.07 1.4 1.4 0 0 0 1.39.76 2 2 0 0 0 2-1.34 5.46 5.46 0 0 0 .28-2V3.36h1.44v8.53H132v-1.26a3.07 3.07 0 0 1-.69.82 3 3 0 0 1-2 .67 2.5 2.5 0 0 1-2.45-1.22 3.83 3.83 0 0 1-.34-1.76V3.32H128zM136.71 3.34h1.38v1.47a3.22 3.22 0 0 1 .82-1 2.08 2.08 0 0 1 1.51-.61h.45v1.51a1.57 1.57 0 0 1-.24 0h-.23a2.07 2.07 0 0 0-1.68.7 2.48 2.48 0 0 0-.57 1.59v4.9h-1.44V3.34zM147.69 6.72a.78.78 0 0 0 .67-.42 1.53 1.53 0 0 0 .09-.55 1.18 1.18 0 0 0-.51-1.07 2.7 2.7 0 0 0-1.49-.33 2 2 0 0 0-1.61.61 2.17 2.17 0 0 0-.34 1h-1.33a2.44 2.44 0 0 1 1-2.21 4.09 4.09 0 0 1 2.29-.61 4.64 4.64 0 0 1 2.44.57 1.94 1.94 0 0 1 .93 1.8v4.92a.64.64 0 0 0 .1.36c.06.1.19.14.38.14a.78.78 0 0 0 .21 0 1.09 1.09 0 0 0 .25 0V12c-.23.06-.4.09-.52.11a3 3 0 0 1-.47 0 1.13 1.13 0 0 1-1.07-.53 1.94 1.94 0 0 1-.25-.78 3.5 3.5 0 0 1-1.26 1 3.89 3.89 0 0 1-1.81.42 2.71 2.71 0 0 1-1.95-.73 2.41 2.41 0 0 1-.76-1.81 2.38 2.38 0 0 1 .74-1.85 3.46 3.46 0 0 1 2-.8zm-3 3.89a1.79 1.79 0 0 0 1.09.37 3.31 3.31 0 0 0 1.47-.35 2 2 0 0 0 1.2-1.91V7.56a2.72 2.72 0 0 1-.66.29 4.9 4.9 0 0 1-.82.15l-.86.11a3.5 3.5 0 0 0-1.19.33 1.28 1.28 0 0 0-.66 1.2 1.24 1.24 0 0 0 .39.97zM153.47 1h1.45v2.34h1.38v1.18h-1.38v5.58a.58.58 0 0 0 .31.59 1.24 1.24 0 0 0 .55.09h.52v1.14a4.87 4.87 0 0 1-.52.12h-.57a1.58 1.58 0 0 1-1.37-.51 2.21 2.21 0 0 1-.37-1.34V4.54h-1.16V3.36h1.16V1zM176.68.27h1.37v11.91h-1.37zM182.12.27h1.37v11.91h-1.37zM187.58.27h1.37v11.91h-1.37zM193.03.27h1.37v11.91h-1.37zM210.27.27h1.37v11.91h-1.37zM170.48.44h1.21l-3.71 11.74h.04L171.87.27h-1.43l-3.86 11.91h.19L170.48.44z","fill":"#606060"}}),_c('path',{attrs:{"fill":"#606060","d":"M170.48.44l-3.71 11.74h1.21L171.69.44h-1.21zM204.07.44h1.22l-3.72 11.74h.03L205.45.27h-1.43l-3.86 11.91h.2L204.07.44z"}}),_c('path',{attrs:{"fill":"#606060","d":"M204.07.44l-3.71 11.74h1.21L205.29.44h-1.22z"}}),_c('text',{attrs:{"transform":"translate(0 11.98)","font-size":"14","fill":"#565656","font-family":"Muli-Light, Muli"}},[_v("designed by")])])])}}};

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (mat) {
  mat.fragmentShader = mat.fragmentShader.replace('#include <gradientmap_pars_fragment>', '#ifdef TOON\n      uniform sampler2D gradientMap;\n      vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n        // dotNL will be from -1.0 to 1.0\n        float dotNL = dot( normal, lightDirection );\n        vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n        #ifdef USE_GRADIENTMAP\n          return texture2D( gradientMap, coord ).rgb;\n        #else\n          return ( coord.x < 0.7 ) ? vec3( 0.85 ) : vec3( 1.0 );\n        #endif\n      }\n    #endif');
});

/***/ }),

/***/ 970:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 289.63 18.62"}},[_c('title',[_v("desktop_logo2")]),_c('g',{attrs:{"data-name":"Layer 2","fill":"#565656"}},[_c('text',{attrs:{"transform":"translate(0 13.49)","font-size":"14","font-family":"Muli-Light, Muli"}},[_v("supported by")]),_c('text',{attrs:{"transform":"translate(105.48 13.69)","font-size":"16","font-family":"Muli-SemiBold, Muli","font-weight":"700"}},[_v("Google News Inititative")])])])}}};

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.82 31.94"}},[_c('title',[_v("mobile_logo1")]),_c('g',{attrs:{"data-name":"Layer 2","fill":"#565656"}},[_c('path',{attrs:{"d":"M5 26.48a.76.76 0 0 0 .67-.42 1.37 1.37 0 0 0 .1-.56 1.2 1.2 0 0 0-.52-1.07 2.77 2.77 0 0 0-1.49-.32 2 2 0 0 0-1.6.61 2.13 2.13 0 0 0-.35 1H.46a2.46 2.46 0 0 1 1-2.21 4.11 4.11 0 0 1 2.29-.61 4.64 4.64 0 0 1 2.44.57 1.93 1.93 0 0 1 .94 1.79v4.94a.73.73 0 0 0 .09.36c.06.1.19.14.38.14a.78.78 0 0 0 .21 0 1 1 0 0 0 .25 0v1.07l-.51.11a3.33 3.33 0 0 1-.48 0A1.13 1.13 0 0 1 6 31.31a2.1 2.1 0 0 1-.25-.79 3.25 3.25 0 0 1-1.26 1 3.89 3.89 0 0 1-1.81.42 2.71 2.71 0 0 1-1.95-.73A2.46 2.46 0 0 1 0 29.4a2.35 2.35 0 0 1 .74-1.85 3.54 3.54 0 0 1 2-.81zm-3 3.89a1.73 1.73 0 0 0 1 .36 3.27 3.27 0 0 0 1.47-.34 2 2 0 0 0 1.21-1.91v-1.16a2.33 2.33 0 0 1-.68.28 4 4 0 0 1-.82.16l-.88.11a3.35 3.35 0 0 0-1.16.32 1.29 1.29 0 0 0-.67 1.21 1.11 1.11 0 0 0 .53.97zM16.11 23.56A3.35 3.35 0 0 1 17.2 26h-1.4a2.64 2.64 0 0 0-.57-1.32 1.84 1.84 0 0 0-1.45-.51 2 2 0 0 0-2 1.33 5.61 5.61 0 0 0-.38 2.14 3.91 3.91 0 0 0 .6 2.14 1.85 1.85 0 0 0 1.7.88 1.84 1.84 0 0 0 1.41-.56 3 3 0 0 0 .72-1.49h1.4A3.75 3.75 0 0 1 16 31.1a3.82 3.82 0 0 1-2.47.78 3.25 3.25 0 0 1-2.67-1.22 4.67 4.67 0 0 1-1-3.06A5.18 5.18 0 0 1 11 24.09a3.51 3.51 0 0 1 2.78-1.26 3.74 3.74 0 0 1 2.33.73zM25.27 23.56A3.35 3.35 0 0 1 26.36 26H25a2.59 2.59 0 0 0-.6-1.32 1.86 1.86 0 0 0-1.47-.51 2 2 0 0 0-2 1.33 5.43 5.43 0 0 0-.38 2.14 3.83 3.83 0 0 0 .55 2.16 1.86 1.86 0 0 0 1.7.88 1.84 1.84 0 0 0 1.41-.56 3 3 0 0 0 .79-1.51h1.39a3.67 3.67 0 0 1-1.2 2.49 3.82 3.82 0 0 1-2.45.78A3.25 3.25 0 0 1 20 30.66a4.67 4.67 0 0 1-1-3.06 5.18 5.18 0 0 1 1.09-3.51 3.51 3.51 0 0 1 2.78-1.26 3.78 3.78 0 0 1 2.4.73zM30.21 23.1v5.69a2.22 2.22 0 0 0 .21 1.07 1.4 1.4 0 0 0 1.4.76 1.94 1.94 0 0 0 2-1.34 5.44 5.44 0 0 0 .29-2v-4.2h1.43v8.53h-1.37v-1.26a3.45 3.45 0 0 1-.69.82 3 3 0 0 1-2 .67 2.5 2.5 0 0 1-2.44-1.22 3.83 3.83 0 0 1-.34-1.76v-5.78h1.46zM38.9 23.1h1.37v1.47a3.54 3.54 0 0 1 .82-1.05 2.1 2.1 0 0 1 1.51-.61h.46v1.52h-.48a2.06 2.06 0 0 0-1.68.71 2.47 2.47 0 0 0-.57 1.6v4.91H38.9V23.1zM49.87 26.48a.76.76 0 0 0 .67-.42 1.37 1.37 0 0 0 .1-.56 1.18 1.18 0 0 0-.52-1.07 2.77 2.77 0 0 0-1.49-.32 2 2 0 0 0-1.6.61 2 2 0 0 0-.34 1h-1.34a2.46 2.46 0 0 1 1-2.21 4.11 4.11 0 0 1 2.29-.61 4.68 4.68 0 0 1 2.45.57 1.92 1.92 0 0 1 .93 1.79v4.94a.64.64 0 0 0 .1.36c.05.1.19.14.38.14a.82.82 0 0 0 .21 0 1.18 1.18 0 0 0 .25 0v1.07l-.52.11a3.11 3.11 0 0 1-.48 0 1.14 1.14 0 0 1-1.07-.53 1.94 1.94 0 0 1-.24-.79 3.41 3.41 0 0 1-1.26 1 4 4 0 0 1-1.82.42 2.66 2.66 0 0 1-1.94-.73 2.43 2.43 0 0 1-.77-1.81 2.33 2.33 0 0 1 .75-1.85 3.47 3.47 0 0 1 1.94-.81zm-3 3.89a1.78 1.78 0 0 0 1.09.36 3.33 3.33 0 0 0 1.47-.34 2 2 0 0 0 1.2-1.91v-1.16a2.33 2.33 0 0 1-.67.28 4 4 0 0 1-.82.16l-.86.11a3.78 3.78 0 0 0-1.18.32 1.29 1.29 0 0 0-.67 1.21 1.22 1.22 0 0 0 .41.97zM55.66 20.71h1.45v2.39h1.37v1.18h-1.37v5.58a.57.57 0 0 0 .3.59 1.51 1.51 0 0 0 .56.09h.51v1.15a3.1 3.1 0 0 1-.51.11 5 5 0 0 1-.58 0 1.6 1.6 0 0 1-1.39-.49 2.23 2.23 0 0 1-.34-1.31v-5.7h-1.17v-1.18h1.17v-2.41zM78.86 20.03h1.37v11.91h-1.37zM84.3 20.03h1.37v11.91H84.3zM89.76 20.03h1.37v11.91h-1.37zM95.22 20.03h1.37v11.91h-1.37zM112.46 20.03h1.37v11.91h-1.37zM72.66 20.2h1.22l-3.71 11.74h.04l3.85-11.91h-1.44l-3.85 11.91h.18l3.71-11.74z"}}),_c('path',{attrs:{"d":"M72.66 20.2l-3.71 11.74h1.22l3.71-11.74h-1.22zM106.26 20.2h1.21l-3.71 11.74h.03l3.85-11.91h-1.44l-3.85 11.91h.2l3.71-11.74z"}}),_c('path',{attrs:{"d":"M106.26 20.2l-3.71 11.74h1.21l3.71-11.74h-1.21z"}}),_c('text',{attrs:{"transform":"translate(16.24 11.98)","font-size":"14","font-family":"Muli-Light, Muli"}},[_v("designed by")])])])}}};

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 184.15 38.01"}},[_c('title',[_v("mobile_logo2")]),_c('g',{attrs:{"data-name":"Layer 2","fill":"#565656"}},[_c('text',{attrs:{"transform":"translate(47.51 11.98)","font-size":"14","font-family":"Muli-Light, Muli"}},[_v("supported by")]),_c('text',{attrs:{"transform":"translate(0 33.08)","font-size":"16","font-family":"Muli-SemiBold, Muli","font-weight":"700"}},[_v("Google News Inititative")])])])}}};

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-screen"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("BUILDING ")]),_vm._v(" "),_c('transition',{attrs:{"name":"title"}},_vm._l((_vm.stoneStates),function(state,index){return (index === _vm.stoneShapeIndex)?_c('div',{key:index,staticClass:"changing",style:({color: '#' + state.color.toString(16)})},[_c('span',[_vm._v("HOPES")])]):_vm._e()}))],1),_vm._v(" "),_c('canvas',{ref:"threeCanvas",staticClass:"three-canvas",class:{'canvas-clickable': _vm.stoneMorphComplete},on:{"click":_vm.onStoneClick}}),_vm._v(" "),_c('transition',[(_vm.stoneMorphComplete)?_c('el-button',{staticClass:"start-btn",style:({color: '#' + _vm.stoneStates[_vm.stoneShapeIndex].color.toString(16)}),on:{"click":function($event){_vm.$emit('update:mode', 'wheel')}}},[_vm._v("START")]):_c('el-button',{staticClass:"loading-text"},[_vm._v("LOADING...")])],1),_vm._v(" "),_c('transition',[(_vm.stoneMorphComplete)?_c('div',{staticClass:"desktop-ctas"},[_c('p',[_vm._v(" Take this to a whole different level!"),_c('br'),_vm._v("Download the immersive AR app")]),_vm._v(" "),_c('div',{staticClass:"download-container",on:{"mouseleave":_vm.onMouseLeave,"mouseenter":_vm.onMouseEnter}},[_c('transition',{attrs:{"mode":"out-in","name":"download-animation"}},[(!_vm.showDownload)?_c('DownloadIcon',{staticClass:"download-icon"}):_c('div',{staticClass:"hidden-button"},[_c('a',{staticClass:"google-play",attrs:{"href":"https://play.google.com/store/apps/details?id=it.accurat.BuildingHopesM","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(169)}})]),_vm._v(" "),_c('a',{staticClass:"app-store",attrs:{"href":"https://itunes.apple.com/app/building-hopes/id1424884572?ls=1&mt=8","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(170)}})])])],1)],1)]):_vm._e()]),_vm._v(" "),_c('h2',{staticClass:"logo-desktop"},[_c('AccuratLogo',{staticClass:"accurat-logo"}),_vm._v(" "),_c('span',{staticClass:"sep"}),_vm._v(" "),_c('GoogleLogo',{staticClass:"google-logo"})],1),_vm._v(" "),_c('h2',{staticClass:"logo-mobile"},[_c('AccuratLogoMobile',{staticClass:"accurat-logo"}),_vm._v(" "),_c('span',{staticClass:"sep"}),_vm._v(" "),_c('GoogleLogoMobile',{staticClass:"google-logo"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptImportanceUI_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29809d01_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptImportanceUI_vue__ = __webpack_require__(977);
function injectStyle (ssrContext) {
  __webpack_require__(975)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29809d01"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptImportanceUI_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29809d01_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptImportanceUI_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 975:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_ConceptsSelectionWheel__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Viewport__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_delay__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_delay__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConceptImportanceUI',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Viewport__["a" /* default */]],
  components: {
    ConceptsSelectionWheel: __WEBPACK_IMPORTED_MODULE_0__molecules_ConceptsSelectionWheel__["a" /* default */],
    ElButton: __WEBPACK_IMPORTED_MODULE_2_element_ui_packages_button__["a" /* default */]
  },
  data: function data() {
    return {
      intro: true,
      definitions: ['A LITTLE', 'DEFINITELY', 'UNCONDITIONALLY']
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.introDelay = __WEBPACK_IMPORTED_MODULE_3_lodash_delay___default()(function () {
      _this.intro = false;
    }, 4000);
  },
  watch: {
    'confirmingConcept.importance': function confirmingConceptImportance(value) {
      this.intro = false;
    }
  },
  computed: {
    importanceDefinition: function importanceDefinition() {
      var index = Math.round((this.definitions.length - 1) * this.confirmingConcept.importance);
      return this.definitions[index];
    }
  },
  props: {
    confirmingConcept: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"importance-selection"},[_c('div',{staticClass:"title"},[_c('em',[_vm._v("HOW HOPEFUL I FEEL FOR")]),_c('em',{style:({color: '#' + _vm.confirmingConcept.categoryObject.color.toString(16)})},[_vm._v(_vm._s(_vm.confirmingConcept.label))])]),_vm._v(" "),_c('div',{staticClass:"left-side"},[_c('transition',[(_vm.intro)?_c('div',{staticClass:"desktop-intro"},[_vm._v("\n          HOW HOPEFUL"),_c('br'),_vm._v("ARE YOU?\n        ")]):_vm._e()]),_vm._v(" "),_c('transition',[(!_vm.intro)?_c('div',{staticClass:"desktop-instructions"},[_vm._v("\n          I FEEL"),_c('br'),_c('em',[_vm._v(_vm._s(_vm.importanceDefinition))]),_c('br'),_vm._v("HOPEFUL\n        ")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"definition"},[_vm._v(_vm._s(_vm.importanceDefinition)+" HOPEFUL")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"importance-confirm-btns"},[_c('el-button',{staticClass:"cancel-btn secondary",on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("remove")]),_vm._v(" "),_c('el-button',{staticClass:"confirm-btn",on:{"click":function($event){_vm.$emit('confirm')}}},[_vm._v("CHOOSE")])],1)]),_vm._v(" "),_c('div',{staticClass:"importance-confirm-btns mobile"},[_c('el-button',{staticClass:"cancel-btn secondary",on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("remove")]),_vm._v(" "),_c('el-button',{staticClass:"confirm-btn",on:{"click":function($event){_vm.$emit('confirm')}}},[_vm._v("CHOOSE")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"track-container"},[_c('div',{staticClass:"minus el-icon-minus"}),_vm._v(" "),_c('div',{staticClass:"track"}),_vm._v(" "),_c('div',{staticClass:"plus el-icon-plus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee844fee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__(985);
function injectStyle (ssrContext) {
  __webpack_require__(979)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee844fee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee844fee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 979:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_about_1_svg__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_about_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_about_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_about_2_svg__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_about_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_about_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_about_3_svg__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_about_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_about_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_about_4_svg__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_about_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_about_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_about_5_svg__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_about_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_about_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_dx_svg__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_dx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_dx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_arrow_sx_svg__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_arrow_sx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_arrow_sx_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AboutPage',

  components: {
    About1: __WEBPACK_IMPORTED_MODULE_0__assets_img_about_1_svg___default.a,
    About2: __WEBPACK_IMPORTED_MODULE_1__assets_img_about_2_svg___default.a,
    About3: __WEBPACK_IMPORTED_MODULE_2__assets_img_about_3_svg___default.a,
    About4: __WEBPACK_IMPORTED_MODULE_3__assets_img_about_4_svg___default.a,
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_4__assets_img_about_5_svg___default.a,
    ArrowDx: __WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_dx_svg___default.a,
    ArrowSx: __WEBPACK_IMPORTED_MODULE_6__assets_img_arrow_sx_svg___default.a
  },

  data: function data() {
    return {
      currentIndex: 1
    };
  },


  methods: {
    nextSlide: function nextSlide() {
      var _this = this;

      this.$refs.grid.scrollTop = 0;

      if (this.currentIndex === 3) {
        this.currentIndex = 0;
      }

      this.currentIndex += 1;

      setTimeout(function () {
        _this.$refs['slide-' + _this.currentIndex].click();
      }, 100);
    },
    prevSlide: function prevSlide() {
      var _this2 = this;

      this.$refs.grid.scrollTop = 0;

      if (this.currentIndex === 1) {
        this.currentIndex = 4;
      }

      this.currentIndex -= 1;

      setTimeout(function () {
        _this2.$refs['slide-' + _this2.currentIndex].click();
      }, 100);
    },
    setIndex: function setIndex(index) {
      this.currentIndex = index;
    }
  }
});

/***/ }),

/***/ 981:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 135.19 62.94"}},[_c('title',[_v("about_1")]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Livello 4"}},[_c('path',{attrs:{"d":"M12.91 45L95 60.32a31.23 31.23 0 0 1-9.18-6.24c-6.1-5.81-11.8-13.67-12-21.47s2.51-14 8.32-20.14a66 66 0 0 1 8.17-7.55L13.56 21.49c2.78.39 6.06 1.48 7.84 3.17 2.33 2.22 2.27 5.95 2.34 8.93a10.83 10.83 0 0 1-2.84 8.14A10.91 10.91 0 0 1 12.91 45z","fill":"#f2f2f2"}}),_c('path',{attrs:{"d":"M5.09 41.8C2.75 39.58.58 36.57.5 33.59a10.2 10.2 0 0 1 3.18-7.69c2.22-2.33 4.52-4.5 7.5-4.57s7.89 1.11 10.22 3.33 2.27 5.95 2.34 8.93a10.83 10.83 0 0 1-2.84 8.14 10.91 10.91 0 0 1-8 3.26 10.49 10.49 0 0 1-7.81-3.19zM85.84 54.08c-6.1-5.81-11.8-13.67-12-21.47s2.51-14 8.32-20.14S94 .7 101.8.51s20.64 2.91 26.74 8.72 6 15.58 6.14 23.38-1.65 15.2-7.45 21.3-13.11 8.33-20.91 8.52-14.38-2.54-20.48-8.35z","fill":"none"}}),_c('path',{attrs:{"d":"M.76 35.4s2.13 3.06 5.57 2.35c1.63-.34 13.46-4.21 15-5.45a5.39 5.39 0 0 0 2.18-3","fill":"none","stroke":"#c6c6c6","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M5.09 41.8C2.75 39.58.58 36.57.5 33.59a10.2 10.2 0 0 1 3.18-7.69c2.22-2.33 4.52-4.5 7.5-4.57s7.89 1.11 10.22 3.33 2.27 5.95 2.34 8.93a10.83 10.83 0 0 1-2.84 8.14 10.91 10.91 0 0 1-8 3.26 10.49 10.49 0 0 1-7.81-3.19z","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M74.52 37.34s5.57 8 14.59 6.14c4.24-.88 35.23-11 39.2-14.25 4.4-3.57 5.15-5.92 5.7-7.74","fill":"none","stroke":"#c6c6c6","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M85.84 54.08c-6.1-5.81-11.8-13.67-12-21.47s2.51-14 8.32-20.14S94 .7 101.8.51s20.64 2.91 26.74 8.72 6 15.58 6.14 23.38-1.65 15.2-7.45 21.3-13.11 8.33-20.91 8.52-14.38-2.54-20.48-8.35z","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}})])])])}}};

/***/ }),

/***/ 982:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100.97 73.74"}},[_c('title',[_v("about_2")]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Livello 4","fill":"none","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M.57 52.25S12 62.56 51.91 50.85c15.19-4.46 27.42-4.35 37.48-16.13 5.14-6 7.38-12.12 6.71-15.4","stroke":"#6f6f6e"}}),_c('path',{attrs:{"d":"M4.31 62.62s11.58 10.78 51.47-.89C71 57.28 83.24 57.52 93.2 45.46c5.26-6.35 7.42-12.85 6.49-16.16M2.2 43s11.87 11 49.2-1.67C65.62 36.5 77.37 36.57 86 24c4.59-6.69 4.78-12.4 2.82-15.16","stroke":"#6f6f6e"}}),_c('path',{attrs:{"d":"M5.76 35.46s4 5.22 39.94-5.4c13.68-4 24.6-4.25 33.87-14.21 4.68-5 5.57-9.3 4.29-11.51","stroke":"#6f6f6e"}}),_c('path',{attrs:{"d":"M98.91 26.23c2 6.24 2.88 15.09-2.33 22S82 66.14 68.43 70.43s-31.33 2.73-43.85 1.42S3 63.58 1 57.33c-1.49-4.69.66-14.84 3.81-20.19C10 28.22 17.11 11.07 34 5.7 45.58 2 60.85 1.16 71 .53c13.63-.83 24.06 13.59 27.91 25.7z","stroke":"#c6c6c6"}})])])])}}};

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96.59 70.04"}},[_c('title',[_v("about_3")]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Livello 4"}},[_c('path',{attrs:{"d":"M15.36 61.42c8.57 3.29 20.17 5.31 32.93 5.31a112.76 112.76 0 0 0 15.88-1.09","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"#6f6f6e","d":"M61.33 70.04l-.76-.65 3.21-3.74-3.96-2.93.59-.8 4.83 3.57-3.91 4.55z"}}),_c('path',{attrs:{"d":"M2.7 41.64a9.39 9.39 0 0 0-2.2 5.81c0 4.3 3.49 8.27 9.39 11.48","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"#6f6f6e","d":"M5 60.76l-.22-.97 4.81-1.09-1.44-4.72.96-.29 1.75 5.75L5 60.76z"}}),_c('path',{attrs:{"d":"M17.48 32.71a42.71 42.71 0 0 0-10.64 5.13","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"#6f6f6e","d":"M7.41 32.65l.97.24-1.18 4.78 4.86.84-.17.98-5.92-1.01 1.44-5.83z"}}),_c('path',{attrs:{"d":"M88.16 36.81a46.49 46.49 0 0 0-9.55-4.27","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M20 18.36s.43 8.8 9.11 11.69c4.09 1.35 35.93 8.4 41.06 7.83 5.65-.63 7.56-2.08 9-3.21","fill":"none","stroke":"#c6c6c6","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M86.29 59.15c6.15-3.25 9.8-7.3 9.8-11.7a10.15 10.15 0 0 0-3.31-7.06M71.56 64.3a69.57 69.57 0 0 0 8.76-2.54","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M29.6 49c-6.19-5.25-12-12.37-12.17-19.43S20 16.85 25.87 11.33 37.88.68 45.8.51 66.74 3.15 72.93 8.4s6 14.09 6.23 21.15-1.68 13.75-7.57 19.27-13.3 7.54-21.21 7.71A29.73 29.73 0 0 1 29.6 49z","fill":"none","stroke":"#c6c6c6","stroke-miterlimit":"10"}})])])])}}};

/***/ }),

/***/ 984:
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96.92 102.79"}},[_c('title',[_v("about_4")]),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Livello 4"}},[_c('path',{attrs:{"d":"M20 18.36s.43 8.8 9.11 11.69c4.09 1.35 35.93 8.4 41.05 7.83 5.66-.63 7.57-2.08 9-3.21","fill":"none","stroke":"#c6c6c6","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M71.56 64.3c14.63-3.3 24.53-9.61 24.53-16.85 0-6-6.81-11.37-17.48-14.91M17.48 32.71C7.09 36.24.5 41.54.5 47.45c0 10.65 21.4 19.28 47.79 19.28a112.76 112.76 0 0 0 15.88-1.09","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"#6f6f6e","d":"M61.33 70.04l-.76-.65 3.21-3.74-3.96-2.93.59-.8 4.83 3.57-3.91 4.55z"}}),_c('path',{attrs:{"d":"M29.6 49c-6.19-5.25-12-12.37-12.17-19.43S20 16.85 25.87 11.33 37.88.68 45.8.51 66.74 3.15 72.93 8.4s6 14.09 6.23 21.15-1.68 13.75-7.57 19.27-13.3 7.54-21.21 7.71A29.73 29.73 0 0 1 29.6 49z","fill":"none","stroke":"#c6c6c6","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M24.67 98.13a106.27 106.27 0 0 0 23.95 2.59c26.4 0 47.8-8.63 47.8-19.29 0-6-6.81-11.37-17.48-14.9","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"#6f6f6e","d":"M27.07 102.79l.82-.58-2.84-4.03 4.23-2.54-.51-.85-5.15 3.08 3.45 4.92z"}}),_c('path',{attrs:{"d":"M17.8 66.69C7.42 70.23.83 75.52.83 81.43S7.4 92.62 17.75 96.16","fill":"none","stroke":"#6f6f6e","stroke-miterlimit":"10"}})])])])}}};

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-page",attrs:{"data-block-interaction":""}},[_c('div',{ref:"grid",staticClass:"about-grid"},[_c('div',{staticClass:"about-column about-column-left"},[_c('div',{ref:"slide-1",staticClass:"about-slide slide-1",class:{ 'slide-hide-left': _vm.currentIndex === 3, 'slide-current': _vm.currentIndex === 1, 'slide-prev': _vm.currentIndex === 2, 'slide-next': _vm.currentIndex === 3 }},[_c('h3',{staticClass:"first"},[_vm._v("How to read it")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"about-images"},[_c('div',{staticClass:"about-image about-left"},[_c('About1',{staticClass:"img"}),_vm._v(" "),_vm._m(1,false,false)],1),_vm._v(" "),_c('div',{staticClass:"about-image about-right"},[_c('About2',{staticClass:"img"}),_vm._v(" "),_vm._m(2,false,false)],1),_vm._v(" "),_c('div',{staticClass:"about-image about-left about-last"},[_c('About3',{staticClass:"img"}),_vm._v(" "),_vm._m(3,false,false)],1),_vm._v(" "),_c('div',{staticClass:"about-image about-right about-last"},[_c('About4',{staticClass:"img"}),_vm._v(" "),_vm._m(4,false,false)],1)])]),_vm._v(" "),_c('div',{ref:"slide-2",staticClass:"about-slide slide-2",class:{ 'slide-current': _vm.currentIndex === 2, 'slide-prev': _vm.currentIndex === 3, 'slide-next': _vm.currentIndex === 1 }},[_c('h3',{staticClass:"mobile-first"},[_vm._v("The data")]),_vm._v(" "),_c('p',[_vm._v("We combine Google Trends with people’s hopes, creating a visualization centered on\n        rotating pebbles: their size is relevant to your own choices, but their rotation is\n        connected to the worldwide interest in that concept.")]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('h3',[_vm._v("What’s a Google trend?")]),_vm._v(" "),_vm._m(6,false,false),_vm._m(7,false,false)])]),_vm._v(" "),_c('div',{staticClass:"about-column about-column-right"},[_c('div',{ref:"slide-3",staticClass:"about-slide slide-3",class:{ 'slide-hide-right': _vm.currentIndex === 1, 'slide-current': _vm.currentIndex === 3, 'slide-next': _vm.currentIndex === 2 }},[_c('h3',{staticClass:"first"},[_vm._v("About the project")]),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_c('h3',[_vm._v("Time interval")]),_vm._v(" "),_c('p',[_vm._v("Currently showing searches for the last 2 years.")]),_vm._v(" "),_c('h3',[_vm._v("Credits")]),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_c('div',{staticClass:"box-app"},[_c('div',{staticClass:"box-left"},[_c('h3',[_vm._v("Try it in augmented reality")]),_vm._v(" "),_vm._m(10,false,false),_vm._v(" "),_c('DownloadIcon',{staticClass:"download-icon"})],1),_vm._v(" "),_vm._m(11,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"mobile-buttons"},[_c('transition',[(_vm.currentIndex > 1)?_c('span',{on:{"click":_vm.prevSlide}},[_c('ArrowSx',{staticClass:"arrow-icon arrow-left"}),_vm._v(" Prev")],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"indicator"},[_c('div',{staticClass:"indicator-icon icon-1",class:{'active': _vm.currentIndex === 1},on:{"click":function($event){_vm.setIndex(1)}}}),_vm._v(" "),_c('div',{staticClass:"indicator-icon icon-2",class:{'active': _vm.currentIndex === 2},on:{"click":function($event){_vm.setIndex(2)}}}),_vm._v(" "),_c('div',{staticClass:"indicator-icon icon-3",class:{'active': _vm.currentIndex === 3},on:{"click":function($event){_vm.setIndex(3)}}})]),_vm._v(" "),_c('transition',[(_vm.currentIndex < 3)?_c('span',{on:{"click":_vm.nextSlide}},[_c('ArrowDx',{staticClass:"arrow-icon arrow-right"}),_vm._v(" Next")],1):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your balancing sculpture is made of colorful rocks, one for each one of the themes you are hopeful for: "),_c('span',{staticClass:"color-1"},[_vm._v("Culture")]),_vm._v(", "),_c('span',{staticClass:"color-2"},[_vm._v("Education")]),_vm._v(", "),_c('span',{staticClass:"color-7"},[_vm._v("Technology")]),_vm._v(", "),_c('span',{staticClass:"color-3"},[_vm._v("Society")]),_vm._v(", "),_c('span',{staticClass:"color-5"},[_vm._v("Science")]),_vm._v(", "),_c('span',{staticClass:"color-6"},[_vm._v("Wellness")]),_vm._v(", "),_c('span',{staticClass:"color-4"},[_vm._v("Economy")]),_vm._v(", and "),_c('span',{staticClass:"color-8"},[_vm._v("Medicine")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Size")]),_vm._v(" shows how hopeful you feel.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Lines")]),_vm._v(" on rock show the number of hopes grouped by theme.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Rotation speed")]),_vm._v(" represents volume of searches on Google: faster rotation means higher search interest.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Rotation direction")]),_vm._v(" shows if the search trend is growing moving clockwise, or declining moving counter-clockwise.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("When your sculpture is exploded, you can see all your hopes stacked like small pebbles\n        on top of each other: you determined "),_c('strong',[_vm._v("the size of each pebble")]),_vm._v(" when you selected what\n        you are hopeful for and you can click on them to "),_c('strong',[_vm._v("explore Google Trends")]),_vm._v(" data on those\n        topics.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("A Google Trends index (0-100) represents the volume of searches performed on Google worldwide for a search term."),_c('br'),_vm._v("\n        The pebble spins to the right if the volume of searches is increasing, and to left if it’s declining."),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The top 6 locations in which the term was most popular during the past two years are displayed below the trend graph."),_c('br'),_vm._v(" "),_c('a',{staticClass:"underline",attrs:{"href":"https://newsinitiative.withgoogle.com/training/lesson/6507480104304640","target":"_blank"}},[_vm._v("Learn more about Google Trends.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("What are you hopeful for?"),_c('br'),_vm._v("Building Hopes lets you create physical structures in the world, sculptures made of balancing rocks that represent the ideas, concepts, movements you are hopeful for. You can choose up to ten ideas, concepts that can be “weighted” and turned into rocks big and small according to how much hope you have for them. Each rock represents a topic, and they are stacked to create a physical manifestation of your hopes, that you can place in a specific location around the world: “Hope Sculptures” for everyone else to discover and explore. The size and rotation of the rocks, their direction and speed are used to represent Google Trends’ data on the topics of your choice, revealing how people around the world are searching for these concepts or discovering what others are hopeful for, and how much."),_c('br'),_c('br'),_vm._v("\n        Building Hopes is an experimental data visualization app, imagined and created by Accurat with the support of Google News Initiative.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Design and software development by Accurat"),_c('br'),_vm._v("\n        Software development by MONOGRID"),_c('br'),_vm._v("\n        Created in collaboration with Google News Initiative")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Take this to a whole different level!"),_c('br'),_vm._v("\n            Download the immersive AR app")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-right"},[_c('a',{staticClass:"google-play",attrs:{"href":"https://play.google.com/store/apps/details?id=it.accurat.BuildingHopesM","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(169)}})]),_vm._v(" "),_c('a',{staticClass:"app-store",attrs:{"href":"https://itunes.apple.com/app/building-hopes/id1424884572?ls=1&mt=8","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(170)}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharePanel_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef28ce2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharePanel_vue__ = __webpack_require__(989);
function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ef28ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SharePanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef28ce2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SharePanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 987:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform__ = __webpack_require__(40);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SharePanel',
  components: {
    FacebookIcon: __WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg___default.a,
    TwitterIcon: __WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg___default.a,
    ElButton: __WEBPACK_IMPORTED_MODULE_2_element_ui_packages_button__["a" /* default */]
  },
  props: {
    openAlpha: {
      required: true,
      type: Number
    },

    totemData: {
      required: false,
      type: Object
    }
  },
  data: function data() {
    return {
      copiedLink: false
    };
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  computed: {
    imageUrl: function imageUrl() {
      return 'https://accurat-ghope.appspot.com/thumbnail/' + this.totemData.key;
    }
  },

  methods: {
    preventEvent: function preventEvent() {},

    copyShareableLink: function copyShareableLink() {
      var _this = this;

      var el = document.createElement('textarea');
      el.style.position = 'absolute';
      el.value = 'https://accurat-ghope.appspot.com/social/' + this.totemData.key;
      el.style.opacity = '0';

      el.addEventListener('click', function () {
        console.log(':D');
      });

      document.body.appendChild(el);
      el.focus();

      if (__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].ios) {
        var range = document.createRange();
        range.selectNodeContents(el);

        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);
      } else {
        el.select();
      }

      document.execCommand('copy');

      setTimeout(function () {
        document.body.removeChild(el);
        _this.copiedLink = true;
      }, 100);
    },
    share: function share(url) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 557;
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;

      var opts = 'width=' + width + ', height=' + height + ', scrollbars=0, ' + 'top=' + (window.innerHeight / 2 - height / 2) + ', ' + 'left=' + (window.innerWidth / 2 - width / 2);

      window.open(url, '_blank', opts);
    },
    onSocialClick: function onSocialClick(social) {
      var key = this.totemData.key;

      if (social === 'twitter') {
        var url = 'https://accurat-ghope.appspot.com/social/' + key;

        var path = 'https://twitter.com/intent/tweet?url=' + url;

        this.share(path);
      }

      if (social === 'facebook') {
        var _url = 'https://accurat-ghope.appspot.com/social/' + key;
        var _path = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(_url);

        this.share(_path);
      }
    }
  },

  watch: {}
});

/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-panel",attrs:{"data-block-interaction":_vm.openAlpha === 1 && !_vm.$root.platform.mobile ? '' : 'nope'},on:{"touchmove":function($event){$event.preventDefault();_vm.preventEvent($event)}}},[_c('div',{staticClass:"centered-stuff"},[_c('h1',[_vm._v("Share your hopes")]),_vm._v(" "),_c('div',{staticClass:"icons"},[_c('FacebookIcon',{staticClass:"icon",attrs:{"data-block-interaction":""},nativeOn:{"click":function($event){_vm.onSocialClick('facebook')}}}),_vm._v(" "),_c('TwitterIcon',{staticClass:"icon",attrs:{"data-block-interaction":""},nativeOn:{"click":function($event){_vm.onSocialClick('twitter')}}})],1),_vm._v(" "),_c('p',[_c('a',{attrs:{"data-block-interaction":"","href":_vm.imageUrl,"target":"_blank","download":"google-hope.jpg"}},[_vm._v("Download an image")]),_vm._v(" of your Hopes"),_c('br'),_vm._v("or "),_c('a',{attrs:{"data-block-interaction":""},on:{"click":_vm.copyShareableLink}},[_vm._v("get a shareable link")])]),_vm._v(" "),_c('el-button',{staticClass:"button",on:{"click":function($event){_vm.$emit('update:openAlpha', 0)}}},[_vm._v("BACK")]),_vm._v(" "),_c('transition',{attrs:{"appear":""}},[(_vm.copiedLink)?_c('div',{staticClass:"copied-link-message"},[_c('span',[_vm._v("Copied to your clipboard")])]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinalSharePanel_vue__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f33536cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinalSharePanel_vue__ = __webpack_require__(993);
function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f33536cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinalSharePanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f33536cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinalSharePanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 991:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_packages_button__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform__ = __webpack_require__(40);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FinalSharePanel',
  components: {
    FacebookIcon: __WEBPACK_IMPORTED_MODULE_0__assets_img_facebook_icon_svg___default.a,
    TwitterIcon: __WEBPACK_IMPORTED_MODULE_1__assets_img_twitter_icon_svg___default.a,
    ElButton: __WEBPACK_IMPORTED_MODULE_2_element_ui_packages_button__["a" /* default */]
  },
  props: {
    openAlpha: {
      required: true,
      type: Number
    },

    totemData: {
      required: false,
      type: Object
    }
  },
  data: function data() {
    return {
      copiedLink: false
    };
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  computed: {
    imageUrl: function imageUrl() {
      return 'https://accurat-ghope.appspot.com/thumbnail/' + this.totemData.key;
    }
  },

  methods: {
    onShareClick: function onShareClick() {
      this.$emit('share:open');
    },
    onKeepExploringClick: function onKeepExploringClick() {
      this.$emit('panel:close');
    },
    copyShareableLink: function copyShareableLink() {
      var _this = this;

      var el = document.createElement('textarea');
      el.style.position = 'absolute';
      el.value = 'https://accurat-ghope.appspot.com/social/' + this.totemData.key;
      el.style.opacity = '0';

      el.addEventListener('click', function () {
        console.log(':D');
      });

      document.body.appendChild(el);
      el.focus();

      if (__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* default */].ios) {
        var range = document.createRange();
        range.selectNodeContents(el);

        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);
      } else {
        el.select();
      }

      document.execCommand('copy');

      setTimeout(function () {
        document.body.removeChild(el);
        _this.copiedLink = true;
      }, 100);
    },


    preventEvent: function preventEvent() {},

    share: function share(url) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 557;
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;

      var opts = 'width=' + width + ', height=' + height + ', scrollbars=0, ' + 'top=' + (window.innerHeight / 2 - height / 2) + ', ' + 'left=' + (window.innerWidth / 2 - width / 2);

      window.open(url, '_blank', opts);
    },
    onSocialClick: function onSocialClick(social) {
      var key = this.totemData.key;

      if (social === 'twitter') {
        var url = 'https://accurat-ghope.appspot.com/social/' + key;

        var path = 'https://twitter.com/intent/tweet?url=' + url;

        this.share(path);
      }

      if (social === 'facebook') {
        var _url = 'https://accurat-ghope.appspot.com/social/' + key;
        var _path = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(_url);

        this.share(_path);
      }
    }
  },

  watch: {}
});

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-panel",attrs:{"data-block-interaction":_vm.openAlpha === 1 && !_vm.$root.platform.mobile ? '' : 'nope'},on:{"touchmove":function($event){$event.preventDefault();_vm.preventEvent($event)}}},[_c('div',{staticClass:"centered-stuff"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"icons"},[_c('FacebookIcon',{staticClass:"icon",attrs:{"data-block-interaction":""},nativeOn:{"click":function($event){_vm.onSocialClick('facebook')}}}),_vm._v(" "),_c('TwitterIcon',{staticClass:"icon",attrs:{"data-block-interaction":""},nativeOn:{"click":function($event){_vm.onSocialClick('twitter')}}})],1),_vm._v(" "),_c('p',{staticClass:"mobile-copy"},[_c('a',{attrs:{"data-block-interaction":"","href":_vm.imageUrl,"target":"_blank","download":""}},[_vm._v("Download an image")]),_vm._v(" of your Hopes"),_c('br'),_vm._v("or "),_c('a',{attrs:{"data-block-interaction":""},on:{"click":_vm.copyShareableLink}},[_vm._v("get a shareable link")])]),_vm._v(" "),_c('el-button',{staticClass:"btn-final btn-share",attrs:{"data-block-interaction":""},on:{"click":_vm.onShareClick}},[_vm._v("SHARE IT")]),_vm._v(" "),_c('el-button',{staticClass:"btn-final",attrs:{"data-block-interaction":""},on:{"click":_vm.onKeepExploringClick}},[_vm._v("KEEP EXPLORING")]),_vm._v(" "),_c('transition',{attrs:{"appear":""}},[(_vm.copiedLink)?_c('div',{staticClass:"copied-link-message"},[_c('span',[_vm._v("Copied to your clipboard")])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"desktop-copy"},[_vm._v("Now that you have"),_c('br'),_vm._v("created your hope"),_c('br'),_vm._v("sculpture...")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"mobile-copy"},[_vm._v("Now that you have created"),_c('br'),_vm._v(" your hopes culpture, share"),_c('br'),_vm._v(" your Hopes!")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderStonesContainer_vue__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f52e312_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderStonesContainer_vue__ = __webpack_require__(997);
function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f52e312"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderStonesContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f52e312_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderStonesContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 995:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(THREE) {//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global THREE */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderStonesContainer',

  components: {},
  data: function data() {
    return {};
  },
  props: {
    maxConcepts: {
      type: Number,
      default: 10
    },
    concepts: {
      type: Array,
      required: true
    }
  },

  methods: {
    getConceptStyle: function getConceptStyle(concept, index) {
      var opacity = 0.2;
      if (index < 4) {
        opacity = 0.5;
      }
      return {
        left: index * 100 / (this.maxConcepts - 1) + '%',
        opacity: opacity
      };
    },
    getHightlightStyle: function getHightlightStyle(concept) {
      var color = concept.categoryObject ? new THREE.Color(concept.categoryObject.color).getHexString() : null;
      return {
        borderColor: '#' + color
      };
    }
  },
  computed: {
    fakeConcepts: function fakeConcepts() {
      var ret = [];
      for (var i = 0; i < this.maxConcepts; i++) {
        if (this.concepts[i]) {
          ret.push(this.concepts[i]);
        } else {
          ret.push({ fake: true, confirmed: true });
        }
      }
      return ret;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stones-container"},_vm._l((_vm.fakeConcepts),function(concept,index){return (concept.fake || !concept.confirmed)?_c('div',{staticClass:"concept",style:(_vm.getConceptStyle(concept, index))},[_c('transition',[(!concept.confirmed)?_c('div',{staticClass:"hightlight"},[_c('div',{staticClass:"circle circle-1",style:(_vm.getHightlightStyle(concept))}),_vm._v(" "),_c('div',{staticClass:"circle circle-2",style:(_vm.getHightlightStyle(concept))}),_vm._v(" "),_c('div',{staticClass:"circle circle-3",style:(_vm.getHightlightStyle(concept))})]):_vm._e()])],1):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemDotsIndicator_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a4288c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemDotsIndicator_vue__ = __webpack_require__(1001);
function injectStyle (ssrContext) {
  __webpack_require__(999)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80a4288c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotemDotsIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a4288c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotemDotsIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 999:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[416]);


// WEBPACK FOOTER //
// static/js/app.8507fadebd2164e52424.js